(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mtob-client"] = factory();
	else
		root["mtob-client"] = factory();
})(self, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ([
/* 0 */,
/* 1 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.events = {};
    }
    EventEmitter.prototype.on = function (event, listener) {
        if (typeof this.events[event] !== 'object') {
            this.events[event] = [];
        }
        this.events[event] = this.events[event].concat([listener]);
        return {
            remove: this.removeListener.bind(this, event, listener),
        };
    };
    EventEmitter.prototype.once = function (event, listener) {
        var self = this;
        var fn = function fn() {
            listener.apply(null, arguments);
            self.removeListener(event, fn);
        };
        this.on(event, fn);
        return {
            remove: this.removeListener.bind(this, event, fn),
        };
    };
    EventEmitter.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        args = Array.prototype.slice.call(arguments, 1);
        if (!Array.isArray(this.events[event])) {
            this.events[event] = [];
        }
        this.events[event].forEach(function (listener) {
            listener.apply(null, args);
        });
    };
    EventEmitter.prototype.removeListener = function (event, listener) {
        if (!this.events[event]) {
            return;
        }
        this.events[event] = this.events[event].filter(function (fn) {
            return fn !== listener;
        });
    };
    EventEmitter.prototype.removeAllListeners = function (event) {
        if (event === null || event === undefined) {
            this.events = {};
        }
        else {
            this.events[event] = [];
        }
    };
    return EventEmitter;
}());
/* harmony default export */ __webpack_exports__["default"] = (EventEmitter);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvRXZlbnRFbWl0dGVyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQUE7UUFDVSxXQUFNLEdBQVEsRUFBRSxDQUFDO0lBMkQzQixDQUFDO0lBekRRLHlCQUFFLEdBQVQsVUFBVSxLQUFhLEVBQUUsUUFBa0I7UUFDekMsSUFBSSxPQUFPLElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLEtBQUssUUFBUSxFQUFFO1lBQzFDLElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLEdBQUcsRUFBRSxDQUFDO1NBQ3pCO1FBRUQsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUM7UUFFM0QsT0FBTztZQUNMLE1BQU0sRUFBRSxJQUFJLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUUsS0FBSyxFQUFFLFFBQVEsQ0FBQztTQUN4RCxDQUFDO0lBQ0osQ0FBQztJQUVNLDJCQUFJLEdBQVgsVUFBWSxLQUFhLEVBQUUsUUFBa0I7UUFDM0MsSUFBTSxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBRWxCLElBQU0sRUFBRSxHQUFHLFNBQVMsRUFBRTtZQUNwQixRQUFRLENBQUMsS0FBSyxDQUFDLElBQUksRUFBRSxTQUFTLENBQUMsQ0FBQztZQUVoQyxJQUFJLENBQUMsY0FBYyxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsQ0FBQztRQUNqQyxDQUFDLENBQUM7UUFFRixJQUFJLENBQUMsRUFBRSxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsQ0FBQztRQUVuQixPQUFPO1lBQ0wsTUFBTSxFQUFFLElBQUksQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxLQUFLLEVBQUUsRUFBRSxDQUFDO1NBQ2xELENBQUM7SUFDSixDQUFDO0lBRU0sMkJBQUksR0FBWCxVQUFZLEtBQWE7UUFBRSxjQUFZO2FBQVosVUFBWSxFQUFaLHFCQUFZLEVBQVosSUFBWTtZQUFaLDZCQUFZOztRQUNyQyxJQUFJLEdBQUcsS0FBSyxDQUFDLFNBQVMsQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLFNBQVMsRUFBRSxDQUFDLENBQUMsQ0FBQztRQUVoRCxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUU7WUFDdEMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsR0FBRyxFQUFFLENBQUM7U0FDekI7UUFFRCxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDLE9BQU8sQ0FBQyxVQUFTLFFBQWtCO1lBQ3BELFFBQVEsQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxDQUFDO1FBQzdCLENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVNLHFDQUFjLEdBQXJCLFVBQXNCLEtBQWEsRUFBRSxRQUFrQjtRQUNyRCxJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsRUFBRTtZQUN2QixPQUFPO1NBQ1I7UUFFRCxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxHQUFHLElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsTUFBTSxDQUFDLFVBQVMsRUFBWTtZQUNsRSxPQUFPLEVBQUUsS0FBSyxRQUFRLENBQUM7UUFDekIsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0lBRU0seUNBQWtCLEdBQXpCLFVBQTBCLEtBQWM7UUFDdEMsSUFBSSxLQUFLLEtBQUssSUFBSSxJQUFJLEtBQUssS0FBSyxTQUFTLEVBQUU7WUFDekMsSUFBSSxDQUFDLE1BQU0sR0FBRyxFQUFFLENBQUM7U0FDbEI7YUFBTTtZQUNMLElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLEdBQUcsRUFBRSxDQUFDO1NBQ3pCO0lBQ0gsQ0FBQztJQUNILG1CQUFDO0FBQUQsQ0FBQyxBQTVERCxJQTREQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGNsYXNzIEV2ZW50RW1pdHRlciB7XG4gIHByaXZhdGUgZXZlbnRzOiBhbnkgPSB7fTtcblxuICBwdWJsaWMgb24oZXZlbnQ6IHN0cmluZywgbGlzdGVuZXI6IEZ1bmN0aW9uKSB7XG4gICAgaWYgKHR5cGVvZiB0aGlzLmV2ZW50c1tldmVudF0gIT09ICdvYmplY3QnKSB7XG4gICAgICB0aGlzLmV2ZW50c1tldmVudF0gPSBbXTtcbiAgICB9XG5cbiAgICB0aGlzLmV2ZW50c1tldmVudF0gPSB0aGlzLmV2ZW50c1tldmVudF0uY29uY2F0KFtsaXN0ZW5lcl0pO1xuXG4gICAgcmV0dXJuIHtcbiAgICAgIHJlbW92ZTogdGhpcy5yZW1vdmVMaXN0ZW5lci5iaW5kKHRoaXMsIGV2ZW50LCBsaXN0ZW5lciksXG4gICAgfTtcbiAgfVxuXG4gIHB1YmxpYyBvbmNlKGV2ZW50OiBzdHJpbmcsIGxpc3RlbmVyOiBGdW5jdGlvbikge1xuICAgIGNvbnN0IHNlbGYgPSB0aGlzO1xuXG4gICAgY29uc3QgZm4gPSBmdW5jdGlvbiBmbigpIHtcbiAgICAgIGxpc3RlbmVyLmFwcGx5KG51bGwsIGFyZ3VtZW50cyk7XG5cbiAgICAgIHNlbGYucmVtb3ZlTGlzdGVuZXIoZXZlbnQsIGZuKTtcbiAgICB9O1xuXG4gICAgdGhpcy5vbihldmVudCwgZm4pO1xuXG4gICAgcmV0dXJuIHtcbiAgICAgIHJlbW92ZTogdGhpcy5yZW1vdmVMaXN0ZW5lci5iaW5kKHRoaXMsIGV2ZW50LCBmbiksXG4gICAgfTtcbiAgfVxuXG4gIHB1YmxpYyBlbWl0KGV2ZW50OiBzdHJpbmcsIC4uLmFyZ3M6IGFueSkge1xuICAgIGFyZ3MgPSBBcnJheS5wcm90b3R5cGUuc2xpY2UuY2FsbChhcmd1bWVudHMsIDEpO1xuXG4gICAgaWYgKCFBcnJheS5pc0FycmF5KHRoaXMuZXZlbnRzW2V2ZW50XSkpIHtcbiAgICAgIHRoaXMuZXZlbnRzW2V2ZW50XSA9IFtdO1xuICAgIH1cblxuICAgIHRoaXMuZXZlbnRzW2V2ZW50XS5mb3JFYWNoKGZ1bmN0aW9uKGxpc3RlbmVyOiBGdW5jdGlvbikge1xuICAgICAgbGlzdGVuZXIuYXBwbHkobnVsbCwgYXJncyk7XG4gICAgfSk7XG4gIH1cblxuICBwdWJsaWMgcmVtb3ZlTGlzdGVuZXIoZXZlbnQ6IHN0cmluZywgbGlzdGVuZXI6IEZ1bmN0aW9uKSB7XG4gICAgaWYgKCF0aGlzLmV2ZW50c1tldmVudF0pIHtcbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICB0aGlzLmV2ZW50c1tldmVudF0gPSB0aGlzLmV2ZW50c1tldmVudF0uZmlsdGVyKGZ1bmN0aW9uKGZuOiBGdW5jdGlvbikge1xuICAgICAgcmV0dXJuIGZuICE9PSBsaXN0ZW5lcjtcbiAgICB9KTtcbiAgfVxuXG4gIHB1YmxpYyByZW1vdmVBbGxMaXN0ZW5lcnMoZXZlbnQ/OiBzdHJpbmcpIHtcbiAgICBpZiAoZXZlbnQgPT09IG51bGwgfHwgZXZlbnQgPT09IHVuZGVmaW5lZCkge1xuICAgICAgdGhpcy5ldmVudHMgPSB7fTtcbiAgICB9IGVsc2Uge1xuICAgICAgdGhpcy5ldmVudHNbZXZlbnRdID0gW107XG4gICAgfVxuICB9XG59XG4iXX0=

/***/ }),
/* 2 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MTOBClient": function() { return /* binding */ MTOBClient; }
/* harmony export */ });
/* harmony import */ var socket_io_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var socket_io_client__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(socket_io_client__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_EventEmitter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _utils_uuid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9);
/* harmony import */ var _package_json__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};








var MTOB_SERVER_HOST_HTTP = 'http://localhost:';
var MTOB_SERVER_HOST_HTTPS = 'https://localhost:';
var LOCAL_SERVER_PORTS = [28613, 28713, 28813];
var MAX_POLLING_COUNT = 2;
var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // eslint-disable-next-line no-console
    console.log.apply(console, __spreadArray(['[MTOB-Client] '], args));
};
var MTOBClient = /** @class */ (function (_super) {
    __extends(MTOBClient, _super);
    function MTOBClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.status = _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.Disconnected;
        _this.requestID = (0,_utils_uuid__WEBPACK_IMPORTED_MODULE_2__.getUUID)();
        _this.requestVersion = '1.0';
        _this.failCount = 0;
        _this.retryIndex = 0;
        _this.autoConnect = true;
        _this.port = -1; // 当前连接端口
        _this.forceUpgrade = false;
        _this.requiredVersion = '';
        _this.minVersion = '';
        _this.connectedVersion = '';
        _this.clientUUID = '';
        _this.clientType = 'V2';
        _this.clientGlobalConfig = null;
        _this.options = {};
        _this.remoteConfig = null;
        _this.userConfig = null;
        return _this;
    }
    Object.defineProperty(MTOBClient.prototype, "isProd", {
        get: function () {
            var env = this.options && this.options.env;
            return env === 'production' || env === 'staging';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MTOBClient.prototype, "socketURI", {
        get: function () {
            var host = this.isProd ? MTOB_SERVER_HOST_HTTPS : MTOB_SERVER_HOST_HTTP;
            return "" + host + this.port;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MTOBClient.prototype, "downloadURL", {
        get: function () {
            var env = this.isProd ? 'prod' : 'test';
            return "https://portal-portm.meituan.com/klfe/mtob/" + env + "/downloadConfig";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MTOBClient.prototype, "requiredVersionDownloadURL", {
        get: function () {
            return this.downloadURL + '?version=' + this.requiredVersion;
        },
        enumerable: false,
        configurable: true
    });
    MTOBClient.prototype.init = function (options) {
        var _this = this;
        if (!options || !options.appName) {
            throw _constants__WEBPACK_IMPORTED_MODULE_5__.ClientError.CLIENT_OPTIONS_ERROR;
        }
        this.options = options || {};
        this.setConfig(this.options);
        _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.init({
            appName: this.options.appName,
            userId: this.options.userId,
            env: this.options.env,
            extraAppInfo: this.options.extraAppInfo,
        });
        this.updateUpgradeConfig().then(function () {
            log('updateUpgradeConfig res', {
                forceUpgrade: _this.forceUpgrade,
                requiredVersion: _this.requiredVersion,
                minVersion: _this.minVersion,
            });
        });
        this.connect();
    };
    MTOBClient.prototype.finish = function () {
        this.stopAutoReconnect();
    };
    MTOBClient.prototype.connect = function () {
        if (this.status === _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.Connected) {
            this.notifyConnected();
            return;
        }
        if (this.status === _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.Connecting ||
            this.status === _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.NeedUpdate) {
            return;
        }
        this.status = _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.Connecting;
        this.poll();
    };
    MTOBClient.prototype.poll = function () {
        var _this = this;
        if (!this.autoConnect) {
            return;
        }
        if (this.options.portNum && this.options.portNum > 0) {
            // 手动设置的端口号
            this.port = this.options.portNum;
        }
        else if (parseInt(localStorage.getItem('mtob_port') || '-1') > -1) {
            // 存储的端口号
            this.port = parseInt(localStorage.getItem('mtob_port'));
        }
        else {
            this.port = LOCAL_SERVER_PORTS[this.retryIndex];
            this.retryIndex = (this.retryIndex + 1) % LOCAL_SERVER_PORTS.length;
        }
        log('trying to connect port: ', this.port);
        this.manager = new (socket_io_client__WEBPACK_IMPORTED_MODULE_0___default().Manager)(this.socketURI, {
            reconnection: false,
            rejectUnauthorized: false,
        });
        this.socket = this.manager.socket('/');
        this.manager.connect();
        this.manager.on('error', function () { return _this.onSocketConnectionError(); });
        this.socket.on('connect', function () { return _this.onSocketConnected(); });
        this.socket.on('disconnect', function (reason) {
            return _this.onSocketDisconnected(reason);
        });
    };
    MTOBClient.prototype.onSocketConnectionError = function () {
        var _this = this;
        this.socket.close();
        this.socket.removeAllListeners();
        this.manager._close();
        this.failCount++;
        // 所有端口尝试一轮均失败后，如果autoLaunch则尝试唤起，否则提示连接超时
        if (this.failCount == LOCAL_SERVER_PORTS.length) {
            if (this.options.autoLaunch === false) {
                this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents.StatusChange, { status: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus.ERROR });
                this.showDownloadAlert();
            }
            else {
                this.launchMTOB();
            }
        }
        // 失败MAX_POLLING_COUNT轮后，提示连接超时
        if (this.failCount === LOCAL_SERVER_PORTS.length * MAX_POLLING_COUNT) {
            // autoLaunch === false 情况下，端口尝试一轮均失败后会有一次提示，这里不再提示
            if (this.options.autoLaunch !== false) {
                this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents.StatusChange, { status: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus.ERROR });
                this.showDownloadAlert();
            }
        }
        setTimeout(function () { return _this.poll(); }, 2000);
    };
    MTOBClient.prototype.onSocketConnected = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log('connected: ', this.port);
                        return [4 /*yield*/, this.authenticate(this.socket.id).catch(function (error) {
                                log('authenticate error: ', error);
                                _this.socket.close();
                            })];
                    case 1:
                        _a.sent();
                        this.getClientInfo();
                        return [2 /*return*/];
                }
            });
        });
    };
    MTOBClient.prototype.onSocketDisconnected = function (reason) {
        log('disconnected: ', this.port, reason);
        this.socket.close();
        this.socket.removeAllListeners();
        this.connectedVersion = '';
        this.status = _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.Disconnected;
        this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.MTOB_CLIENT_EVENT.DISCONNECT);
        this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents.StatusChange, { status: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus.DISCONNECTED });
        this.connect();
    };
    MTOBClient.prototype.setConfig = function (options) {
        this.options = __assign(__assign({}, (this.options || {})), (options || {}));
        log('setConfig: ', this.options);
        this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.MTOB_CLIENT_EVENT.OPTIONS_UPDATE, this.options, this.userConfig);
        if (options.portNum) {
            localStorage.setItem('mtob_port', options.portNum === -1 ? '' : "" + options.portNum);
            if (this.port !== options.portNum) {
                this.socket.close();
                this.connect();
            }
        }
    };
    MTOBClient.prototype.launchMTOB = function () {
        var uri = 'mtob' + this.requiredVersion + '://home?from=web';
        try {
            window.location.href = uri;
        }
        catch (_a) {
            log("MTOB launch failed: " + uri);
            _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logWarning('MTOB launch failed', { uri: uri });
        }
    };
    MTOBClient.prototype.getMTOBInfo = function () {
        return {
            status: this.status,
            requiredMTOBVersion: this.requiredVersion,
            currentMTOBVersion: this.connectedVersion,
            downloadURL: this.downloadURL,
            requiredVersionDownloadURL: this.requiredVersionDownloadURL,
            clientType: this.clientType,
        };
    };
    MTOBClient.prototype.getGlobalConfig = function () {
        var _this = this;
        if (this.clientType !== 'V2') {
            return Promise.resolve(null);
        }
        return this.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.GET_GLOBAL_CONFIG)
            .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var cmd, requestID, status, code, data;
            return __generator(this, function (_a) {
                log('get V2 global config: ', res);
                cmd = res.cmd, requestID = res.requestID, status = res.status, code = res.code, data = __rest(res, ["cmd", "requestID", "status", "code"]);
                this.clientGlobalConfig = data;
                return [2 /*return*/, data];
            });
        }); })
            .catch(function (err) {
            log('get V2 global config error: ', err);
            _this.clientGlobalConfig = null;
            return null;
        });
    };
    MTOBClient.prototype.setGlobalConfig = function (config) {
        var _this = this;
        if (this.clientType !== 'V2') {
            return Promise.resolve();
        }
        return this.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.SET_GLOBAL_CONFIG, __assign(__assign({ pendingTaskLimit: 500, printHistorySaveHours: 12, notifyOnTaskFailure: true }, (this.clientGlobalConfig || {})), (config || {})))
            .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                log('set V2 global config: ', res);
                this.getGlobalConfig();
                return [2 /*return*/];
            });
        }); })
            .catch(function (err) {
            log('set V2 global config error: ', err);
            _this.getGlobalConfig();
        });
    };
    MTOBClient.prototype.setCatLogger = function (instance) {
        _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.setLogger(instance);
    };
    MTOBClient.prototype.ipc = function (action, data, callback) {
        if (!this.socket ||
            !this.socket.token ||
            this.socket.disconnected ||
            this.status === _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.Disconnected) {
            _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logWarning('[V1] API Call Reject Server Connection Failed');
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents.StatusChange, { status: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus.ERROR });
            return;
        }
        if (this.status === _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.NeedUpdate) {
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents.StatusChange, {
                status: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus.MTOB_UPDATE_REQUIRED,
            });
            _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logWarning('[V1] API Call Reject Server Update Required');
            return;
        }
        _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logInfo('[V1] API Request', { action: action });
        var startTime = new Date().getTime();
        this.socket.emit('MTOB_MSG', {
            action: action,
            data: data,
            token: this.socket.token,
        }, function (res) {
            if (!res.statusCode) {
                _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logInfo('[V1] API Response Failed', {
                    action: action,
                    params: data,
                    res: res,
                    delay: new Date().getTime() - startTime,
                });
            }
            else {
                _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logInfo('[V1] API Response Success', {
                    action: action,
                    params: action !== 'printer/print' ? data : undefined,
                    res: res,
                    delay: new Date().getTime() - startTime,
                });
            }
            callback && callback(res);
        });
    };
    MTOBClient.prototype.ipcOn = function (event, callback) {
        if (!this.socket ||
            this.socket.disconnected ||
            this.status === _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.Disconnected) {
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents.StatusChange, { status: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus.ERROR });
            return;
        }
        this.socket.on(event, callback);
    };
    MTOBClient.prototype.ipcOff = function (event) {
        if (!this.socket)
            return;
        this.socket.off(event);
    };
    MTOBClient.prototype.reuqest = function (cmd, params) {
        var _this = this;
        if (!this.socket ||
            !this.socket.token ||
            this.socket.disconnected ||
            this.status === _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.Disconnected) {
            _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logWarning('API Call Reject Server Connection Failed');
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents.StatusChange, { status: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus.ERROR });
            return Promise.reject();
        }
        if (this.status === _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.NeedUpdate) {
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents.StatusChange, {
                status: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus.MTOB_UPDATE_REQUIRED,
            });
            _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logWarning('API Call Reject Server Update Required');
            return Promise.reject();
        }
        _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logInfo('API Request', { cmd: cmd });
        var startTime = new Date().getTime();
        return new Promise(function (resolve, reject) {
            _this.socket.send(__assign({ cmd: cmd, requestID: (0,_utils_uuid__WEBPACK_IMPORTED_MODULE_2__.getUUID)(), version: _this.requestVersion }, (params || {})), function (res) {
                if (res && res.status === 'success') {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logInfo('API Response Success', {
                        cmd: cmd,
                        params: cmd !== 'print' ? params : undefined,
                        res: res,
                        delay: new Date().getTime() - startTime,
                    });
                    resolve(res);
                }
                else {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logInfo('API Response Failed', {
                        cmd: cmd,
                        params: params,
                        res: res,
                        delay: new Date().getTime() - startTime,
                    });
                    reject(res);
                }
            });
        });
    };
    MTOBClient.prototype.stopAutoReconnect = function () {
        this.autoConnect = false;
    };
    MTOBClient.prototype.notifyConnected = function () {
        this.status = _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.Connected;
        this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.MTOB_CLIENT_EVENT.CONNECT, this.clientType, this.options);
        this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents.StatusChange, { status: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus.READY });
    };
    // 鉴权
    MTOBClient.prototype.authenticate = function (socketId) {
        var _this = this;
        return fetch(this.socketURI + _api__WEBPACK_IMPORTED_MODULE_6__.default.AUTHENTICATE + '?socketId=' + socketId)
            .then(function (res) { return res.json(); })
            .then(function (res) {
            log('authenticate res: ', res);
            _this.socket.token = res.token;
            _this.clientType = res.V2 ? 'V2' : 'V1';
            if (res === null || res === void 0 ? void 0 : res.token) {
                _this.clientUUID = res.token;
                _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.setUUID(_this.clientUUID);
            }
            if (res === null || res === void 0 ? void 0 : res.version) {
                _this.connectedVersion = res.version;
                _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.setClientVersion(_this.connectedVersion);
            }
        });
    };
    MTOBClient.prototype.getClientInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.clientType === 'V2')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getClientInfoV2()];
                    case 1:
                        _a.sent();
                        this.getGlobalConfig();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.getClientInfoV1()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MTOBClient.prototype.getClientInfoV1 = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.ipc(_api__WEBPACK_IMPORTED_MODULE_6__.default.SERVER_GETINFO, null, function (res) { return __awaiter(_this, void 0, void 0, function () {
                var _a, uuid, version;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            log('get V1 info: ', res);
                            _a = res || {}, uuid = _a.uuid, version = _a.version;
                            if (uuid) {
                                this.clientUUID = uuid;
                                _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.setUUID(uuid);
                            }
                            if (version) {
                                this.connectedVersion = version;
                                _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.setClientVersion(version);
                            }
                            this.notifyConnected();
                            return [4 /*yield*/, this.updateUpgradeConfig()];
                        case 1:
                            _b.sent();
                            this.checkUpgrade();
                            resolve();
                            return [2 /*return*/];
                    }
                });
            }); });
        });
    };
    MTOBClient.prototype.getClientInfoV2 = function () {
        var _this = this;
        return this.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.GET_AGENT_INFO)
            .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var _a, uuid, version;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        log('get V2 info: ', res);
                        _a = res || {}, uuid = _a.uuid, version = _a.version;
                        if (uuid) {
                            this.clientUUID = uuid;
                            _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.setUUID(uuid);
                        }
                        if (version) {
                            this.connectedVersion = version;
                            _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.setClientVersion(version);
                        }
                        this.notifyConnected();
                        return [4 /*yield*/, this.updateUpgradeConfig()];
                    case 1:
                        _b.sent();
                        this.checkUpgrade();
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log('get V2 info error 1: ', err);
                        this.notifyConnected();
                        return [4 /*yield*/, this.updateUpgradeConfig()];
                    case 1:
                        _a.sent();
                        this.checkUpgrade();
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function (err) {
            log('get V2 info error 2: ', err);
        });
    };
    MTOBClient.prototype.upgrade = function () {
        this.showUpdateAlert();
        if (this.connectedVersion && +this.connectedVersion.split('.')[0] >= 3) {
            this.checkoutForUpdate({
                extraRequestParams: {
                    appName: this.options.appName,
                    userId: this.options.userId,
                },
            });
        }
        else if (this.clientType === 'V2') {
            this.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.UPGRADE, {
                version: this.requiredVersion,
                targetVersion: this.requiredVersion,
            });
        }
        else {
            this.ipc(_api__WEBPACK_IMPORTED_MODULE_6__.default.SERVER_UPDATE, {
                targetVersion: this.requiredVersion,
            });
        }
        _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logInfo('Upgrade', {
            requiredVersion: this.requiredVersion,
        });
    };
    MTOBClient.prototype.checkoutForUpdate = function (options) {
        return this.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.CHECK_FOR_UPDATE, options);
    };
    MTOBClient.prototype.getUpdateInfo = function (options) {
        var _this = this;
        return this.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.GET_UPDATE_INFO, options)
            .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var versionInfo;
            return __generator(this, function (_a) {
                log('get 3.0 upgrade info: ', res);
                versionInfo = res.versionInfo;
                return [2 /*return*/, versionInfo];
            });
        }); })
            .catch(function (err) {
            log('get 3.0 upgrade info error: ', err);
            return null;
        });
    };
    /**
     * 获取并解析远程配置
     * 说明: 配置不是每次调用实时更新, 每个 Client 实例只获取一次
     * 配置环境: test、prod
     * 配置参考: examples/config.remote.json
     */
    MTOBClient.prototype.getRemoteConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var v, url, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        v = _package_json__WEBPACK_IMPORTED_MODULE_7__.version.split('-')[0];
                        url = "https://portal-portm.meituan.com/klfe/mtob/" + (this.isProd ? 'prod' : 'test') + "/clientSDKConfig";
                        if (!!this.remoteConfig) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, fetch(url)
                                .then(function (response) { return response.json(); })
                                .then(function (data) {
                                if (data === void 0) { data = {}; }
                                return (__assign(__assign({}, (data.common || {})), (data[v] || {})));
                            })
                                .catch(function () { return null; })];
                    case 1:
                        _a.remoteConfig = _b.sent();
                        _b.label = 2;
                    case 2:
                        log('remote config: ', this.remoteConfig);
                        return [2 /*return*/];
                }
            });
        });
    };
    MTOBClient.prototype.updateUpgradeConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var info, config, _a, appName, userId, appConfig, version, userIdReg, clientUUIDReg, forceUpgrade, requiredVersion, minVersion, reg, reg;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.connectedVersion && +this.connectedVersion.split('.')[0] >= 3)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getUpdateInfo({
                                extraRequestParams: {
                                    appName: this.options.appName,
                                    userId: this.options.userId,
                                },
                            })];
                    case 1:
                        info = _b.sent();
                        if (info) {
                            this.requiredVersion = info.versionname;
                            this.forceUpgrade = !!info.forceupdate;
                        }
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, this.getRemoteConfig()];
                    case 3:
                        _b.sent();
                        config = this.remoteConfig;
                        if (!config) {
                            return [2 /*return*/];
                        }
                        _a = this.options, appName = _a.appName, userId = _a.userId;
                        // 用户级别配置
                        if (userId && config[userId]) {
                            this.userConfig = config[userId];
                            this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.MTOB_CLIENT_EVENT.OPTIONS_UPDATE, this.options, this.userConfig);
                        }
                        this.forceUpgrade =
                            config.forceUpgrade != null ? config.forceUpgrade : this.forceUpgrade;
                        this.requiredVersion = config.requiredVersion || this.requiredVersion;
                        this.minVersion = config.minVersion || this.minVersion;
                        appConfig = appName && config[appName];
                        if (!appConfig) {
                            return [2 /*return*/];
                        }
                        version = appConfig.version, userIdReg = appConfig.userIdReg, clientUUIDReg = appConfig.clientUUIDReg, forceUpgrade = appConfig.forceUpgrade, requiredVersion = appConfig.requiredVersion, minVersion = appConfig.minVersion;
                        if (requiredVersion) {
                            this.forceUpgrade = !!forceUpgrade;
                            this.requiredVersion = requiredVersion;
                        }
                        if (minVersion) {
                            this.minVersion = minVersion;
                        }
                        // 按照uuid精确配置的版本
                        if (this.clientUUID && appConfig[this.clientUUID]) {
                            this.forceUpgrade = true;
                            this.requiredVersion = appConfig[this.clientUUID];
                            return [2 /*return*/];
                        }
                        // 按照userId精确配置的版本
                        if (userId && appConfig[userId]) {
                            this.forceUpgrade = true;
                            this.requiredVersion = appConfig[userId];
                            return [2 /*return*/];
                        }
                        if (clientUUIDReg && this.clientUUID) {
                            reg = new RegExp(clientUUIDReg);
                            if (reg.test(this.clientUUID) && version) {
                                this.forceUpgrade = true;
                                this.requiredVersion = version;
                                return [2 /*return*/];
                            }
                        }
                        if (userIdReg && userId) {
                            reg = new RegExp(userIdReg);
                            if (reg.test(userId.toString()) && version) {
                                this.forceUpgrade = true;
                                this.requiredVersion = version;
                                return [2 /*return*/];
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MTOBClient.prototype.checkUpgrade = function () {
        log('checkUpgrade', {
            forceUpgrade: this.forceUpgrade,
            requiredVersion: this.requiredVersion,
            minVersion: this.minVersion,
            connectedVersion: this.connectedVersion,
            skipForcedUpgrade: this.options.skipForcedUpgrade,
        });
        if (!this.connectedVersion) {
            return;
        }
        // 跳过强制升级
        if (this.options.skipForcedUpgrade) {
            log('skip forced upgrade!', this.requiredVersion);
            _utils_logger__WEBPACK_IMPORTED_MODULE_3__.default.logInfo('Skip Forced Upgrade', {
                forceUpgrade: this.forceUpgrade,
                requiredVersion: this.requiredVersion,
            });
            return;
        }
        if (this.connectedVersion !== this.requiredVersion && this.forceUpgrade) {
            this.upgrade();
            this.status = _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.NeedUpdate;
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents.StatusChange, {
                status: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus.MTOB_UPDATE_REQUIRED,
            });
            return;
        }
        if (this.minVersion &&
            this.compareVersion(this.connectedVersion, this.minVersion) === -1) {
            this.requiredVersion = this.minVersion;
            this.upgrade();
            this.status = _constants__WEBPACK_IMPORTED_MODULE_4__.EMTOBStatus.NeedUpdate;
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents.StatusChange, {
                status: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus.MTOB_UPDATE_REQUIRED,
            });
        }
    };
    /**
     * v1 < v2 return -1
     * v1 === v2 return 0
     * v1 > v2 return 1
     */
    MTOBClient.prototype.compareVersion = function (v1, v2) {
        var arr1 = v1.split('-')[0].split('.');
        var arr2 = v2.split('-')[0].split('.');
        for (var i = 0; i < 3; i++) {
            var num1 = +arr1[i];
            var num2 = +arr2[i];
            if (num1 < num2) {
                return -1;
            }
            if (num1 > num2) {
                return 1;
            }
        }
        return 0;
    };
    MTOBClient.prototype.showDownloadAlert = function () {
        if (!this.options.defaultDownloadAlert) {
            return false;
        }
        if (window.confirm('MTOB未启动，请手动启动，或点击确定下载安装包')) {
            window.open(this.requiredVersionDownloadURL, '_blank', 'noreferrer,noopener');
            return true;
        }
        else {
            return false;
        }
    };
    MTOBClient.prototype.showUpdateAlert = function () {
        if (!this.options.defaultUpdateAlert) {
            return false;
        }
        if (window.confirm('MTOB版本不兼容，正在自动更新，也可点击确定下载正确版本')) {
            window.open(this.requiredVersionDownloadURL, '_blank', 'noreferrer,noopener');
            return true;
        }
        else {
            return false;
        }
    };
    return MTOBClient;
}(_utils_EventEmitter__WEBPACK_IMPORTED_MODULE_1__.default));

/* harmony default export */ __webpack_exports__["default"] = (new MTOBClient());
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29yZS9jbGllbnQvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLE1BQU0sa0JBQWtCLENBQUM7QUFDbEMsT0FBTyxZQUFZLE1BQU0sMEJBQTBCLENBQUM7QUFDcEQsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBQzNDLE9BQU8sTUFBTSxNQUFNLG9CQUFvQixDQUFDO0FBRXhDLE9BQU8sRUFDTCxpQkFBaUIsRUFDakIsVUFBVSxFQUNWLFVBQVUsRUFDVixXQUFXLEdBQ1osTUFBTSxpQkFBaUIsQ0FBQztBQUN6QixPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sYUFBYSxDQUFDO0FBQzFDLE9BQU8sR0FBRyxNQUFNLE9BQU8sQ0FBQztBQUN4QixPQUFPLEdBQUcsTUFBTSx1QkFBdUIsQ0FBQztBQUd4QyxJQUFNLHFCQUFxQixHQUFHLG1CQUFtQixDQUFDO0FBQ2xELElBQU0sc0JBQXNCLEdBQUcsb0JBQW9CLENBQUM7QUFDcEQsSUFBTSxrQkFBa0IsR0FBRyxDQUFDLEtBQUssRUFBRSxLQUFLLEVBQUUsS0FBSyxDQUFDLENBQUM7QUFDakQsSUFBTSxpQkFBaUIsR0FBRyxDQUFDLENBQUM7QUFFNUIsSUFBTSxHQUFHLEdBQUc7SUFBQyxjQUFjO1NBQWQsVUFBYyxFQUFkLHFCQUFjLEVBQWQsSUFBYztRQUFkLHlCQUFjOztJQUN6QixzQ0FBc0M7SUFDdEMsT0FBTyxDQUFDLEdBQUcsT0FBWCxPQUFPLGlCQUFLLGdCQUFnQixHQUFLLElBQUksR0FBRTtBQUN6QyxDQUFDLENBQUM7QUE4QkY7SUFBZ0MsOEJBQVk7SUFBNUM7UUFBQSxxRUF3dkJDO1FBdnZCQyxZQUFNLEdBQUcsV0FBVyxDQUFDLFlBQVksQ0FBQztRQUNsQyxlQUFTLEdBQUcsT0FBTyxFQUFFLENBQUM7UUFDdEIsb0JBQWMsR0FBRyxLQUFLLENBQUM7UUFJdkIsZUFBUyxHQUFHLENBQUMsQ0FBQztRQUNkLGdCQUFVLEdBQUcsQ0FBQyxDQUFDO1FBQ2YsaUJBQVcsR0FBRyxJQUFJLENBQUM7UUFDbkIsVUFBSSxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUztRQUVwQixrQkFBWSxHQUFHLEtBQUssQ0FBQztRQUNyQixxQkFBZSxHQUFHLEVBQUUsQ0FBQztRQUNyQixnQkFBVSxHQUFHLEVBQUUsQ0FBQztRQUNoQixzQkFBZ0IsR0FBRyxFQUFFLENBQUM7UUFDdEIsZ0JBQVUsR0FBRyxFQUFFLENBQUM7UUFDaEIsZ0JBQVUsR0FBZ0IsSUFBSSxDQUFDO1FBQy9CLHdCQUFrQixHQUE2QixJQUFJLENBQUM7UUFFcEQsYUFBTyxHQUE2QixFQUFFLENBQUM7UUFFdkMsa0JBQVksR0FBeUIsSUFBSSxDQUFDO1FBRTFDLGdCQUFVLEdBQXVCLElBQUksQ0FBQzs7SUFndUJ4QyxDQUFDO0lBOXRCQyxzQkFBSSw4QkFBTTthQUFWO1lBQ0UsSUFBTSxHQUFHLEdBQUcsSUFBSSxDQUFDLE9BQU8sSUFBSSxJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQztZQUM3QyxPQUFPLEdBQUcsS0FBSyxZQUFZLElBQUksR0FBRyxLQUFLLFNBQVMsQ0FBQztRQUNuRCxDQUFDOzs7T0FBQTtJQUVELHNCQUFZLGlDQUFTO2FBQXJCO1lBQ0UsSUFBTSxJQUFJLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsc0JBQXNCLENBQUMsQ0FBQyxDQUFDLHFCQUFxQixDQUFDO1lBQzFFLE9BQU8sS0FBRyxJQUFJLEdBQUcsSUFBSSxDQUFDLElBQU0sQ0FBQztRQUMvQixDQUFDOzs7T0FBQTtJQUVELHNCQUFZLG1DQUFXO2FBQXZCO1lBQ0UsSUFBTSxHQUFHLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUM7WUFDMUMsT0FBTyxnREFBOEMsR0FBRyxvQkFBaUIsQ0FBQztRQUM1RSxDQUFDOzs7T0FBQTtJQUVELHNCQUFZLGtEQUEwQjthQUF0QztZQUNFLE9BQU8sSUFBSSxDQUFDLFdBQVcsR0FBRyxXQUFXLEdBQUcsSUFBSSxDQUFDLGVBQWUsQ0FBQztRQUMvRCxDQUFDOzs7T0FBQTtJQUVELHlCQUFJLEdBQUosVUFBSyxPQUF3QjtRQUE3QixpQkF5QkM7UUF4QkMsSUFBSSxDQUFDLE9BQU8sSUFBSSxDQUFDLE9BQU8sQ0FBQyxPQUFPLEVBQUU7WUFDaEMsTUFBTSxXQUFXLENBQUMsb0JBQW9CLENBQUM7U0FDeEM7UUFFRCxJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sSUFBSSxFQUFFLENBQUM7UUFFN0IsSUFBSSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUM7UUFFN0IsTUFBTSxDQUFDLElBQUksQ0FBQztZQUNWLE9BQU8sRUFBRSxJQUFJLENBQUMsT0FBTyxDQUFDLE9BQU87WUFDN0IsTUFBTSxFQUFFLElBQUksQ0FBQyxPQUFPLENBQUMsTUFBTTtZQUMzQixHQUFHLEVBQUUsSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHO1lBQ3JCLFlBQVksRUFBRSxJQUFJLENBQUMsT0FBTyxDQUFDLFlBQVk7U0FDeEMsQ0FBQyxDQUFDO1FBRUgsSUFBSSxDQUFDLG1CQUFtQixFQUFFLENBQUMsSUFBSSxDQUFDO1lBQzlCLEdBQUcsQ0FBQyx5QkFBeUIsRUFBRTtnQkFDN0IsWUFBWSxFQUFFLEtBQUksQ0FBQyxZQUFZO2dCQUMvQixlQUFlLEVBQUUsS0FBSSxDQUFDLGVBQWU7Z0JBQ3JDLFVBQVUsRUFBRSxLQUFJLENBQUMsVUFBVTthQUM1QixDQUFDLENBQUM7UUFDTCxDQUFDLENBQUMsQ0FBQztRQUVILElBQUksQ0FBQyxPQUFPLEVBQUUsQ0FBQztJQUNqQixDQUFDO0lBRUQsMkJBQU0sR0FBTjtRQUNFLElBQUksQ0FBQyxpQkFBaUIsRUFBRSxDQUFDO0lBQzNCLENBQUM7SUFFTyw0QkFBTyxHQUFmO1FBQ0UsSUFBSSxJQUFJLENBQUMsTUFBTSxLQUFLLFdBQVcsQ0FBQyxTQUFTLEVBQUU7WUFDekMsSUFBSSxDQUFDLGVBQWUsRUFBRSxDQUFDO1lBQ3ZCLE9BQU87U0FDUjtRQUVELElBQ0UsSUFBSSxDQUFDLE1BQU0sS0FBSyxXQUFXLENBQUMsVUFBVTtZQUN0QyxJQUFJLENBQUMsTUFBTSxLQUFLLFdBQVcsQ0FBQyxVQUFVLEVBQ3RDO1lBQ0EsT0FBTztTQUNSO1FBRUQsSUFBSSxDQUFDLE1BQU0sR0FBRyxXQUFXLENBQUMsVUFBVSxDQUFDO1FBRXJDLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztJQUNkLENBQUM7SUFFTyx5QkFBSSxHQUFaO1FBQUEsaUJBK0JDO1FBOUJDLElBQUksQ0FBQyxJQUFJLENBQUMsV0FBVyxFQUFFO1lBQ3JCLE9BQU87U0FDUjtRQUVELElBQUksSUFBSSxDQUFDLE9BQU8sQ0FBQyxPQUFPLElBQUksSUFBSSxDQUFDLE9BQU8sQ0FBQyxPQUFPLEdBQUcsQ0FBQyxFQUFFO1lBQ3BELFdBQVc7WUFDWCxJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDO1NBQ2xDO2FBQU0sSUFBSSxRQUFRLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUMsSUFBSSxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsRUFBRTtZQUNuRSxTQUFTO1lBQ1QsSUFBSSxDQUFDLElBQUksR0FBRyxRQUFRLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQVcsQ0FBQyxDQUFDO1NBQ25FO2FBQU07WUFDTCxJQUFJLENBQUMsSUFBSSxHQUFHLGtCQUFrQixDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQztZQUNoRCxJQUFJLENBQUMsVUFBVSxHQUFHLENBQUMsSUFBSSxDQUFDLFVBQVUsR0FBRyxDQUFDLENBQUMsR0FBRyxrQkFBa0IsQ0FBQyxNQUFNLENBQUM7U0FDckU7UUFFRCxHQUFHLENBQUMsMEJBQTBCLEVBQUUsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO1FBRTNDLElBQUksQ0FBQyxPQUFPLEdBQUcsSUFBSSxFQUFFLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxTQUFTLEVBQUU7WUFDNUMsWUFBWSxFQUFFLEtBQUs7WUFDbkIsa0JBQWtCLEVBQUUsS0FBSztTQUMxQixDQUFDLENBQUM7UUFFSCxJQUFJLENBQUMsTUFBTSxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ3ZDLElBQUksQ0FBQyxPQUFPLENBQUMsT0FBTyxFQUFFLENBQUM7UUFFdkIsSUFBSSxDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUMsT0FBTyxFQUFFLGNBQU0sT0FBQSxLQUFJLENBQUMsdUJBQXVCLEVBQUUsRUFBOUIsQ0FBOEIsQ0FBQyxDQUFDO1FBQy9ELElBQUksQ0FBQyxNQUFNLENBQUMsRUFBRSxDQUFDLFNBQVMsRUFBRSxjQUFNLE9BQUEsS0FBSSxDQUFDLGlCQUFpQixFQUFFLEVBQXhCLENBQXdCLENBQUMsQ0FBQztRQUMxRCxJQUFJLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQyxZQUFZLEVBQUUsVUFBQyxNQUFjO1lBQzFDLE9BQUEsS0FBSSxDQUFDLG9CQUFvQixDQUFDLE1BQU0sQ0FBQztRQUFqQyxDQUFpQyxDQUNsQyxDQUFDO0lBQ0osQ0FBQztJQUVPLDRDQUF1QixHQUEvQjtRQUFBLGlCQTBCQztRQXpCQyxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssRUFBRSxDQUFDO1FBQ3BCLElBQUksQ0FBQyxNQUFNLENBQUMsa0JBQWtCLEVBQUUsQ0FBQztRQUNqQyxJQUFJLENBQUMsT0FBTyxDQUFDLE1BQU0sRUFBRSxDQUFDO1FBQ3RCLElBQUksQ0FBQyxTQUFTLEVBQUUsQ0FBQztRQUVqQiwwQ0FBMEM7UUFDMUMsSUFBSSxJQUFJLENBQUMsU0FBUyxJQUFJLGtCQUFrQixDQUFDLE1BQU0sRUFBRTtZQUMvQyxJQUFJLElBQUksQ0FBQyxPQUFPLENBQUMsVUFBVSxLQUFLLEtBQUssRUFBRTtnQkFDckMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsWUFBWSxFQUFFLEVBQUUsTUFBTSxFQUFFLFVBQVUsQ0FBQyxLQUFLLEVBQUUsQ0FBQyxDQUFDO2dCQUNqRSxJQUFJLENBQUMsaUJBQWlCLEVBQUUsQ0FBQzthQUMxQjtpQkFBTTtnQkFDTCxJQUFJLENBQUMsVUFBVSxFQUFFLENBQUM7YUFDbkI7U0FDRjtRQUVELCtCQUErQjtRQUMvQixJQUFJLElBQUksQ0FBQyxTQUFTLEtBQUssa0JBQWtCLENBQUMsTUFBTSxHQUFHLGlCQUFpQixFQUFFO1lBQ3BFLG1EQUFtRDtZQUNuRCxJQUFJLElBQUksQ0FBQyxPQUFPLENBQUMsVUFBVSxLQUFLLEtBQUssRUFBRTtnQkFDckMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsWUFBWSxFQUFFLEVBQUUsTUFBTSxFQUFFLFVBQVUsQ0FBQyxLQUFLLEVBQUUsQ0FBQyxDQUFDO2dCQUNqRSxJQUFJLENBQUMsaUJBQWlCLEVBQUUsQ0FBQzthQUMxQjtTQUNGO1FBRUQsVUFBVSxDQUFDLGNBQU0sT0FBQSxLQUFJLENBQUMsSUFBSSxFQUFFLEVBQVgsQ0FBVyxFQUFFLElBQUksQ0FBQyxDQUFDO0lBQ3RDLENBQUM7SUFFYSxzQ0FBaUIsR0FBL0I7Ozs7Ozt3QkFDRSxHQUFHLENBQUMsYUFBYSxFQUFFLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQzt3QkFFOUIscUJBQU0sSUFBSSxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxVQUFDLEtBQUs7Z0NBQ2xELEdBQUcsQ0FBQyxzQkFBc0IsRUFBRSxLQUFLLENBQUMsQ0FBQztnQ0FDbkMsS0FBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLEVBQUUsQ0FBQzs0QkFDdEIsQ0FBQyxDQUFDLEVBQUE7O3dCQUhGLFNBR0UsQ0FBQzt3QkFFSCxJQUFJLENBQUMsYUFBYSxFQUFFLENBQUM7Ozs7O0tBQ3RCO0lBRU8seUNBQW9CLEdBQTVCLFVBQTZCLE1BQWM7UUFDekMsR0FBRyxDQUFDLGdCQUFnQixFQUFFLElBQUksQ0FBQyxJQUFJLEVBQUUsTUFBTSxDQUFDLENBQUM7UUFDekMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLEVBQUUsQ0FBQztRQUNwQixJQUFJLENBQUMsTUFBTSxDQUFDLGtCQUFrQixFQUFFLENBQUM7UUFDakMsSUFBSSxDQUFDLGdCQUFnQixHQUFHLEVBQUUsQ0FBQztRQUMzQixJQUFJLENBQUMsTUFBTSxHQUFHLFdBQVcsQ0FBQyxZQUFZLENBQUM7UUFDdkMsSUFBSSxDQUFDLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxVQUFVLENBQUMsQ0FBQztRQUN4QyxJQUFJLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxZQUFZLEVBQUUsRUFBRSxNQUFNLEVBQUUsVUFBVSxDQUFDLFlBQVksRUFBRSxDQUFDLENBQUM7UUFDeEUsSUFBSSxDQUFDLE9BQU8sRUFBRSxDQUFDO0lBQ2pCLENBQUM7SUFFRCw4QkFBUyxHQUFULFVBQVUsT0FBaUM7UUFDekMsSUFBSSxDQUFDLE9BQU8seUJBQ1AsQ0FBQyxJQUFJLENBQUMsT0FBTyxJQUFJLEVBQUUsQ0FBQyxHQUNwQixDQUFDLE9BQU8sSUFBSSxFQUFFLENBQUMsQ0FDbkIsQ0FBQztRQUVGLEdBQUcsQ0FBQyxhQUFhLEVBQUUsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBRWpDLElBQUksQ0FBQyxJQUFJLENBQUMsaUJBQWlCLENBQUMsY0FBYyxFQUFFLElBQUksQ0FBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLFVBQVUsQ0FBQyxDQUFDO1FBRTNFLElBQUksT0FBTyxDQUFDLE9BQU8sRUFBRTtZQUNuQixZQUFZLENBQUMsT0FBTyxDQUNsQixXQUFXLEVBQ1gsT0FBTyxDQUFDLE9BQU8sS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxLQUFHLE9BQU8sQ0FBQyxPQUFTLENBQ25ELENBQUM7WUFDRixJQUFJLElBQUksQ0FBQyxJQUFJLEtBQUssT0FBTyxDQUFDLE9BQU8sRUFBRTtnQkFDakMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLEVBQUUsQ0FBQztnQkFDcEIsSUFBSSxDQUFDLE9BQU8sRUFBRSxDQUFDO2FBQ2hCO1NBQ0Y7SUFDSCxDQUFDO0lBRUQsK0JBQVUsR0FBVjtRQUNFLElBQU0sR0FBRyxHQUFHLE1BQU0sR0FBRyxJQUFJLENBQUMsZUFBZSxHQUFHLGtCQUFrQixDQUFDO1FBQy9ELElBQUk7WUFDRixNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksR0FBRyxHQUFHLENBQUM7U0FDNUI7UUFBQyxXQUFNO1lBQ04sR0FBRyxDQUFDLHlCQUF1QixHQUFLLENBQUMsQ0FBQztZQUNsQyxNQUFNLENBQUMsVUFBVSxDQUFDLG9CQUFvQixFQUFFLEVBQUUsR0FBRyxLQUFBLEVBQUUsQ0FBQyxDQUFDO1NBQ2xEO0lBQ0gsQ0FBQztJQUVELGdDQUFXLEdBQVg7UUFDRSxPQUFPO1lBQ0wsTUFBTSxFQUFFLElBQUksQ0FBQyxNQUFNO1lBQ25CLG1CQUFtQixFQUFFLElBQUksQ0FBQyxlQUFlO1lBQ3pDLGtCQUFrQixFQUFFLElBQUksQ0FBQyxnQkFBZ0I7WUFDekMsV0FBVyxFQUFFLElBQUksQ0FBQyxXQUFXO1lBQzdCLDBCQUEwQixFQUFFLElBQUksQ0FBQywwQkFBMEI7WUFDM0QsVUFBVSxFQUFFLElBQUksQ0FBQyxVQUFVO1NBQzVCLENBQUM7SUFDSixDQUFDO0lBRUQsb0NBQWUsR0FBZjtRQUFBLGlCQWtCQztRQWpCQyxJQUFJLElBQUksQ0FBQyxVQUFVLEtBQUssSUFBSSxFQUFFO1lBQzVCLE9BQU8sT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztTQUM5QjtRQUVELE9BQU8sSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsaUJBQWlCLENBQUM7YUFDdkMsSUFBSSxDQUFDLFVBQU8sR0FBUTs7O2dCQUNuQixHQUFHLENBQUMsd0JBQXdCLEVBQUUsR0FBRyxDQUFDLENBQUM7Z0JBRTNCLEdBQUcsR0FBdUMsR0FBRyxJQUExQyxFQUFFLFNBQVMsR0FBNEIsR0FBRyxVQUEvQixFQUFFLE1BQU0sR0FBb0IsR0FBRyxPQUF2QixFQUFFLElBQUksR0FBYyxHQUFHLEtBQWpCLEVBQUssSUFBSSxVQUFLLEdBQUcsRUFBL0Msc0NBQXlDLENBQUYsQ0FBUztnQkFDdEQsSUFBSSxDQUFDLGtCQUFrQixHQUFHLElBQXlCLENBQUM7Z0JBQ3BELHNCQUFPLElBQUksRUFBQzs7YUFDYixDQUFDO2FBQ0QsS0FBSyxDQUFDLFVBQUMsR0FBRztZQUNULEdBQUcsQ0FBQyw4QkFBOEIsRUFBRSxHQUFHLENBQUMsQ0FBQztZQUN6QyxLQUFJLENBQUMsa0JBQWtCLEdBQUcsSUFBSSxDQUFDO1lBQy9CLE9BQU8sSUFBSSxDQUFDO1FBQ2QsQ0FBQyxDQUFDLENBQUM7SUFDUCxDQUFDO0lBRUQsb0NBQWUsR0FBZixVQUFnQixNQUFrQztRQUFsRCxpQkFvQkM7UUFuQkMsSUFBSSxJQUFJLENBQUMsVUFBVSxLQUFLLElBQUksRUFBRTtZQUM1QixPQUFPLE9BQU8sQ0FBQyxPQUFPLEVBQUUsQ0FBQztTQUMxQjtRQUVELE9BQU8sSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsaUJBQWlCLHNCQUN2QyxnQkFBZ0IsRUFBRSxHQUFHLEVBQ3JCLHFCQUFxQixFQUFFLEVBQUUsRUFDekIsbUJBQW1CLEVBQUUsSUFBSSxJQUN0QixDQUFDLElBQUksQ0FBQyxrQkFBa0IsSUFBSSxFQUFFLENBQUMsR0FDL0IsQ0FBQyxNQUFNLElBQUksRUFBRSxDQUFDLEVBQ2pCO2FBQ0MsSUFBSSxDQUFDLFVBQU8sR0FBRzs7Z0JBQ2QsR0FBRyxDQUFDLHdCQUF3QixFQUFFLEdBQUcsQ0FBQyxDQUFDO2dCQUNuQyxJQUFJLENBQUMsZUFBZSxFQUFFLENBQUM7OzthQUN4QixDQUFDO2FBQ0QsS0FBSyxDQUFDLFVBQUMsR0FBRztZQUNULEdBQUcsQ0FBQyw4QkFBOEIsRUFBRSxHQUFHLENBQUMsQ0FBQztZQUN6QyxLQUFJLENBQUMsZUFBZSxFQUFFLENBQUM7UUFDekIsQ0FBQyxDQUFDLENBQUM7SUFDUCxDQUFDO0lBRUQsaUNBQVksR0FBWixVQUFhLFFBQWE7UUFDeEIsTUFBTSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUM3QixDQUFDO0lBRUQsd0JBQUcsR0FBSCxVQUFJLE1BQWMsRUFBRSxJQUFTLEVBQUUsUUFBYztRQUMzQyxJQUNFLENBQUMsSUFBSSxDQUFDLE1BQU07WUFDWixDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSztZQUNsQixJQUFJLENBQUMsTUFBTSxDQUFDLFlBQVk7WUFDeEIsSUFBSSxDQUFDLE1BQU0sS0FBSyxXQUFXLENBQUMsWUFBWSxFQUN4QztZQUNBLE1BQU0sQ0FBQyxVQUFVLENBQUMsK0NBQStDLENBQUMsQ0FBQztZQUNuRSxJQUFJLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxZQUFZLEVBQUUsRUFBRSxNQUFNLEVBQUUsVUFBVSxDQUFDLEtBQUssRUFBRSxDQUFDLENBQUM7WUFDakUsT0FBTztTQUNSO1FBRUQsSUFBSSxJQUFJLENBQUMsTUFBTSxLQUFLLFdBQVcsQ0FBQyxVQUFVLEVBQUU7WUFDMUMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsWUFBWSxFQUFFO2dCQUNqQyxNQUFNLEVBQUUsVUFBVSxDQUFDLG9CQUFvQjthQUN4QyxDQUFDLENBQUM7WUFDSCxNQUFNLENBQUMsVUFBVSxDQUFDLDZDQUE2QyxDQUFDLENBQUM7WUFDakUsT0FBTztTQUNSO1FBRUQsTUFBTSxDQUFDLE9BQU8sQ0FBQyxrQkFBa0IsRUFBRSxFQUFFLE1BQU0sUUFBQSxFQUFFLENBQUMsQ0FBQztRQUUvQyxJQUFNLFNBQVMsR0FBRyxJQUFJLElBQUksRUFBRSxDQUFDLE9BQU8sRUFBRSxDQUFDO1FBQ3ZDLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUNkLFVBQVUsRUFDVjtZQUNFLE1BQU0sUUFBQTtZQUNOLElBQUksTUFBQTtZQUNKLEtBQUssRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUs7U0FDekIsRUFDRCxVQUFDLEdBQVE7WUFDUCxJQUFJLENBQUMsR0FBRyxDQUFDLFVBQVUsRUFBRTtnQkFDbkIsTUFBTSxDQUFDLE9BQU8sQ0FBQywwQkFBMEIsRUFBRTtvQkFDekMsTUFBTSxRQUFBO29CQUNOLE1BQU0sRUFBRSxJQUFJO29CQUNaLEdBQUcsS0FBQTtvQkFDSCxLQUFLLEVBQUUsSUFBSSxJQUFJLEVBQUUsQ0FBQyxPQUFPLEVBQUUsR0FBRyxTQUFTO2lCQUN4QyxDQUFDLENBQUM7YUFDSjtpQkFBTTtnQkFDTCxNQUFNLENBQUMsT0FBTyxDQUFDLDJCQUEyQixFQUFFO29CQUMxQyxNQUFNLFFBQUE7b0JBQ04sTUFBTSxFQUFFLE1BQU0sS0FBSyxlQUFlLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsU0FBUztvQkFDckQsR0FBRyxLQUFBO29CQUNILEtBQUssRUFBRSxJQUFJLElBQUksRUFBRSxDQUFDLE9BQU8sRUFBRSxHQUFHLFNBQVM7aUJBQ3hDLENBQUMsQ0FBQzthQUNKO1lBQ0QsUUFBUSxJQUFJLFFBQVEsQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUM1QixDQUFDLENBQ0YsQ0FBQztJQUNKLENBQUM7SUFFRCwwQkFBSyxHQUFMLFVBQU0sS0FBYSxFQUFFLFFBQTRCO1FBQy9DLElBQ0UsQ0FBQyxJQUFJLENBQUMsTUFBTTtZQUNaLElBQUksQ0FBQyxNQUFNLENBQUMsWUFBWTtZQUN4QixJQUFJLENBQUMsTUFBTSxLQUFLLFdBQVcsQ0FBQyxZQUFZLEVBQ3hDO1lBQ0EsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsWUFBWSxFQUFFLEVBQUUsTUFBTSxFQUFFLFVBQVUsQ0FBQyxLQUFLLEVBQUUsQ0FBQyxDQUFDO1lBQ2pFLE9BQU87U0FDUjtRQUNELElBQUksQ0FBQyxNQUFNLENBQUMsRUFBRSxDQUFDLEtBQUssRUFBRSxRQUFRLENBQUMsQ0FBQztJQUNsQyxDQUFDO0lBRUQsMkJBQU0sR0FBTixVQUFPLEtBQVU7UUFDZixJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU07WUFBRSxPQUFPO1FBQ3pCLElBQUksQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ3pCLENBQUM7SUFFRCw0QkFBTyxHQUFQLFVBQVEsR0FBVyxFQUFFLE1BQVk7UUFBakMsaUJBb0RDO1FBbkRDLElBQ0UsQ0FBQyxJQUFJLENBQUMsTUFBTTtZQUNaLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLO1lBQ2xCLElBQUksQ0FBQyxNQUFNLENBQUMsWUFBWTtZQUN4QixJQUFJLENBQUMsTUFBTSxLQUFLLFdBQVcsQ0FBQyxZQUFZLEVBQ3hDO1lBQ0EsTUFBTSxDQUFDLFVBQVUsQ0FBQywwQ0FBMEMsQ0FBQyxDQUFDO1lBQzlELElBQUksQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLFlBQVksRUFBRSxFQUFFLE1BQU0sRUFBRSxVQUFVLENBQUMsS0FBSyxFQUFFLENBQUMsQ0FBQztZQUNqRSxPQUFPLE9BQU8sQ0FBQyxNQUFNLEVBQUUsQ0FBQztTQUN6QjtRQUVELElBQUksSUFBSSxDQUFDLE1BQU0sS0FBSyxXQUFXLENBQUMsVUFBVSxFQUFFO1lBQzFDLElBQUksQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLFlBQVksRUFBRTtnQkFDakMsTUFBTSxFQUFFLFVBQVUsQ0FBQyxvQkFBb0I7YUFDeEMsQ0FBQyxDQUFDO1lBQ0gsTUFBTSxDQUFDLFVBQVUsQ0FBQyx3Q0FBd0MsQ0FBQyxDQUFDO1lBQzVELE9BQU8sT0FBTyxDQUFDLE1BQU0sRUFBRSxDQUFDO1NBQ3pCO1FBRUQsTUFBTSxDQUFDLE9BQU8sQ0FBQyxhQUFhLEVBQUUsRUFBRSxHQUFHLEtBQUEsRUFBRSxDQUFDLENBQUM7UUFFdkMsSUFBTSxTQUFTLEdBQUcsSUFBSSxJQUFJLEVBQUUsQ0FBQyxPQUFPLEVBQUUsQ0FBQztRQUN2QyxPQUFPLElBQUksT0FBTyxDQUFDLFVBQUMsT0FBTyxFQUFFLE1BQU07WUFDakMsS0FBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLFlBRVosR0FBRyxLQUFBLEVBQ0gsU0FBUyxFQUFFLE9BQU8sRUFBRSxFQUNwQixPQUFPLEVBQUUsS0FBSSxDQUFDLGNBQWMsSUFDekIsQ0FBQyxNQUFNLElBQUksRUFBRSxDQUFDLEdBRW5CLFVBQUMsR0FBUTtnQkFDUCxJQUFJLEdBQUcsSUFBSSxHQUFHLENBQUMsTUFBTSxLQUFLLFNBQVMsRUFBRTtvQkFDbkMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxzQkFBc0IsRUFBRTt3QkFDckMsR0FBRyxLQUFBO3dCQUNILE1BQU0sRUFBRSxHQUFHLEtBQUssT0FBTyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLFNBQVM7d0JBQzVDLEdBQUcsS0FBQTt3QkFDSCxLQUFLLEVBQUUsSUFBSSxJQUFJLEVBQUUsQ0FBQyxPQUFPLEVBQUUsR0FBRyxTQUFTO3FCQUN4QyxDQUFDLENBQUM7b0JBQ0gsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDO2lCQUNkO3FCQUFNO29CQUNMLE1BQU0sQ0FBQyxPQUFPLENBQUMscUJBQXFCLEVBQUU7d0JBQ3BDLEdBQUcsS0FBQTt3QkFDSCxNQUFNLFFBQUE7d0JBQ04sR0FBRyxLQUFBO3dCQUNILEtBQUssRUFBRSxJQUFJLElBQUksRUFBRSxDQUFDLE9BQU8sRUFBRSxHQUFHLFNBQVM7cUJBQ3hDLENBQUMsQ0FBQztvQkFDSCxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUM7aUJBQ2I7WUFDSCxDQUFDLENBQ0YsQ0FBQztRQUNKLENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVPLHNDQUFpQixHQUF6QjtRQUNFLElBQUksQ0FBQyxXQUFXLEdBQUcsS0FBSyxDQUFDO0lBQzNCLENBQUM7SUFFTyxvQ0FBZSxHQUF2QjtRQUNFLElBQUksQ0FBQyxNQUFNLEdBQUcsV0FBVyxDQUFDLFNBQVMsQ0FBQztRQUNwQyxJQUFJLENBQUMsSUFBSSxDQUFDLGlCQUFpQixDQUFDLE9BQU8sRUFBRSxJQUFJLENBQUMsVUFBVSxFQUFFLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUNwRSxJQUFJLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxZQUFZLEVBQUUsRUFBRSxNQUFNLEVBQUUsVUFBVSxDQUFDLEtBQUssRUFBRSxDQUFDLENBQUM7SUFDbkUsQ0FBQztJQUVELEtBQUs7SUFDRyxpQ0FBWSxHQUFwQixVQUFxQixRQUFnQjtRQUFyQyxpQkFrQkM7UUFqQkMsT0FBTyxLQUFLLENBQUMsSUFBSSxDQUFDLFNBQVMsR0FBRyxHQUFHLENBQUMsWUFBWSxHQUFHLFlBQVksR0FBRyxRQUFRLENBQUM7YUFDdEUsSUFBSSxDQUFDLFVBQUMsR0FBRyxJQUFLLE9BQUEsR0FBRyxDQUFDLElBQUksRUFBRSxFQUFWLENBQVUsQ0FBQzthQUN6QixJQUFJLENBQUMsVUFBQyxHQUFRO1lBQ2IsR0FBRyxDQUFDLG9CQUFvQixFQUFFLEdBQUcsQ0FBQyxDQUFDO1lBQy9CLEtBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxHQUFHLEdBQUcsQ0FBQyxLQUFLLENBQUM7WUFDOUIsS0FBSSxDQUFDLFVBQVUsR0FBRyxHQUFHLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztZQUV2QyxJQUFJLEdBQUcsYUFBSCxHQUFHLHVCQUFILEdBQUcsQ0FBRSxLQUFLLEVBQUU7Z0JBQ2QsS0FBSSxDQUFDLFVBQVUsR0FBRyxHQUFHLENBQUMsS0FBSyxDQUFDO2dCQUM1QixNQUFNLENBQUMsT0FBTyxDQUFDLEtBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQzthQUNqQztZQUVELElBQUksR0FBRyxhQUFILEdBQUcsdUJBQUgsR0FBRyxDQUFFLE9BQU8sRUFBRTtnQkFDaEIsS0FBSSxDQUFDLGdCQUFnQixHQUFHLEdBQUcsQ0FBQyxPQUFPLENBQUM7Z0JBQ3BDLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxLQUFJLENBQUMsZ0JBQWdCLENBQUMsQ0FBQzthQUNoRDtRQUNILENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQUVhLGtDQUFhLEdBQTNCOzs7Ozs2QkFDTSxDQUFBLElBQUksQ0FBQyxVQUFVLEtBQUssSUFBSSxDQUFBLEVBQXhCLHdCQUF3Qjt3QkFDMUIscUJBQU0sSUFBSSxDQUFDLGVBQWUsRUFBRSxFQUFBOzt3QkFBNUIsU0FBNEIsQ0FBQzt3QkFDN0IsSUFBSSxDQUFDLGVBQWUsRUFBRSxDQUFDOzs0QkFFdkIscUJBQU0sSUFBSSxDQUFDLGVBQWUsRUFBRSxFQUFBOzt3QkFBNUIsU0FBNEIsQ0FBQzs7Ozs7O0tBRWhDO0lBRU8sb0NBQWUsR0FBdkI7UUFBQSxpQkF5QkM7UUF4QkMsT0FBTyxJQUFJLE9BQU8sQ0FBTyxVQUFDLE9BQU87WUFDL0IsS0FBSSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsY0FBYyxFQUFFLElBQUksRUFBRSxVQUFPLEdBQVE7Ozs7OzRCQUNoRCxHQUFHLENBQUMsZUFBZSxFQUFFLEdBQUcsQ0FBQyxDQUFDOzRCQUVwQixLQUFvQixHQUFHLElBQUksRUFBRSxFQUEzQixJQUFJLFVBQUEsRUFBRSxPQUFPLGFBQUEsQ0FBZTs0QkFFcEMsSUFBSSxJQUFJLEVBQUU7Z0NBQ1IsSUFBSSxDQUFDLFVBQVUsR0FBRyxJQUFJLENBQUM7Z0NBQ3ZCLE1BQU0sQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7NkJBQ3RCOzRCQUVELElBQUksT0FBTyxFQUFFO2dDQUNYLElBQUksQ0FBQyxnQkFBZ0IsR0FBRyxPQUFPLENBQUM7Z0NBQ2hDLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxPQUFPLENBQUMsQ0FBQzs2QkFDbEM7NEJBRUQsSUFBSSxDQUFDLGVBQWUsRUFBRSxDQUFDOzRCQUV2QixxQkFBTSxJQUFJLENBQUMsbUJBQW1CLEVBQUUsRUFBQTs7NEJBQWhDLFNBQWdDLENBQUM7NEJBQ2pDLElBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQzs0QkFFcEIsT0FBTyxFQUFFLENBQUM7Ozs7aUJBQ1gsQ0FBQyxDQUFDO1FBQ0wsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0lBRU8sb0NBQWUsR0FBdkI7UUFBQSxpQkFpQ0M7UUFoQ0MsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxjQUFjLENBQUM7YUFDcEMsSUFBSSxDQUFDLFVBQU8sR0FBUTs7Ozs7d0JBQ25CLEdBQUcsQ0FBQyxlQUFlLEVBQUUsR0FBRyxDQUFDLENBQUM7d0JBRXBCLEtBQW9CLEdBQUcsSUFBSSxFQUFFLEVBQTNCLElBQUksVUFBQSxFQUFFLE9BQU8sYUFBQSxDQUFlO3dCQUVwQyxJQUFJLElBQUksRUFBRTs0QkFDUixJQUFJLENBQUMsVUFBVSxHQUFHLElBQUksQ0FBQzs0QkFDdkIsTUFBTSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQzt5QkFDdEI7d0JBRUQsSUFBSSxPQUFPLEVBQUU7NEJBQ1gsSUFBSSxDQUFDLGdCQUFnQixHQUFHLE9BQU8sQ0FBQzs0QkFDaEMsTUFBTSxDQUFDLGdCQUFnQixDQUFDLE9BQU8sQ0FBQyxDQUFDO3lCQUNsQzt3QkFFRCxJQUFJLENBQUMsZUFBZSxFQUFFLENBQUM7d0JBRXZCLHFCQUFNLElBQUksQ0FBQyxtQkFBbUIsRUFBRSxFQUFBOzt3QkFBaEMsU0FBZ0MsQ0FBQzt3QkFDakMsSUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDOzs7O2FBQ3JCLENBQUM7YUFDRCxLQUFLLENBQUMsVUFBTyxHQUFHOzs7O3dCQUNmLEdBQUcsQ0FBQyx1QkFBdUIsRUFBRSxHQUFHLENBQUMsQ0FBQzt3QkFFbEMsSUFBSSxDQUFDLGVBQWUsRUFBRSxDQUFDO3dCQUV2QixxQkFBTSxJQUFJLENBQUMsbUJBQW1CLEVBQUUsRUFBQTs7d0JBQWhDLFNBQWdDLENBQUM7d0JBQ2pDLElBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQzs7OzthQUNyQixDQUFDO2FBQ0QsS0FBSyxDQUFDLFVBQUMsR0FBRztZQUNULEdBQUcsQ0FBQyx1QkFBdUIsRUFBRSxHQUFHLENBQUMsQ0FBQztRQUNwQyxDQUFDLENBQUMsQ0FBQztJQUNQLENBQUM7SUFFTyw0QkFBTyxHQUFmO1FBQ0UsSUFBSSxDQUFDLGVBQWUsRUFBRSxDQUFDO1FBQ3ZCLElBQUksSUFBSSxDQUFDLGdCQUFnQixJQUFJLENBQUMsSUFBSSxDQUFDLGdCQUFnQixDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEVBQUU7WUFDdEUsSUFBSSxDQUFDLGlCQUFpQixDQUFDO2dCQUNyQixrQkFBa0IsRUFBRTtvQkFDbEIsT0FBTyxFQUFFLElBQUksQ0FBQyxPQUFPLENBQUMsT0FBTztvQkFDN0IsTUFBTSxFQUFFLElBQUksQ0FBQyxPQUFPLENBQUMsTUFBTTtpQkFDNUI7YUFDRixDQUFDLENBQUM7U0FDSjthQUFNLElBQUksSUFBSSxDQUFDLFVBQVUsS0FBSyxJQUFJLEVBQUU7WUFDbkMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsT0FBTyxFQUFFO2dCQUN4QixPQUFPLEVBQUUsSUFBSSxDQUFDLGVBQWU7Z0JBQzdCLGFBQWEsRUFBRSxJQUFJLENBQUMsZUFBZTthQUNwQyxDQUFDLENBQUM7U0FDSjthQUFNO1lBQ0wsSUFBSSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsYUFBYSxFQUFFO2dCQUMxQixhQUFhLEVBQUUsSUFBSSxDQUFDLGVBQWU7YUFDcEMsQ0FBQyxDQUFDO1NBQ0o7UUFDRCxNQUFNLENBQUMsT0FBTyxDQUFDLFNBQVMsRUFBRTtZQUN4QixlQUFlLEVBQUUsSUFBSSxDQUFDLGVBQWU7U0FDdEMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVPLHNDQUFpQixHQUF6QixVQUEwQixPQUFZO1FBQ3BDLE9BQU8sSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsZ0JBQWdCLEVBQUUsT0FBTyxDQUFDLENBQUM7SUFDckQsQ0FBQztJQUVPLGtDQUFhLEdBQXJCLFVBQXNCLE9BQVk7UUFBbEMsaUJBWUM7UUFYQyxPQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLGVBQWUsRUFBRSxPQUFPLENBQUM7YUFDOUMsSUFBSSxDQUFDLFVBQU8sR0FBUTs7O2dCQUNuQixHQUFHLENBQUMsd0JBQXdCLEVBQUUsR0FBRyxDQUFDLENBQUM7Z0JBRTNCLFdBQVcsR0FBSyxHQUFHLFlBQVIsQ0FBUztnQkFDNUIsc0JBQU8sV0FBVyxFQUFDOzthQUNwQixDQUFDO2FBQ0QsS0FBSyxDQUFDLFVBQUMsR0FBRztZQUNULEdBQUcsQ0FBQyw4QkFBOEIsRUFBRSxHQUFHLENBQUMsQ0FBQztZQUN6QyxPQUFPLElBQUksQ0FBQztRQUNkLENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ1csb0NBQWUsR0FBN0I7Ozs7Ozt3QkFDUSxDQUFDLEdBQUcsR0FBRyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7d0JBQzlCLEdBQUcsR0FBRyxpREFDVixJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLE1BQU0sc0JBQ2IsQ0FBQzs2QkFFZixDQUFDLElBQUksQ0FBQyxZQUFZLEVBQWxCLHdCQUFrQjt3QkFDcEIsS0FBQSxJQUFJLENBQUE7d0JBQWdCLHFCQUFNLEtBQUssQ0FBQyxHQUFHLENBQUM7aUNBQ2pDLElBQUksQ0FBQyxVQUFDLFFBQVEsSUFBSyxPQUFBLFFBQVEsQ0FBQyxJQUFJLEVBQUUsRUFBZixDQUFlLENBQUM7aUNBQ25DLElBQUksQ0FBQyxVQUFDLElBQVM7Z0NBQVQscUJBQUEsRUFBQSxTQUFTO2dDQUFLLE9BQUEsdUJBQ2hCLENBQUMsSUFBSSxDQUFDLE1BQU0sSUFBSSxFQUFFLENBQUMsR0FDbkIsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksRUFBRSxDQUFDLEVBQ2xCOzRCQUhtQixDQUduQixDQUFDO2lDQUNGLEtBQUssQ0FBQyxjQUFNLE9BQUEsSUFBSSxFQUFKLENBQUksQ0FBQyxFQUFBOzt3QkFOcEIsR0FBSyxZQUFZLEdBQUcsU0FNQSxDQUFDOzs7d0JBR3ZCLEdBQUcsQ0FBQyxpQkFBaUIsRUFBRSxJQUFJLENBQUMsWUFBWSxDQUFDLENBQUM7Ozs7O0tBQzNDO0lBRWEsd0NBQW1CLEdBQWpDOzs7Ozs7NkJBRU0sQ0FBQSxJQUFJLENBQUMsZ0JBQWdCLElBQUksQ0FBQyxJQUFJLENBQUMsZ0JBQWdCLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQSxFQUFsRSx3QkFBa0U7d0JBQ3ZELHFCQUFNLElBQUksQ0FBQyxhQUFhLENBQUM7Z0NBQ3BDLGtCQUFrQixFQUFFO29DQUNsQixPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU8sQ0FBQyxPQUFPO29DQUM3QixNQUFNLEVBQUUsSUFBSSxDQUFDLE9BQU8sQ0FBQyxNQUFNO2lDQUM1Qjs2QkFDRixDQUFDLEVBQUE7O3dCQUxJLElBQUksR0FBRyxTQUtYO3dCQUVGLElBQUksSUFBSSxFQUFFOzRCQUNSLElBQUksQ0FBQyxlQUFlLEdBQUcsSUFBSSxDQUFDLFdBQVcsQ0FBQzs0QkFDeEMsSUFBSSxDQUFDLFlBQVksR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQzt5QkFDeEM7d0JBRUQsc0JBQU87NEJBR1QscUJBQU0sSUFBSSxDQUFDLGVBQWUsRUFBRSxFQUFBOzt3QkFBNUIsU0FBNEIsQ0FBQzt3QkFFdkIsTUFBTSxHQUFHLElBQUksQ0FBQyxZQUFZLENBQUM7d0JBRWpDLElBQUksQ0FBQyxNQUFNLEVBQUU7NEJBQ1gsc0JBQU87eUJBQ1I7d0JBRUssS0FBc0IsSUFBSSxDQUFDLE9BQU8sRUFBaEMsT0FBTyxhQUFBLEVBQUUsTUFBTSxZQUFBLENBQWtCO3dCQUV6QyxTQUFTO3dCQUNULElBQUksTUFBTSxJQUFJLE1BQU0sQ0FBQyxNQUFNLENBQUMsRUFBRTs0QkFDNUIsSUFBSSxDQUFDLFVBQVUsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUM7NEJBQ2pDLElBQUksQ0FBQyxJQUFJLENBQ1AsaUJBQWlCLENBQUMsY0FBYyxFQUNoQyxJQUFJLENBQUMsT0FBTyxFQUNaLElBQUksQ0FBQyxVQUFVLENBQ2hCLENBQUM7eUJBQ0g7d0JBRUQsSUFBSSxDQUFDLFlBQVk7NEJBQ2YsTUFBTSxDQUFDLFlBQVksSUFBSSxJQUFJLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxZQUFZLENBQUM7d0JBQ3hFLElBQUksQ0FBQyxlQUFlLEdBQUcsTUFBTSxDQUFDLGVBQWUsSUFBSSxJQUFJLENBQUMsZUFBZSxDQUFDO3dCQUN0RSxJQUFJLENBQUMsVUFBVSxHQUFHLE1BQU0sQ0FBQyxVQUFVLElBQUksSUFBSSxDQUFDLFVBQVUsQ0FBQzt3QkFFakQsU0FBUyxHQUFlLE9BQU8sSUFBSSxNQUFNLENBQUMsT0FBTyxDQUFDLENBQUM7d0JBRXpELElBQUksQ0FBQyxTQUFTLEVBQUU7NEJBQ2Qsc0JBQU87eUJBQ1I7d0JBR0MsT0FBTyxHQU1MLFNBQVMsUUFOSixFQUNQLFNBQVMsR0FLUCxTQUFTLFVBTEYsRUFDVCxhQUFhLEdBSVgsU0FBUyxjQUpFLEVBQ2IsWUFBWSxHQUdWLFNBQVMsYUFIQyxFQUNaLGVBQWUsR0FFYixTQUFTLGdCQUZJLEVBQ2YsVUFBVSxHQUNSLFNBQVMsV0FERCxDQUNFO3dCQUVkLElBQUksZUFBZSxFQUFFOzRCQUNuQixJQUFJLENBQUMsWUFBWSxHQUFHLENBQUMsQ0FBQyxZQUFZLENBQUM7NEJBQ25DLElBQUksQ0FBQyxlQUFlLEdBQUcsZUFBZSxDQUFDO3lCQUN4Qzt3QkFFRCxJQUFJLFVBQVUsRUFBRTs0QkFDZCxJQUFJLENBQUMsVUFBVSxHQUFHLFVBQVUsQ0FBQzt5QkFDOUI7d0JBRUQsZ0JBQWdCO3dCQUNoQixJQUFJLElBQUksQ0FBQyxVQUFVLElBQUksU0FBUyxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsRUFBRTs0QkFDakQsSUFBSSxDQUFDLFlBQVksR0FBRyxJQUFJLENBQUM7NEJBQ3pCLElBQUksQ0FBQyxlQUFlLEdBQUcsU0FBUyxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQzs0QkFDbEQsc0JBQU87eUJBQ1I7d0JBRUQsa0JBQWtCO3dCQUNsQixJQUFJLE1BQU0sSUFBSSxTQUFTLENBQUMsTUFBTSxDQUFDLEVBQUU7NEJBQy9CLElBQUksQ0FBQyxZQUFZLEdBQUcsSUFBSSxDQUFDOzRCQUN6QixJQUFJLENBQUMsZUFBZSxHQUFHLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBQzs0QkFDekMsc0JBQU87eUJBQ1I7d0JBRUQsSUFBSSxhQUFhLElBQUksSUFBSSxDQUFDLFVBQVUsRUFBRTs0QkFDOUIsR0FBRyxHQUFHLElBQUksTUFBTSxDQUFDLGFBQWEsQ0FBQyxDQUFDOzRCQUN0QyxJQUFJLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLE9BQU8sRUFBRTtnQ0FDeEMsSUFBSSxDQUFDLFlBQVksR0FBRyxJQUFJLENBQUM7Z0NBQ3pCLElBQUksQ0FBQyxlQUFlLEdBQUcsT0FBTyxDQUFDO2dDQUMvQixzQkFBTzs2QkFDUjt5QkFDRjt3QkFFRCxJQUFJLFNBQVMsSUFBSSxNQUFNLEVBQUU7NEJBQ2pCLEdBQUcsR0FBRyxJQUFJLE1BQU0sQ0FBQyxTQUFTLENBQUMsQ0FBQzs0QkFDbEMsSUFBSSxHQUFHLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxRQUFRLEVBQUUsQ0FBQyxJQUFJLE9BQU8sRUFBRTtnQ0FDMUMsSUFBSSxDQUFDLFlBQVksR0FBRyxJQUFJLENBQUM7Z0NBQ3pCLElBQUksQ0FBQyxlQUFlLEdBQUcsT0FBTyxDQUFDO2dDQUMvQixzQkFBTzs2QkFDUjt5QkFDRjs7Ozs7S0FDRjtJQUVPLGlDQUFZLEdBQXBCO1FBQ0UsR0FBRyxDQUFDLGNBQWMsRUFBRTtZQUNsQixZQUFZLEVBQUUsSUFBSSxDQUFDLFlBQVk7WUFDL0IsZUFBZSxFQUFFLElBQUksQ0FBQyxlQUFlO1lBQ3JDLFVBQVUsRUFBRSxJQUFJLENBQUMsVUFBVTtZQUMzQixnQkFBZ0IsRUFBRSxJQUFJLENBQUMsZ0JBQWdCO1lBQ3ZDLGlCQUFpQixFQUFFLElBQUksQ0FBQyxPQUFPLENBQUMsaUJBQWlCO1NBQ2xELENBQUMsQ0FBQztRQUVILElBQUksQ0FBQyxJQUFJLENBQUMsZ0JBQWdCLEVBQUU7WUFDMUIsT0FBTztTQUNSO1FBRUQsU0FBUztRQUNULElBQUksSUFBSSxDQUFDLE9BQU8sQ0FBQyxpQkFBaUIsRUFBRTtZQUNsQyxHQUFHLENBQUMsc0JBQXNCLEVBQUUsSUFBSSxDQUFDLGVBQWUsQ0FBQyxDQUFDO1lBQ2xELE1BQU0sQ0FBQyxPQUFPLENBQUMscUJBQXFCLEVBQUU7Z0JBQ3BDLFlBQVksRUFBRSxJQUFJLENBQUMsWUFBWTtnQkFDL0IsZUFBZSxFQUFFLElBQUksQ0FBQyxlQUFlO2FBQ3RDLENBQUMsQ0FBQztZQUNILE9BQU87U0FDUjtRQUVELElBQUksSUFBSSxDQUFDLGdCQUFnQixLQUFLLElBQUksQ0FBQyxlQUFlLElBQUksSUFBSSxDQUFDLFlBQVksRUFBRTtZQUN2RSxJQUFJLENBQUMsT0FBTyxFQUFFLENBQUM7WUFDZixJQUFJLENBQUMsTUFBTSxHQUFHLFdBQVcsQ0FBQyxVQUFVLENBQUM7WUFDckMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsWUFBWSxFQUFFO2dCQUNqQyxNQUFNLEVBQUUsVUFBVSxDQUFDLG9CQUFvQjthQUN4QyxDQUFDLENBQUM7WUFDSCxPQUFPO1NBQ1I7UUFFRCxJQUNFLElBQUksQ0FBQyxVQUFVO1lBQ2YsSUFBSSxDQUFDLGNBQWMsQ0FBQyxJQUFJLENBQUMsZ0JBQWdCLEVBQUUsSUFBSSxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUNsRTtZQUNBLElBQUksQ0FBQyxlQUFlLEdBQUcsSUFBSSxDQUFDLFVBQVUsQ0FBQztZQUN2QyxJQUFJLENBQUMsT0FBTyxFQUFFLENBQUM7WUFDZixJQUFJLENBQUMsTUFBTSxHQUFHLFdBQVcsQ0FBQyxVQUFVLENBQUM7WUFDckMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsWUFBWSxFQUFFO2dCQUNqQyxNQUFNLEVBQUUsVUFBVSxDQUFDLG9CQUFvQjthQUN4QyxDQUFDLENBQUM7U0FDSjtJQUNILENBQUM7SUFFRDs7OztPQUlHO0lBQ0ssbUNBQWMsR0FBdEIsVUFBdUIsRUFBVSxFQUFFLEVBQVU7UUFDM0MsSUFBTSxJQUFJLEdBQUcsRUFBRSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDekMsSUFBTSxJQUFJLEdBQUcsRUFBRSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7UUFFekMsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEVBQUUsRUFBRTtZQUMxQixJQUFNLElBQUksR0FBRyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUN0QixJQUFNLElBQUksR0FBRyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUV0QixJQUFJLElBQUksR0FBRyxJQUFJLEVBQUU7Z0JBQ2YsT0FBTyxDQUFDLENBQUMsQ0FBQzthQUNYO1lBRUQsSUFBSSxJQUFJLEdBQUcsSUFBSSxFQUFFO2dCQUNmLE9BQU8sQ0FBQyxDQUFDO2FBQ1Y7U0FDRjtRQUVELE9BQU8sQ0FBQyxDQUFDO0lBQ1gsQ0FBQztJQUVPLHNDQUFpQixHQUF6QjtRQUNFLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLG9CQUFvQixFQUFFO1lBQ3RDLE9BQU8sS0FBSyxDQUFDO1NBQ2Q7UUFDRCxJQUFJLE1BQU0sQ0FBQyxPQUFPLENBQUMsMEJBQTBCLENBQUMsRUFBRTtZQUM5QyxNQUFNLENBQUMsSUFBSSxDQUNULElBQUksQ0FBQywwQkFBMEIsRUFDL0IsUUFBUSxFQUNSLHFCQUFxQixDQUN0QixDQUFDO1lBQ0YsT0FBTyxJQUFJLENBQUM7U0FDYjthQUFNO1lBQ0wsT0FBTyxLQUFLLENBQUM7U0FDZDtJQUNILENBQUM7SUFFTyxvQ0FBZSxHQUF2QjtRQUNFLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLGtCQUFrQixFQUFFO1lBQ3BDLE9BQU8sS0FBSyxDQUFDO1NBQ2Q7UUFDRCxJQUNFLE1BQU0sQ0FBQyxPQUFPLENBQUMsK0JBQStCLENBQUMsRUFDL0M7WUFDQSxNQUFNLENBQUMsSUFBSSxDQUNULElBQUksQ0FBQywwQkFBMEIsRUFDL0IsUUFBUSxFQUNSLHFCQUFxQixDQUN0QixDQUFDO1lBQ0YsT0FBTyxJQUFJLENBQUM7U0FDYjthQUFNO1lBQ0wsT0FBTyxLQUFLLENBQUM7U0FDZDtJQUNILENBQUM7SUFDSCxpQkFBQztBQUFELENBQUMsQUF4dkJELENBQWdDLFlBQVksR0F3dkIzQzs7QUFFRCxlQUFlLElBQUksVUFBVSxFQUFFLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgaW8gZnJvbSAnc29ja2V0LmlvLWNsaWVudCc7XG5pbXBvcnQgRXZlbnRFbWl0dGVyIGZyb20gJy4uLy4uL3V0aWxzL0V2ZW50RW1pdHRlcic7XG5pbXBvcnQgeyBnZXRVVUlEIH0gZnJvbSAnLi4vLi4vdXRpbHMvdXVpZCc7XG5pbXBvcnQgbG9nZ2VyIGZyb20gJy4uLy4uL3V0aWxzL2xvZ2dlcic7XG5pbXBvcnQgeyBJTVRPQkdsb2JhbENvbmZpZywgSU1UT0JTREtPcHRpb25zIH0gZnJvbSAnLi4vLi4vdHlwZXMnO1xuaW1wb3J0IHtcbiAgTVRPQl9DTElFTlRfRVZFTlQsXG4gIEVTREtFdmVudHMsXG4gIEVTREtTdGF0dXMsXG4gIEVNVE9CU3RhdHVzLFxufSBmcm9tICcuLi8uLi9jb25zdGFudHMnO1xuaW1wb3J0IHsgQ2xpZW50RXJyb3IgfSBmcm9tICcuL2NvbnN0YW50cyc7XG5pbXBvcnQgQVBJIGZyb20gJy4vYXBpJztcbmltcG9ydCBwa2cgZnJvbSAnLi4vLi4vLi4vcGFja2FnZS5qc29uJztcbmltcG9ydCB7IElQcmludERvd25ncmFkZU9wdGlvbnMgfSBmcm9tICcuLi9wcmludGVyL3YyL3R5cGVzJztcblxuY29uc3QgTVRPQl9TRVJWRVJfSE9TVF9IVFRQID0gJ2h0dHA6Ly9sb2NhbGhvc3Q6JztcbmNvbnN0IE1UT0JfU0VSVkVSX0hPU1RfSFRUUFMgPSAnaHR0cHM6Ly9sb2NhbGhvc3Q6JztcbmNvbnN0IExPQ0FMX1NFUlZFUl9QT1JUUyA9IFsyODYxMywgMjg3MTMsIDI4ODEzXTtcbmNvbnN0IE1BWF9QT0xMSU5HX0NPVU5UID0gMjtcblxuY29uc3QgbG9nID0gKC4uLmFyZ3M6IGFueVtdKSA9PiB7XG4gIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBuby1jb25zb2xlXG4gIGNvbnNvbGUubG9nKCdbTVRPQi1DbGllbnRdICcsIC4uLmFyZ3MpO1xufTtcblxuaW50ZXJmYWNlIElVc2VyQ29uZmlnXG4gIGV4dGVuZHMgRXhjbHVkZTxJUHJpbnREb3duZ3JhZGVPcHRpb25zLCAnbWF4UHJpbnRGYWlsQ291bnQnPiB7XG4gIFtrOiBzdHJpbmddOiBhbnk7XG59XG5cbmludGVyZmFjZSBJQXBwQ29uZmlnIHtcbiAgLy8g5a6i5oi356uv54Gw5bqm54mI5pysXG4gIHZlcnNpb24/OiBzdHJpbmc7XG4gIC8vIOeBsOW6puWMuemFjeeahHVzZXJJZOato+WImVxuICB1c2VySWRSZWc/OiBzdHJpbmc7XG4gIC8vIOeBsOW6puWMuemFjeeahHV1aWTmraPliJlcbiAgY2xpZW50VVVJRFJlZz86IHN0cmluZztcbiAgLy8g5piv5ZCm5by65Yi25Y2H57qn77yI5Lia5Yqh57u05bqm77yJXG4gIGZvcmNlVXBncmFkZT86IGJvb2xlYW47XG4gIC8vIOmcgOimgeeahOWuouaIt+err+eJiOacrO+8iOS4muWKoee7tOW6pu+8iVxuICByZXF1aXJlZFZlcnNpb24/OiBzdHJpbmc7XG4gIC8vIOacgOS9jueahOWuouaIt+err+eJiOacrO+8iOS4muWKoee7tOW6pu+8iVxuICBtaW5WZXJzaW9uPzogc3RyaW5nO1xuICAvLyBrZXnkuLp1c2VySWTmiJZ1dWlkIHZhbHVl5Li65a6i5oi356uv54mI5pys5Y+3XG4gIFt1c2VySWRPckNsaWVudFVVSUQ6IHN0cmluZ106IGFueTtcbn1cblxuaW50ZXJmYWNlIElSZW1vdGVDb25maWcge1xuICBmb3JjZVVwZ3JhZGU6IGJvb2xlYW47XG4gIHJlcXVpcmVkVmVyc2lvbjogc3RyaW5nO1xuICBbYXBwTmFtZU9yVXNlcklkOiBzdHJpbmddOiBhbnk7XG59XG5cbmV4cG9ydCBjbGFzcyBNVE9CQ2xpZW50IGV4dGVuZHMgRXZlbnRFbWl0dGVyIHtcbiAgc3RhdHVzID0gRU1UT0JTdGF0dXMuRGlzY29ubmVjdGVkO1xuICByZXF1ZXN0SUQgPSBnZXRVVUlEKCk7XG4gIHJlcXVlc3RWZXJzaW9uID0gJzEuMCc7XG5cbiAgbWFuYWdlcjogYW55O1xuICBzb2NrZXQ6IGFueTtcbiAgZmFpbENvdW50ID0gMDtcbiAgcmV0cnlJbmRleCA9IDA7XG4gIGF1dG9Db25uZWN0ID0gdHJ1ZTtcbiAgcG9ydCA9IC0xOyAvLyDlvZPliY3ov57mjqXnq6/lj6NcblxuICBmb3JjZVVwZ3JhZGUgPSBmYWxzZTtcbiAgcmVxdWlyZWRWZXJzaW9uID0gJyc7XG4gIG1pblZlcnNpb24gPSAnJztcbiAgY29ubmVjdGVkVmVyc2lvbiA9ICcnO1xuICBjbGllbnRVVUlEID0gJyc7XG4gIGNsaWVudFR5cGU6ICdWMScgfCAnVjInID0gJ1YyJztcbiAgY2xpZW50R2xvYmFsQ29uZmlnOiBJTVRPQkdsb2JhbENvbmZpZyB8IG51bGwgPSBudWxsO1xuXG4gIG9wdGlvbnM6IFBhcnRpYWw8SU1UT0JTREtPcHRpb25zPiA9IHt9O1xuXG4gIHJlbW90ZUNvbmZpZzogSVJlbW90ZUNvbmZpZyB8IG51bGwgPSBudWxsO1xuXG4gIHVzZXJDb25maWc6IElVc2VyQ29uZmlnIHwgbnVsbCA9IG51bGw7XG5cbiAgZ2V0IGlzUHJvZCgpIHtcbiAgICBjb25zdCBlbnYgPSB0aGlzLm9wdGlvbnMgJiYgdGhpcy5vcHRpb25zLmVudjtcbiAgICByZXR1cm4gZW52ID09PSAncHJvZHVjdGlvbicgfHwgZW52ID09PSAnc3RhZ2luZyc7XG4gIH1cblxuICBwcml2YXRlIGdldCBzb2NrZXRVUkkoKSB7XG4gICAgY29uc3QgaG9zdCA9IHRoaXMuaXNQcm9kID8gTVRPQl9TRVJWRVJfSE9TVF9IVFRQUyA6IE1UT0JfU0VSVkVSX0hPU1RfSFRUUDtcbiAgICByZXR1cm4gYCR7aG9zdH0ke3RoaXMucG9ydH1gO1xuICB9XG5cbiAgcHJpdmF0ZSBnZXQgZG93bmxvYWRVUkwoKSB7XG4gICAgY29uc3QgZW52ID0gdGhpcy5pc1Byb2QgPyAncHJvZCcgOiAndGVzdCc7XG4gICAgcmV0dXJuIGBodHRwczovL3BvcnRhbC1wb3J0bS5tZWl0dWFuLmNvbS9rbGZlL210b2IvJHtlbnZ9L2Rvd25sb2FkQ29uZmlnYDtcbiAgfVxuXG4gIHByaXZhdGUgZ2V0IHJlcXVpcmVkVmVyc2lvbkRvd25sb2FkVVJMKCkge1xuICAgIHJldHVybiB0aGlzLmRvd25sb2FkVVJMICsgJz92ZXJzaW9uPScgKyB0aGlzLnJlcXVpcmVkVmVyc2lvbjtcbiAgfVxuXG4gIGluaXQob3B0aW9uczogSU1UT0JTREtPcHRpb25zKSB7XG4gICAgaWYgKCFvcHRpb25zIHx8ICFvcHRpb25zLmFwcE5hbWUpIHtcbiAgICAgIHRocm93IENsaWVudEVycm9yLkNMSUVOVF9PUFRJT05TX0VSUk9SO1xuICAgIH1cblxuICAgIHRoaXMub3B0aW9ucyA9IG9wdGlvbnMgfHwge307XG5cbiAgICB0aGlzLnNldENvbmZpZyh0aGlzLm9wdGlvbnMpO1xuXG4gICAgbG9nZ2VyLmluaXQoe1xuICAgICAgYXBwTmFtZTogdGhpcy5vcHRpb25zLmFwcE5hbWUsXG4gICAgICB1c2VySWQ6IHRoaXMub3B0aW9ucy51c2VySWQsXG4gICAgICBlbnY6IHRoaXMub3B0aW9ucy5lbnYsXG4gICAgICBleHRyYUFwcEluZm86IHRoaXMub3B0aW9ucy5leHRyYUFwcEluZm8sXG4gICAgfSk7XG5cbiAgICB0aGlzLnVwZGF0ZVVwZ3JhZGVDb25maWcoKS50aGVuKCgpID0+IHtcbiAgICAgIGxvZygndXBkYXRlVXBncmFkZUNvbmZpZyByZXMnLCB7XG4gICAgICAgIGZvcmNlVXBncmFkZTogdGhpcy5mb3JjZVVwZ3JhZGUsXG4gICAgICAgIHJlcXVpcmVkVmVyc2lvbjogdGhpcy5yZXF1aXJlZFZlcnNpb24sXG4gICAgICAgIG1pblZlcnNpb246IHRoaXMubWluVmVyc2lvbixcbiAgICAgIH0pO1xuICAgIH0pO1xuXG4gICAgdGhpcy5jb25uZWN0KCk7XG4gIH1cblxuICBmaW5pc2goKSB7XG4gICAgdGhpcy5zdG9wQXV0b1JlY29ubmVjdCgpO1xuICB9XG5cbiAgcHJpdmF0ZSBjb25uZWN0KCkge1xuICAgIGlmICh0aGlzLnN0YXR1cyA9PT0gRU1UT0JTdGF0dXMuQ29ubmVjdGVkKSB7XG4gICAgICB0aGlzLm5vdGlmeUNvbm5lY3RlZCgpO1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGlmIChcbiAgICAgIHRoaXMuc3RhdHVzID09PSBFTVRPQlN0YXR1cy5Db25uZWN0aW5nIHx8XG4gICAgICB0aGlzLnN0YXR1cyA9PT0gRU1UT0JTdGF0dXMuTmVlZFVwZGF0ZVxuICAgICkge1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIHRoaXMuc3RhdHVzID0gRU1UT0JTdGF0dXMuQ29ubmVjdGluZztcblxuICAgIHRoaXMucG9sbCgpO1xuICB9XG5cbiAgcHJpdmF0ZSBwb2xsKCkge1xuICAgIGlmICghdGhpcy5hdXRvQ29ubmVjdCkge1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGlmICh0aGlzLm9wdGlvbnMucG9ydE51bSAmJiB0aGlzLm9wdGlvbnMucG9ydE51bSA+IDApIHtcbiAgICAgIC8vIOaJi+WKqOiuvue9rueahOerr+WPo+WPt1xuICAgICAgdGhpcy5wb3J0ID0gdGhpcy5vcHRpb25zLnBvcnROdW07XG4gICAgfSBlbHNlIGlmIChwYXJzZUludChsb2NhbFN0b3JhZ2UuZ2V0SXRlbSgnbXRvYl9wb3J0JykgfHwgJy0xJykgPiAtMSkge1xuICAgICAgLy8g5a2Y5YKo55qE56uv5Y+j5Y+3XG4gICAgICB0aGlzLnBvcnQgPSBwYXJzZUludChsb2NhbFN0b3JhZ2UuZ2V0SXRlbSgnbXRvYl9wb3J0JykgYXMgc3RyaW5nKTtcbiAgICB9IGVsc2Uge1xuICAgICAgdGhpcy5wb3J0ID0gTE9DQUxfU0VSVkVSX1BPUlRTW3RoaXMucmV0cnlJbmRleF07XG4gICAgICB0aGlzLnJldHJ5SW5kZXggPSAodGhpcy5yZXRyeUluZGV4ICsgMSkgJSBMT0NBTF9TRVJWRVJfUE9SVFMubGVuZ3RoO1xuICAgIH1cblxuICAgIGxvZygndHJ5aW5nIHRvIGNvbm5lY3QgcG9ydDogJywgdGhpcy5wb3J0KTtcblxuICAgIHRoaXMubWFuYWdlciA9IG5ldyBpby5NYW5hZ2VyKHRoaXMuc29ja2V0VVJJLCB7XG4gICAgICByZWNvbm5lY3Rpb246IGZhbHNlLFxuICAgICAgcmVqZWN0VW5hdXRob3JpemVkOiBmYWxzZSxcbiAgICB9KTtcblxuICAgIHRoaXMuc29ja2V0ID0gdGhpcy5tYW5hZ2VyLnNvY2tldCgnLycpO1xuICAgIHRoaXMubWFuYWdlci5jb25uZWN0KCk7XG5cbiAgICB0aGlzLm1hbmFnZXIub24oJ2Vycm9yJywgKCkgPT4gdGhpcy5vblNvY2tldENvbm5lY3Rpb25FcnJvcigpKTtcbiAgICB0aGlzLnNvY2tldC5vbignY29ubmVjdCcsICgpID0+IHRoaXMub25Tb2NrZXRDb25uZWN0ZWQoKSk7XG4gICAgdGhpcy5zb2NrZXQub24oJ2Rpc2Nvbm5lY3QnLCAocmVhc29uOiBzdHJpbmcpID0+XG4gICAgICB0aGlzLm9uU29ja2V0RGlzY29ubmVjdGVkKHJlYXNvbilcbiAgICApO1xuICB9XG5cbiAgcHJpdmF0ZSBvblNvY2tldENvbm5lY3Rpb25FcnJvcigpIHtcbiAgICB0aGlzLnNvY2tldC5jbG9zZSgpO1xuICAgIHRoaXMuc29ja2V0LnJlbW92ZUFsbExpc3RlbmVycygpO1xuICAgIHRoaXMubWFuYWdlci5fY2xvc2UoKTtcbiAgICB0aGlzLmZhaWxDb3VudCsrO1xuXG4gICAgLy8g5omA5pyJ56uv5Y+j5bCd6K+V5LiA6L2u5Z2H5aSx6LSl5ZCO77yM5aaC5p6cYXV0b0xhdW5jaOWImeWwneivleWUpOi1t++8jOWQpuWImeaPkOekuui/nuaOpei2heaXtlxuICAgIGlmICh0aGlzLmZhaWxDb3VudCA9PSBMT0NBTF9TRVJWRVJfUE9SVFMubGVuZ3RoKSB7XG4gICAgICBpZiAodGhpcy5vcHRpb25zLmF1dG9MYXVuY2ggPT09IGZhbHNlKSB7XG4gICAgICAgIHRoaXMuZW1pdChFU0RLRXZlbnRzLlN0YXR1c0NoYW5nZSwgeyBzdGF0dXM6IEVTREtTdGF0dXMuRVJST1IgfSk7XG4gICAgICAgIHRoaXMuc2hvd0Rvd25sb2FkQWxlcnQoKTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHRoaXMubGF1bmNoTVRPQigpO1xuICAgICAgfVxuICAgIH1cblxuICAgIC8vIOWksei0pU1BWF9QT0xMSU5HX0NPVU5U6L2u5ZCO77yM5o+Q56S66L+e5o6l6LaF5pe2XG4gICAgaWYgKHRoaXMuZmFpbENvdW50ID09PSBMT0NBTF9TRVJWRVJfUE9SVFMubGVuZ3RoICogTUFYX1BPTExJTkdfQ09VTlQpIHtcbiAgICAgIC8vIGF1dG9MYXVuY2ggPT09IGZhbHNlIOaDheWGteS4i++8jOerr+WPo+WwneivleS4gOi9ruWdh+Wksei0peWQjuS8muacieS4gOasoeaPkOekuu+8jOi/memHjOS4jeWGjeaPkOekulxuICAgICAgaWYgKHRoaXMub3B0aW9ucy5hdXRvTGF1bmNoICE9PSBmYWxzZSkge1xuICAgICAgICB0aGlzLmVtaXQoRVNES0V2ZW50cy5TdGF0dXNDaGFuZ2UsIHsgc3RhdHVzOiBFU0RLU3RhdHVzLkVSUk9SIH0pO1xuICAgICAgICB0aGlzLnNob3dEb3dubG9hZEFsZXJ0KCk7XG4gICAgICB9XG4gICAgfVxuXG4gICAgc2V0VGltZW91dCgoKSA9PiB0aGlzLnBvbGwoKSwgMjAwMCk7XG4gIH1cblxuICBwcml2YXRlIGFzeW5jIG9uU29ja2V0Q29ubmVjdGVkKCkge1xuICAgIGxvZygnY29ubmVjdGVkOiAnLCB0aGlzLnBvcnQpO1xuXG4gICAgYXdhaXQgdGhpcy5hdXRoZW50aWNhdGUodGhpcy5zb2NrZXQuaWQpLmNhdGNoKChlcnJvcikgPT4ge1xuICAgICAgbG9nKCdhdXRoZW50aWNhdGUgZXJyb3I6ICcsIGVycm9yKTtcbiAgICAgIHRoaXMuc29ja2V0LmNsb3NlKCk7XG4gICAgfSk7XG5cbiAgICB0aGlzLmdldENsaWVudEluZm8oKTtcbiAgfVxuXG4gIHByaXZhdGUgb25Tb2NrZXREaXNjb25uZWN0ZWQocmVhc29uOiBzdHJpbmcpIHtcbiAgICBsb2coJ2Rpc2Nvbm5lY3RlZDogJywgdGhpcy5wb3J0LCByZWFzb24pO1xuICAgIHRoaXMuc29ja2V0LmNsb3NlKCk7XG4gICAgdGhpcy5zb2NrZXQucmVtb3ZlQWxsTGlzdGVuZXJzKCk7XG4gICAgdGhpcy5jb25uZWN0ZWRWZXJzaW9uID0gJyc7XG4gICAgdGhpcy5zdGF0dXMgPSBFTVRPQlN0YXR1cy5EaXNjb25uZWN0ZWQ7XG4gICAgdGhpcy5lbWl0KE1UT0JfQ0xJRU5UX0VWRU5ULkRJU0NPTk5FQ1QpO1xuICAgIHRoaXMuZW1pdChFU0RLRXZlbnRzLlN0YXR1c0NoYW5nZSwgeyBzdGF0dXM6IEVTREtTdGF0dXMuRElTQ09OTkVDVEVEIH0pO1xuICAgIHRoaXMuY29ubmVjdCgpO1xuICB9XG5cbiAgc2V0Q29uZmlnKG9wdGlvbnM6IFBhcnRpYWw8SU1UT0JTREtPcHRpb25zPikge1xuICAgIHRoaXMub3B0aW9ucyA9IHtcbiAgICAgIC4uLih0aGlzLm9wdGlvbnMgfHwge30pLFxuICAgICAgLi4uKG9wdGlvbnMgfHwge30pLFxuICAgIH07XG5cbiAgICBsb2coJ3NldENvbmZpZzogJywgdGhpcy5vcHRpb25zKTtcblxuICAgIHRoaXMuZW1pdChNVE9CX0NMSUVOVF9FVkVOVC5PUFRJT05TX1VQREFURSwgdGhpcy5vcHRpb25zLCB0aGlzLnVzZXJDb25maWcpO1xuXG4gICAgaWYgKG9wdGlvbnMucG9ydE51bSkge1xuICAgICAgbG9jYWxTdG9yYWdlLnNldEl0ZW0oXG4gICAgICAgICdtdG9iX3BvcnQnLFxuICAgICAgICBvcHRpb25zLnBvcnROdW0gPT09IC0xID8gJycgOiBgJHtvcHRpb25zLnBvcnROdW19YFxuICAgICAgKTtcbiAgICAgIGlmICh0aGlzLnBvcnQgIT09IG9wdGlvbnMucG9ydE51bSkge1xuICAgICAgICB0aGlzLnNvY2tldC5jbG9zZSgpO1xuICAgICAgICB0aGlzLmNvbm5lY3QoKTtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICBsYXVuY2hNVE9CKCkge1xuICAgIGNvbnN0IHVyaSA9ICdtdG9iJyArIHRoaXMucmVxdWlyZWRWZXJzaW9uICsgJzovL2hvbWU/ZnJvbT13ZWInO1xuICAgIHRyeSB7XG4gICAgICB3aW5kb3cubG9jYXRpb24uaHJlZiA9IHVyaTtcbiAgICB9IGNhdGNoIHtcbiAgICAgIGxvZyhgTVRPQiBsYXVuY2ggZmFpbGVkOiAke3VyaX1gKTtcbiAgICAgIGxvZ2dlci5sb2dXYXJuaW5nKCdNVE9CIGxhdW5jaCBmYWlsZWQnLCB7IHVyaSB9KTtcbiAgICB9XG4gIH1cblxuICBnZXRNVE9CSW5mbygpIHtcbiAgICByZXR1cm4ge1xuICAgICAgc3RhdHVzOiB0aGlzLnN0YXR1cyxcbiAgICAgIHJlcXVpcmVkTVRPQlZlcnNpb246IHRoaXMucmVxdWlyZWRWZXJzaW9uLFxuICAgICAgY3VycmVudE1UT0JWZXJzaW9uOiB0aGlzLmNvbm5lY3RlZFZlcnNpb24sXG4gICAgICBkb3dubG9hZFVSTDogdGhpcy5kb3dubG9hZFVSTCxcbiAgICAgIHJlcXVpcmVkVmVyc2lvbkRvd25sb2FkVVJMOiB0aGlzLnJlcXVpcmVkVmVyc2lvbkRvd25sb2FkVVJMLFxuICAgICAgY2xpZW50VHlwZTogdGhpcy5jbGllbnRUeXBlLFxuICAgIH07XG4gIH1cblxuICBnZXRHbG9iYWxDb25maWcoKSB7XG4gICAgaWYgKHRoaXMuY2xpZW50VHlwZSAhPT0gJ1YyJykge1xuICAgICAgcmV0dXJuIFByb21pc2UucmVzb2x2ZShudWxsKTtcbiAgICB9XG5cbiAgICByZXR1cm4gdGhpcy5yZXVxZXN0KEFQSS5HRVRfR0xPQkFMX0NPTkZJRylcbiAgICAgIC50aGVuKGFzeW5jIChyZXM6IGFueSkgPT4ge1xuICAgICAgICBsb2coJ2dldCBWMiBnbG9iYWwgY29uZmlnOiAnLCByZXMpO1xuICAgICAgICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzXG4gICAgICAgIGNvbnN0IHsgY21kLCByZXF1ZXN0SUQsIHN0YXR1cywgY29kZSwgLi4uZGF0YSB9ID0gcmVzO1xuICAgICAgICB0aGlzLmNsaWVudEdsb2JhbENvbmZpZyA9IGRhdGEgYXMgSU1UT0JHbG9iYWxDb25maWc7XG4gICAgICAgIHJldHVybiBkYXRhO1xuICAgICAgfSlcbiAgICAgIC5jYXRjaCgoZXJyKSA9PiB7XG4gICAgICAgIGxvZygnZ2V0IFYyIGdsb2JhbCBjb25maWcgZXJyb3I6ICcsIGVycik7XG4gICAgICAgIHRoaXMuY2xpZW50R2xvYmFsQ29uZmlnID0gbnVsbDtcbiAgICAgICAgcmV0dXJuIG51bGw7XG4gICAgICB9KTtcbiAgfVxuXG4gIHNldEdsb2JhbENvbmZpZyhjb25maWc6IFBhcnRpYWw8SU1UT0JHbG9iYWxDb25maWc+KSB7XG4gICAgaWYgKHRoaXMuY2xpZW50VHlwZSAhPT0gJ1YyJykge1xuICAgICAgcmV0dXJuIFByb21pc2UucmVzb2x2ZSgpO1xuICAgIH1cblxuICAgIHJldHVybiB0aGlzLnJldXFlc3QoQVBJLlNFVF9HTE9CQUxfQ09ORklHLCB7XG4gICAgICBwZW5kaW5nVGFza0xpbWl0OiA1MDAsXG4gICAgICBwcmludEhpc3RvcnlTYXZlSG91cnM6IDEyLFxuICAgICAgbm90aWZ5T25UYXNrRmFpbHVyZTogdHJ1ZSxcbiAgICAgIC4uLih0aGlzLmNsaWVudEdsb2JhbENvbmZpZyB8fCB7fSksXG4gICAgICAuLi4oY29uZmlnIHx8IHt9KSxcbiAgICB9KVxuICAgICAgLnRoZW4oYXN5bmMgKHJlcykgPT4ge1xuICAgICAgICBsb2coJ3NldCBWMiBnbG9iYWwgY29uZmlnOiAnLCByZXMpO1xuICAgICAgICB0aGlzLmdldEdsb2JhbENvbmZpZygpO1xuICAgICAgfSlcbiAgICAgIC5jYXRjaCgoZXJyKSA9PiB7XG4gICAgICAgIGxvZygnc2V0IFYyIGdsb2JhbCBjb25maWcgZXJyb3I6ICcsIGVycik7XG4gICAgICAgIHRoaXMuZ2V0R2xvYmFsQ29uZmlnKCk7XG4gICAgICB9KTtcbiAgfVxuXG4gIHNldENhdExvZ2dlcihpbnN0YW5jZTogYW55KSB7XG4gICAgbG9nZ2VyLnNldExvZ2dlcihpbnN0YW5jZSk7XG4gIH1cblxuICBpcGMoYWN0aW9uOiBzdHJpbmcsIGRhdGE6IGFueSwgY2FsbGJhY2s/OiBhbnkpIHtcbiAgICBpZiAoXG4gICAgICAhdGhpcy5zb2NrZXQgfHxcbiAgICAgICF0aGlzLnNvY2tldC50b2tlbiB8fFxuICAgICAgdGhpcy5zb2NrZXQuZGlzY29ubmVjdGVkIHx8XG4gICAgICB0aGlzLnN0YXR1cyA9PT0gRU1UT0JTdGF0dXMuRGlzY29ubmVjdGVkXG4gICAgKSB7XG4gICAgICBsb2dnZXIubG9nV2FybmluZygnW1YxXSBBUEkgQ2FsbCBSZWplY3QgU2VydmVyIENvbm5lY3Rpb24gRmFpbGVkJyk7XG4gICAgICB0aGlzLmVtaXQoRVNES0V2ZW50cy5TdGF0dXNDaGFuZ2UsIHsgc3RhdHVzOiBFU0RLU3RhdHVzLkVSUk9SIH0pO1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGlmICh0aGlzLnN0YXR1cyA9PT0gRU1UT0JTdGF0dXMuTmVlZFVwZGF0ZSkge1xuICAgICAgdGhpcy5lbWl0KEVTREtFdmVudHMuU3RhdHVzQ2hhbmdlLCB7XG4gICAgICAgIHN0YXR1czogRVNES1N0YXR1cy5NVE9CX1VQREFURV9SRVFVSVJFRCxcbiAgICAgIH0pO1xuICAgICAgbG9nZ2VyLmxvZ1dhcm5pbmcoJ1tWMV0gQVBJIENhbGwgUmVqZWN0IFNlcnZlciBVcGRhdGUgUmVxdWlyZWQnKTtcbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICBsb2dnZXIubG9nSW5mbygnW1YxXSBBUEkgUmVxdWVzdCcsIHsgYWN0aW9uIH0pO1xuXG4gICAgY29uc3Qgc3RhcnRUaW1lID0gbmV3IERhdGUoKS5nZXRUaW1lKCk7XG4gICAgdGhpcy5zb2NrZXQuZW1pdChcbiAgICAgICdNVE9CX01TRycsXG4gICAgICB7XG4gICAgICAgIGFjdGlvbixcbiAgICAgICAgZGF0YSxcbiAgICAgICAgdG9rZW46IHRoaXMuc29ja2V0LnRva2VuLFxuICAgICAgfSxcbiAgICAgIChyZXM6IGFueSkgPT4ge1xuICAgICAgICBpZiAoIXJlcy5zdGF0dXNDb2RlKSB7XG4gICAgICAgICAgbG9nZ2VyLmxvZ0luZm8oJ1tWMV0gQVBJIFJlc3BvbnNlIEZhaWxlZCcsIHtcbiAgICAgICAgICAgIGFjdGlvbixcbiAgICAgICAgICAgIHBhcmFtczogZGF0YSxcbiAgICAgICAgICAgIHJlcyxcbiAgICAgICAgICAgIGRlbGF5OiBuZXcgRGF0ZSgpLmdldFRpbWUoKSAtIHN0YXJ0VGltZSxcbiAgICAgICAgICB9KTtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICBsb2dnZXIubG9nSW5mbygnW1YxXSBBUEkgUmVzcG9uc2UgU3VjY2VzcycsIHtcbiAgICAgICAgICAgIGFjdGlvbixcbiAgICAgICAgICAgIHBhcmFtczogYWN0aW9uICE9PSAncHJpbnRlci9wcmludCcgPyBkYXRhIDogdW5kZWZpbmVkLFxuICAgICAgICAgICAgcmVzLFxuICAgICAgICAgICAgZGVsYXk6IG5ldyBEYXRlKCkuZ2V0VGltZSgpIC0gc3RhcnRUaW1lLFxuICAgICAgICAgIH0pO1xuICAgICAgICB9XG4gICAgICAgIGNhbGxiYWNrICYmIGNhbGxiYWNrKHJlcyk7XG4gICAgICB9XG4gICAgKTtcbiAgfVxuXG4gIGlwY09uKGV2ZW50OiBzdHJpbmcsIGNhbGxiYWNrOiAoZGF0YTogYW55KSA9PiBhbnkpIHtcbiAgICBpZiAoXG4gICAgICAhdGhpcy5zb2NrZXQgfHxcbiAgICAgIHRoaXMuc29ja2V0LmRpc2Nvbm5lY3RlZCB8fFxuICAgICAgdGhpcy5zdGF0dXMgPT09IEVNVE9CU3RhdHVzLkRpc2Nvbm5lY3RlZFxuICAgICkge1xuICAgICAgdGhpcy5lbWl0KEVTREtFdmVudHMuU3RhdHVzQ2hhbmdlLCB7IHN0YXR1czogRVNES1N0YXR1cy5FUlJPUiB9KTtcbiAgICAgIHJldHVybjtcbiAgICB9XG4gICAgdGhpcy5zb2NrZXQub24oZXZlbnQsIGNhbGxiYWNrKTtcbiAgfVxuXG4gIGlwY09mZihldmVudDogYW55KSB7XG4gICAgaWYgKCF0aGlzLnNvY2tldCkgcmV0dXJuO1xuICAgIHRoaXMuc29ja2V0Lm9mZihldmVudCk7XG4gIH1cblxuICByZXVxZXN0KGNtZDogc3RyaW5nLCBwYXJhbXM/OiBhbnkpOiBQcm9taXNlPGFueT4ge1xuICAgIGlmIChcbiAgICAgICF0aGlzLnNvY2tldCB8fFxuICAgICAgIXRoaXMuc29ja2V0LnRva2VuIHx8XG4gICAgICB0aGlzLnNvY2tldC5kaXNjb25uZWN0ZWQgfHxcbiAgICAgIHRoaXMuc3RhdHVzID09PSBFTVRPQlN0YXR1cy5EaXNjb25uZWN0ZWRcbiAgICApIHtcbiAgICAgIGxvZ2dlci5sb2dXYXJuaW5nKCdBUEkgQ2FsbCBSZWplY3QgU2VydmVyIENvbm5lY3Rpb24gRmFpbGVkJyk7XG4gICAgICB0aGlzLmVtaXQoRVNES0V2ZW50cy5TdGF0dXNDaGFuZ2UsIHsgc3RhdHVzOiBFU0RLU3RhdHVzLkVSUk9SIH0pO1xuICAgICAgcmV0dXJuIFByb21pc2UucmVqZWN0KCk7XG4gICAgfVxuXG4gICAgaWYgKHRoaXMuc3RhdHVzID09PSBFTVRPQlN0YXR1cy5OZWVkVXBkYXRlKSB7XG4gICAgICB0aGlzLmVtaXQoRVNES0V2ZW50cy5TdGF0dXNDaGFuZ2UsIHtcbiAgICAgICAgc3RhdHVzOiBFU0RLU3RhdHVzLk1UT0JfVVBEQVRFX1JFUVVJUkVELFxuICAgICAgfSk7XG4gICAgICBsb2dnZXIubG9nV2FybmluZygnQVBJIENhbGwgUmVqZWN0IFNlcnZlciBVcGRhdGUgUmVxdWlyZWQnKTtcbiAgICAgIHJldHVybiBQcm9taXNlLnJlamVjdCgpO1xuICAgIH1cblxuICAgIGxvZ2dlci5sb2dJbmZvKCdBUEkgUmVxdWVzdCcsIHsgY21kIH0pO1xuXG4gICAgY29uc3Qgc3RhcnRUaW1lID0gbmV3IERhdGUoKS5nZXRUaW1lKCk7XG4gICAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlLCByZWplY3QpID0+IHtcbiAgICAgIHRoaXMuc29ja2V0LnNlbmQoXG4gICAgICAgIHtcbiAgICAgICAgICBjbWQsXG4gICAgICAgICAgcmVxdWVzdElEOiBnZXRVVUlEKCksXG4gICAgICAgICAgdmVyc2lvbjogdGhpcy5yZXF1ZXN0VmVyc2lvbixcbiAgICAgICAgICAuLi4ocGFyYW1zIHx8IHt9KSxcbiAgICAgICAgfSxcbiAgICAgICAgKHJlczogYW55KSA9PiB7XG4gICAgICAgICAgaWYgKHJlcyAmJiByZXMuc3RhdHVzID09PSAnc3VjY2VzcycpIHtcbiAgICAgICAgICAgIGxvZ2dlci5sb2dJbmZvKCdBUEkgUmVzcG9uc2UgU3VjY2VzcycsIHtcbiAgICAgICAgICAgICAgY21kLFxuICAgICAgICAgICAgICBwYXJhbXM6IGNtZCAhPT0gJ3ByaW50JyA/IHBhcmFtcyA6IHVuZGVmaW5lZCxcbiAgICAgICAgICAgICAgcmVzLFxuICAgICAgICAgICAgICBkZWxheTogbmV3IERhdGUoKS5nZXRUaW1lKCkgLSBzdGFydFRpbWUsXG4gICAgICAgICAgICB9KTtcbiAgICAgICAgICAgIHJlc29sdmUocmVzKTtcbiAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgbG9nZ2VyLmxvZ0luZm8oJ0FQSSBSZXNwb25zZSBGYWlsZWQnLCB7XG4gICAgICAgICAgICAgIGNtZCxcbiAgICAgICAgICAgICAgcGFyYW1zLFxuICAgICAgICAgICAgICByZXMsXG4gICAgICAgICAgICAgIGRlbGF5OiBuZXcgRGF0ZSgpLmdldFRpbWUoKSAtIHN0YXJ0VGltZSxcbiAgICAgICAgICAgIH0pO1xuICAgICAgICAgICAgcmVqZWN0KHJlcyk7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICApO1xuICAgIH0pO1xuICB9XG5cbiAgcHJpdmF0ZSBzdG9wQXV0b1JlY29ubmVjdCgpIHtcbiAgICB0aGlzLmF1dG9Db25uZWN0ID0gZmFsc2U7XG4gIH1cblxuICBwcml2YXRlIG5vdGlmeUNvbm5lY3RlZCgpIHtcbiAgICB0aGlzLnN0YXR1cyA9IEVNVE9CU3RhdHVzLkNvbm5lY3RlZDtcbiAgICB0aGlzLmVtaXQoTVRPQl9DTElFTlRfRVZFTlQuQ09OTkVDVCwgdGhpcy5jbGllbnRUeXBlLCB0aGlzLm9wdGlvbnMpO1xuICAgIHRoaXMuZW1pdChFU0RLRXZlbnRzLlN0YXR1c0NoYW5nZSwgeyBzdGF0dXM6IEVTREtTdGF0dXMuUkVBRFkgfSk7XG4gIH1cblxuICAvLyDpibTmnYNcbiAgcHJpdmF0ZSBhdXRoZW50aWNhdGUoc29ja2V0SWQ6IHN0cmluZykge1xuICAgIHJldHVybiBmZXRjaCh0aGlzLnNvY2tldFVSSSArIEFQSS5BVVRIRU5USUNBVEUgKyAnP3NvY2tldElkPScgKyBzb2NrZXRJZClcbiAgICAgIC50aGVuKChyZXMpID0+IHJlcy5qc29uKCkpXG4gICAgICAudGhlbigocmVzOiBhbnkpID0+IHtcbiAgICAgICAgbG9nKCdhdXRoZW50aWNhdGUgcmVzOiAnLCByZXMpO1xuICAgICAgICB0aGlzLnNvY2tldC50b2tlbiA9IHJlcy50b2tlbjtcbiAgICAgICAgdGhpcy5jbGllbnRUeXBlID0gcmVzLlYyID8gJ1YyJyA6ICdWMSc7XG5cbiAgICAgICAgaWYgKHJlcz8udG9rZW4pIHtcbiAgICAgICAgICB0aGlzLmNsaWVudFVVSUQgPSByZXMudG9rZW47XG4gICAgICAgICAgbG9nZ2VyLnNldFVVSUQodGhpcy5jbGllbnRVVUlEKTtcbiAgICAgICAgfVxuXG4gICAgICAgIGlmIChyZXM/LnZlcnNpb24pIHtcbiAgICAgICAgICB0aGlzLmNvbm5lY3RlZFZlcnNpb24gPSByZXMudmVyc2lvbjtcbiAgICAgICAgICBsb2dnZXIuc2V0Q2xpZW50VmVyc2lvbih0aGlzLmNvbm5lY3RlZFZlcnNpb24pO1xuICAgICAgICB9XG4gICAgICB9KTtcbiAgfVxuXG4gIHByaXZhdGUgYXN5bmMgZ2V0Q2xpZW50SW5mbygpIHtcbiAgICBpZiAodGhpcy5jbGllbnRUeXBlID09PSAnVjInKSB7XG4gICAgICBhd2FpdCB0aGlzLmdldENsaWVudEluZm9WMigpO1xuICAgICAgdGhpcy5nZXRHbG9iYWxDb25maWcoKTtcbiAgICB9IGVsc2Uge1xuICAgICAgYXdhaXQgdGhpcy5nZXRDbGllbnRJbmZvVjEoKTtcbiAgICB9XG4gIH1cblxuICBwcml2YXRlIGdldENsaWVudEluZm9WMSgpIHtcbiAgICByZXR1cm4gbmV3IFByb21pc2U8dm9pZD4oKHJlc29sdmUpID0+IHtcbiAgICAgIHRoaXMuaXBjKEFQSS5TRVJWRVJfR0VUSU5GTywgbnVsbCwgYXN5bmMgKHJlczogYW55KSA9PiB7XG4gICAgICAgIGxvZygnZ2V0IFYxIGluZm86ICcsIHJlcyk7XG5cbiAgICAgICAgY29uc3QgeyB1dWlkLCB2ZXJzaW9uIH0gPSByZXMgfHwge307XG5cbiAgICAgICAgaWYgKHV1aWQpIHtcbiAgICAgICAgICB0aGlzLmNsaWVudFVVSUQgPSB1dWlkO1xuICAgICAgICAgIGxvZ2dlci5zZXRVVUlEKHV1aWQpO1xuICAgICAgICB9XG5cbiAgICAgICAgaWYgKHZlcnNpb24pIHtcbiAgICAgICAgICB0aGlzLmNvbm5lY3RlZFZlcnNpb24gPSB2ZXJzaW9uO1xuICAgICAgICAgIGxvZ2dlci5zZXRDbGllbnRWZXJzaW9uKHZlcnNpb24pO1xuICAgICAgICB9XG5cbiAgICAgICAgdGhpcy5ub3RpZnlDb25uZWN0ZWQoKTtcblxuICAgICAgICBhd2FpdCB0aGlzLnVwZGF0ZVVwZ3JhZGVDb25maWcoKTtcbiAgICAgICAgdGhpcy5jaGVja1VwZ3JhZGUoKTtcblxuICAgICAgICByZXNvbHZlKCk7XG4gICAgICB9KTtcbiAgICB9KTtcbiAgfVxuXG4gIHByaXZhdGUgZ2V0Q2xpZW50SW5mb1YyKCkge1xuICAgIHJldHVybiB0aGlzLnJldXFlc3QoQVBJLkdFVF9BR0VOVF9JTkZPKVxuICAgICAgLnRoZW4oYXN5bmMgKHJlczogYW55KSA9PiB7XG4gICAgICAgIGxvZygnZ2V0IFYyIGluZm86ICcsIHJlcyk7XG5cbiAgICAgICAgY29uc3QgeyB1dWlkLCB2ZXJzaW9uIH0gPSByZXMgfHwge307XG5cbiAgICAgICAgaWYgKHV1aWQpIHtcbiAgICAgICAgICB0aGlzLmNsaWVudFVVSUQgPSB1dWlkO1xuICAgICAgICAgIGxvZ2dlci5zZXRVVUlEKHV1aWQpO1xuICAgICAgICB9XG5cbiAgICAgICAgaWYgKHZlcnNpb24pIHtcbiAgICAgICAgICB0aGlzLmNvbm5lY3RlZFZlcnNpb24gPSB2ZXJzaW9uO1xuICAgICAgICAgIGxvZ2dlci5zZXRDbGllbnRWZXJzaW9uKHZlcnNpb24pO1xuICAgICAgICB9XG5cbiAgICAgICAgdGhpcy5ub3RpZnlDb25uZWN0ZWQoKTtcblxuICAgICAgICBhd2FpdCB0aGlzLnVwZGF0ZVVwZ3JhZGVDb25maWcoKTtcbiAgICAgICAgdGhpcy5jaGVja1VwZ3JhZGUoKTtcbiAgICAgIH0pXG4gICAgICAuY2F0Y2goYXN5bmMgKGVycikgPT4ge1xuICAgICAgICBsb2coJ2dldCBWMiBpbmZvIGVycm9yIDE6ICcsIGVycik7XG5cbiAgICAgICAgdGhpcy5ub3RpZnlDb25uZWN0ZWQoKTtcblxuICAgICAgICBhd2FpdCB0aGlzLnVwZGF0ZVVwZ3JhZGVDb25maWcoKTtcbiAgICAgICAgdGhpcy5jaGVja1VwZ3JhZGUoKTtcbiAgICAgIH0pXG4gICAgICAuY2F0Y2goKGVycikgPT4ge1xuICAgICAgICBsb2coJ2dldCBWMiBpbmZvIGVycm9yIDI6ICcsIGVycik7XG4gICAgICB9KTtcbiAgfVxuXG4gIHByaXZhdGUgdXBncmFkZSgpIHtcbiAgICB0aGlzLnNob3dVcGRhdGVBbGVydCgpO1xuICAgIGlmICh0aGlzLmNvbm5lY3RlZFZlcnNpb24gJiYgK3RoaXMuY29ubmVjdGVkVmVyc2lvbi5zcGxpdCgnLicpWzBdID49IDMpIHtcbiAgICAgIHRoaXMuY2hlY2tvdXRGb3JVcGRhdGUoe1xuICAgICAgICBleHRyYVJlcXVlc3RQYXJhbXM6IHtcbiAgICAgICAgICBhcHBOYW1lOiB0aGlzLm9wdGlvbnMuYXBwTmFtZSxcbiAgICAgICAgICB1c2VySWQ6IHRoaXMub3B0aW9ucy51c2VySWQsXG4gICAgICAgIH0sXG4gICAgICB9KTtcbiAgICB9IGVsc2UgaWYgKHRoaXMuY2xpZW50VHlwZSA9PT0gJ1YyJykge1xuICAgICAgdGhpcy5yZXVxZXN0KEFQSS5VUEdSQURFLCB7XG4gICAgICAgIHZlcnNpb246IHRoaXMucmVxdWlyZWRWZXJzaW9uLFxuICAgICAgICB0YXJnZXRWZXJzaW9uOiB0aGlzLnJlcXVpcmVkVmVyc2lvbixcbiAgICAgIH0pO1xuICAgIH0gZWxzZSB7XG4gICAgICB0aGlzLmlwYyhBUEkuU0VSVkVSX1VQREFURSwge1xuICAgICAgICB0YXJnZXRWZXJzaW9uOiB0aGlzLnJlcXVpcmVkVmVyc2lvbixcbiAgICAgIH0pO1xuICAgIH1cbiAgICBsb2dnZXIubG9nSW5mbygnVXBncmFkZScsIHtcbiAgICAgIHJlcXVpcmVkVmVyc2lvbjogdGhpcy5yZXF1aXJlZFZlcnNpb24sXG4gICAgfSk7XG4gIH1cblxuICBwcml2YXRlIGNoZWNrb3V0Rm9yVXBkYXRlKG9wdGlvbnM6IGFueSkge1xuICAgIHJldHVybiB0aGlzLnJldXFlc3QoQVBJLkNIRUNLX0ZPUl9VUERBVEUsIG9wdGlvbnMpO1xuICB9XG5cbiAgcHJpdmF0ZSBnZXRVcGRhdGVJbmZvKG9wdGlvbnM6IGFueSkge1xuICAgIHJldHVybiB0aGlzLnJldXFlc3QoQVBJLkdFVF9VUERBVEVfSU5GTywgb3B0aW9ucylcbiAgICAgIC50aGVuKGFzeW5jIChyZXM6IGFueSkgPT4ge1xuICAgICAgICBsb2coJ2dldCAzLjAgdXBncmFkZSBpbmZvOiAnLCByZXMpO1xuICAgICAgICAvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzXG4gICAgICAgIGNvbnN0IHsgdmVyc2lvbkluZm8gfSA9IHJlcztcbiAgICAgICAgcmV0dXJuIHZlcnNpb25JbmZvO1xuICAgICAgfSlcbiAgICAgIC5jYXRjaCgoZXJyKSA9PiB7XG4gICAgICAgIGxvZygnZ2V0IDMuMCB1cGdyYWRlIGluZm8gZXJyb3I6ICcsIGVycik7XG4gICAgICAgIHJldHVybiBudWxsO1xuICAgICAgfSk7XG4gIH1cblxuICAvKipcbiAgICog6I635Y+W5bm26Kej5p6Q6L+c56iL6YWN572uXG4gICAqIOivtOaYjjog6YWN572u5LiN5piv5q+P5qyh6LCD55So5a6e5pe25pu05pawLCDmr4/kuKogQ2xpZW50IOWunuS+i+WPquiOt+WPluS4gOasoVxuICAgKiDphY3nva7njq/looM6IHRlc3TjgIFwcm9kXG4gICAqIOmFjee9ruWPguiAgzogZXhhbXBsZXMvY29uZmlnLnJlbW90ZS5qc29uXG4gICAqL1xuICBwcml2YXRlIGFzeW5jIGdldFJlbW90ZUNvbmZpZygpIHtcbiAgICBjb25zdCB2ID0gcGtnLnZlcnNpb24uc3BsaXQoJy0nKVswXTtcbiAgICBjb25zdCB1cmwgPSBgaHR0cHM6Ly9wb3J0YWwtcG9ydG0ubWVpdHVhbi5jb20va2xmZS9tdG9iLyR7XG4gICAgICB0aGlzLmlzUHJvZCA/ICdwcm9kJyA6ICd0ZXN0J1xuICAgIH0vY2xpZW50U0RLQ29uZmlnYDtcblxuICAgIGlmICghdGhpcy5yZW1vdGVDb25maWcpIHtcbiAgICAgIHRoaXMucmVtb3RlQ29uZmlnID0gYXdhaXQgZmV0Y2godXJsKVxuICAgICAgICAudGhlbigocmVzcG9uc2UpID0+IHJlc3BvbnNlLmpzb24oKSlcbiAgICAgICAgLnRoZW4oKGRhdGEgPSB7fSkgPT4gKHtcbiAgICAgICAgICAuLi4oZGF0YS5jb21tb24gfHwge30pLFxuICAgICAgICAgIC4uLihkYXRhW3ZdIHx8IHt9KSxcbiAgICAgICAgfSkpXG4gICAgICAgIC5jYXRjaCgoKSA9PiBudWxsKTtcbiAgICB9XG5cbiAgICBsb2coJ3JlbW90ZSBjb25maWc6ICcsIHRoaXMucmVtb3RlQ29uZmlnKTtcbiAgfVxuXG4gIHByaXZhdGUgYXN5bmMgdXBkYXRlVXBncmFkZUNvbmZpZygpIHtcbiAgICAvLyAzLjAuMCDlj4rku6XlkI7nmoTniYjmnKzpgJrov4flrqLmiLfnq6/nmoTojrflj5bmm7TmlrDkv6Hmga9cbiAgICBpZiAodGhpcy5jb25uZWN0ZWRWZXJzaW9uICYmICt0aGlzLmNvbm5lY3RlZFZlcnNpb24uc3BsaXQoJy4nKVswXSA+PSAzKSB7XG4gICAgICBjb25zdCBpbmZvID0gYXdhaXQgdGhpcy5nZXRVcGRhdGVJbmZvKHtcbiAgICAgICAgZXh0cmFSZXF1ZXN0UGFyYW1zOiB7XG4gICAgICAgICAgYXBwTmFtZTogdGhpcy5vcHRpb25zLmFwcE5hbWUsXG4gICAgICAgICAgdXNlcklkOiB0aGlzLm9wdGlvbnMudXNlcklkLFxuICAgICAgICB9LFxuICAgICAgfSk7XG5cbiAgICAgIGlmIChpbmZvKSB7XG4gICAgICAgIHRoaXMucmVxdWlyZWRWZXJzaW9uID0gaW5mby52ZXJzaW9ubmFtZTtcbiAgICAgICAgdGhpcy5mb3JjZVVwZ3JhZGUgPSAhIWluZm8uZm9yY2V1cGRhdGU7XG4gICAgICB9XG5cbiAgICAgIHJldHVybjtcbiAgICB9XG5cbiAgICBhd2FpdCB0aGlzLmdldFJlbW90ZUNvbmZpZygpO1xuXG4gICAgY29uc3QgY29uZmlnID0gdGhpcy5yZW1vdGVDb25maWc7XG5cbiAgICBpZiAoIWNvbmZpZykge1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGNvbnN0IHsgYXBwTmFtZSwgdXNlcklkIH0gPSB0aGlzLm9wdGlvbnM7XG5cbiAgICAvLyDnlKjmiLfnuqfliKvphY3nva5cbiAgICBpZiAodXNlcklkICYmIGNvbmZpZ1t1c2VySWRdKSB7XG4gICAgICB0aGlzLnVzZXJDb25maWcgPSBjb25maWdbdXNlcklkXTtcbiAgICAgIHRoaXMuZW1pdChcbiAgICAgICAgTVRPQl9DTElFTlRfRVZFTlQuT1BUSU9OU19VUERBVEUsXG4gICAgICAgIHRoaXMub3B0aW9ucyxcbiAgICAgICAgdGhpcy51c2VyQ29uZmlnXG4gICAgICApO1xuICAgIH1cblxuICAgIHRoaXMuZm9yY2VVcGdyYWRlID1cbiAgICAgIGNvbmZpZy5mb3JjZVVwZ3JhZGUgIT0gbnVsbCA/IGNvbmZpZy5mb3JjZVVwZ3JhZGUgOiB0aGlzLmZvcmNlVXBncmFkZTtcbiAgICB0aGlzLnJlcXVpcmVkVmVyc2lvbiA9IGNvbmZpZy5yZXF1aXJlZFZlcnNpb24gfHwgdGhpcy5yZXF1aXJlZFZlcnNpb247XG4gICAgdGhpcy5taW5WZXJzaW9uID0gY29uZmlnLm1pblZlcnNpb24gfHwgdGhpcy5taW5WZXJzaW9uO1xuXG4gICAgY29uc3QgYXBwQ29uZmlnOiBJQXBwQ29uZmlnID0gYXBwTmFtZSAmJiBjb25maWdbYXBwTmFtZV07XG5cbiAgICBpZiAoIWFwcENvbmZpZykge1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGNvbnN0IHtcbiAgICAgIHZlcnNpb24sXG4gICAgICB1c2VySWRSZWcsXG4gICAgICBjbGllbnRVVUlEUmVnLFxuICAgICAgZm9yY2VVcGdyYWRlLFxuICAgICAgcmVxdWlyZWRWZXJzaW9uLFxuICAgICAgbWluVmVyc2lvbixcbiAgICB9ID0gYXBwQ29uZmlnO1xuXG4gICAgaWYgKHJlcXVpcmVkVmVyc2lvbikge1xuICAgICAgdGhpcy5mb3JjZVVwZ3JhZGUgPSAhIWZvcmNlVXBncmFkZTtcbiAgICAgIHRoaXMucmVxdWlyZWRWZXJzaW9uID0gcmVxdWlyZWRWZXJzaW9uO1xuICAgIH1cblxuICAgIGlmIChtaW5WZXJzaW9uKSB7XG4gICAgICB0aGlzLm1pblZlcnNpb24gPSBtaW5WZXJzaW9uO1xuICAgIH1cblxuICAgIC8vIOaMieeFp3V1aWTnsr7noa7phY3nva7nmoTniYjmnKxcbiAgICBpZiAodGhpcy5jbGllbnRVVUlEICYmIGFwcENvbmZpZ1t0aGlzLmNsaWVudFVVSURdKSB7XG4gICAgICB0aGlzLmZvcmNlVXBncmFkZSA9IHRydWU7XG4gICAgICB0aGlzLnJlcXVpcmVkVmVyc2lvbiA9IGFwcENvbmZpZ1t0aGlzLmNsaWVudFVVSURdO1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIC8vIOaMieeFp3VzZXJJZOeyvuehrumFjee9rueahOeJiOacrFxuICAgIGlmICh1c2VySWQgJiYgYXBwQ29uZmlnW3VzZXJJZF0pIHtcbiAgICAgIHRoaXMuZm9yY2VVcGdyYWRlID0gdHJ1ZTtcbiAgICAgIHRoaXMucmVxdWlyZWRWZXJzaW9uID0gYXBwQ29uZmlnW3VzZXJJZF07XG4gICAgICByZXR1cm47XG4gICAgfVxuXG4gICAgaWYgKGNsaWVudFVVSURSZWcgJiYgdGhpcy5jbGllbnRVVUlEKSB7XG4gICAgICBjb25zdCByZWcgPSBuZXcgUmVnRXhwKGNsaWVudFVVSURSZWcpO1xuICAgICAgaWYgKHJlZy50ZXN0KHRoaXMuY2xpZW50VVVJRCkgJiYgdmVyc2lvbikge1xuICAgICAgICB0aGlzLmZvcmNlVXBncmFkZSA9IHRydWU7XG4gICAgICAgIHRoaXMucmVxdWlyZWRWZXJzaW9uID0gdmVyc2lvbjtcbiAgICAgICAgcmV0dXJuO1xuICAgICAgfVxuICAgIH1cblxuICAgIGlmICh1c2VySWRSZWcgJiYgdXNlcklkKSB7XG4gICAgICBjb25zdCByZWcgPSBuZXcgUmVnRXhwKHVzZXJJZFJlZyk7XG4gICAgICBpZiAocmVnLnRlc3QodXNlcklkLnRvU3RyaW5nKCkpICYmIHZlcnNpb24pIHtcbiAgICAgICAgdGhpcy5mb3JjZVVwZ3JhZGUgPSB0cnVlO1xuICAgICAgICB0aGlzLnJlcXVpcmVkVmVyc2lvbiA9IHZlcnNpb247XG4gICAgICAgIHJldHVybjtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICBwcml2YXRlIGNoZWNrVXBncmFkZSgpIHtcbiAgICBsb2coJ2NoZWNrVXBncmFkZScsIHtcbiAgICAgIGZvcmNlVXBncmFkZTogdGhpcy5mb3JjZVVwZ3JhZGUsXG4gICAgICByZXF1aXJlZFZlcnNpb246IHRoaXMucmVxdWlyZWRWZXJzaW9uLFxuICAgICAgbWluVmVyc2lvbjogdGhpcy5taW5WZXJzaW9uLFxuICAgICAgY29ubmVjdGVkVmVyc2lvbjogdGhpcy5jb25uZWN0ZWRWZXJzaW9uLFxuICAgICAgc2tpcEZvcmNlZFVwZ3JhZGU6IHRoaXMub3B0aW9ucy5za2lwRm9yY2VkVXBncmFkZSxcbiAgICB9KTtcblxuICAgIGlmICghdGhpcy5jb25uZWN0ZWRWZXJzaW9uKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuXG4gICAgLy8g6Lez6L+H5by65Yi25Y2H57qnXG4gICAgaWYgKHRoaXMub3B0aW9ucy5za2lwRm9yY2VkVXBncmFkZSkge1xuICAgICAgbG9nKCdza2lwIGZvcmNlZCB1cGdyYWRlIScsIHRoaXMucmVxdWlyZWRWZXJzaW9uKTtcbiAgICAgIGxvZ2dlci5sb2dJbmZvKCdTa2lwIEZvcmNlZCBVcGdyYWRlJywge1xuICAgICAgICBmb3JjZVVwZ3JhZGU6IHRoaXMuZm9yY2VVcGdyYWRlLFxuICAgICAgICByZXF1aXJlZFZlcnNpb246IHRoaXMucmVxdWlyZWRWZXJzaW9uLFxuICAgICAgfSk7XG4gICAgICByZXR1cm47XG4gICAgfVxuXG4gICAgaWYgKHRoaXMuY29ubmVjdGVkVmVyc2lvbiAhPT0gdGhpcy5yZXF1aXJlZFZlcnNpb24gJiYgdGhpcy5mb3JjZVVwZ3JhZGUpIHtcbiAgICAgIHRoaXMudXBncmFkZSgpO1xuICAgICAgdGhpcy5zdGF0dXMgPSBFTVRPQlN0YXR1cy5OZWVkVXBkYXRlO1xuICAgICAgdGhpcy5lbWl0KEVTREtFdmVudHMuU3RhdHVzQ2hhbmdlLCB7XG4gICAgICAgIHN0YXR1czogRVNES1N0YXR1cy5NVE9CX1VQREFURV9SRVFVSVJFRCxcbiAgICAgIH0pO1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGlmIChcbiAgICAgIHRoaXMubWluVmVyc2lvbiAmJlxuICAgICAgdGhpcy5jb21wYXJlVmVyc2lvbih0aGlzLmNvbm5lY3RlZFZlcnNpb24sIHRoaXMubWluVmVyc2lvbikgPT09IC0xXG4gICAgKSB7XG4gICAgICB0aGlzLnJlcXVpcmVkVmVyc2lvbiA9IHRoaXMubWluVmVyc2lvbjtcbiAgICAgIHRoaXMudXBncmFkZSgpO1xuICAgICAgdGhpcy5zdGF0dXMgPSBFTVRPQlN0YXR1cy5OZWVkVXBkYXRlO1xuICAgICAgdGhpcy5lbWl0KEVTREtFdmVudHMuU3RhdHVzQ2hhbmdlLCB7XG4gICAgICAgIHN0YXR1czogRVNES1N0YXR1cy5NVE9CX1VQREFURV9SRVFVSVJFRCxcbiAgICAgIH0pO1xuICAgIH1cbiAgfVxuXG4gIC8qKlxuICAgKiB2MSA8IHYyIHJldHVybiAtMVxuICAgKiB2MSA9PT0gdjIgcmV0dXJuIDBcbiAgICogdjEgPiB2MiByZXR1cm4gMVxuICAgKi9cbiAgcHJpdmF0ZSBjb21wYXJlVmVyc2lvbih2MTogc3RyaW5nLCB2Mjogc3RyaW5nKSB7XG4gICAgY29uc3QgYXJyMSA9IHYxLnNwbGl0KCctJylbMF0uc3BsaXQoJy4nKTtcbiAgICBjb25zdCBhcnIyID0gdjIuc3BsaXQoJy0nKVswXS5zcGxpdCgnLicpO1xuXG4gICAgZm9yIChsZXQgaSA9IDA7IGkgPCAzOyBpKyspIHtcbiAgICAgIGNvbnN0IG51bTEgPSArYXJyMVtpXTtcbiAgICAgIGNvbnN0IG51bTIgPSArYXJyMltpXTtcblxuICAgICAgaWYgKG51bTEgPCBudW0yKSB7XG4gICAgICAgIHJldHVybiAtMTtcbiAgICAgIH1cblxuICAgICAgaWYgKG51bTEgPiBudW0yKSB7XG4gICAgICAgIHJldHVybiAxO1xuICAgICAgfVxuICAgIH1cblxuICAgIHJldHVybiAwO1xuICB9XG5cbiAgcHJpdmF0ZSBzaG93RG93bmxvYWRBbGVydCgpIHtcbiAgICBpZiAoIXRoaXMub3B0aW9ucy5kZWZhdWx0RG93bmxvYWRBbGVydCkge1xuICAgICAgcmV0dXJuIGZhbHNlO1xuICAgIH1cbiAgICBpZiAod2luZG93LmNvbmZpcm0oJ01UT0LmnKrlkK/liqjvvIzor7fmiYvliqjlkK/liqjvvIzmiJbngrnlh7vnoa7lrprkuIvovb3lronoo4XljIUnKSkge1xuICAgICAgd2luZG93Lm9wZW4oXG4gICAgICAgIHRoaXMucmVxdWlyZWRWZXJzaW9uRG93bmxvYWRVUkwsXG4gICAgICAgICdfYmxhbmsnLFxuICAgICAgICAnbm9yZWZlcnJlcixub29wZW5lcidcbiAgICAgICk7XG4gICAgICByZXR1cm4gdHJ1ZTtcbiAgICB9IGVsc2Uge1xuICAgICAgcmV0dXJuIGZhbHNlO1xuICAgIH1cbiAgfVxuXG4gIHByaXZhdGUgc2hvd1VwZGF0ZUFsZXJ0KCkge1xuICAgIGlmICghdGhpcy5vcHRpb25zLmRlZmF1bHRVcGRhdGVBbGVydCkge1xuICAgICAgcmV0dXJuIGZhbHNlO1xuICAgIH1cbiAgICBpZiAoXG4gICAgICB3aW5kb3cuY29uZmlybSgnTVRPQueJiOacrOS4jeWFvOWuue+8jOato+WcqOiHquWKqOabtOaWsO+8jOS5n+WPr+eCueWHu+ehruWumuS4i+i9veato+ehrueJiOacrCcpXG4gICAgKSB7XG4gICAgICB3aW5kb3cub3BlbihcbiAgICAgICAgdGhpcy5yZXF1aXJlZFZlcnNpb25Eb3dubG9hZFVSTCxcbiAgICAgICAgJ19ibGFuaycsXG4gICAgICAgICdub3JlZmVycmVyLG5vb3BlbmVyJ1xuICAgICAgKTtcbiAgICAgIHJldHVybiB0cnVlO1xuICAgIH0gZWxzZSB7XG4gICAgICByZXR1cm4gZmFsc2U7XG4gICAgfVxuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IG5ldyBNVE9CQ2xpZW50KCk7XG4iXX0=

/***/ }),
/* 3 */
/***/ (function(module) {

/*!
 * Socket.IO v3.1.3
 * (c) 2014-2021 Guillermo Rauch
 * Released under the MIT License.
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(self, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_623__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_623__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_623__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_623__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_623__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_623__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_623__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_623__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_623__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_623__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_623__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_623__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_623__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_623__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_623__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_623__(__nested_webpack_require_623__.s = "./build/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./build/index.js":
/*!************************!*\
  !*** ./build/index.js ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_4243__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Socket = exports.io = exports.Manager = exports.protocol = void 0;

var url_1 = __nested_webpack_require_4243__(/*! ./url */ "./build/url.js");

var manager_1 = __nested_webpack_require_4243__(/*! ./manager */ "./build/manager.js");

var socket_1 = __nested_webpack_require_4243__(/*! ./socket */ "./build/socket.js");

Object.defineProperty(exports, "Socket", {
  enumerable: true,
  get: function get() {
    return socket_1.Socket;
  }
});

var debug = __nested_webpack_require_4243__(/*! debug */ "./node_modules/debug/src/browser.js")("socket.io-client");
/**
 * Module exports.
 */


module.exports = exports = lookup;
/**
 * Managers cache.
 */

var cache = exports.managers = {};

function lookup(uri, opts) {
  if (_typeof(uri) === "object") {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};
  var parsed = url_1.url(uri, opts.path);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id]["nsps"];
  var newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
  var io;

  if (newConnection) {
    debug("ignoring socket cache for %s", source);
    io = new manager_1.Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug("new io instance for %s", source);
      cache[id] = new manager_1.Manager(source, opts);
    }

    io = cache[id];
  }

  if (parsed.query && !opts.query) {
    opts.query = parsed.queryKey;
  }

  return io.socket(parsed.path, opts);
}

exports.io = lookup;
/**
 * Protocol version.
 *
 * @public
 */

var socket_io_parser_1 = __nested_webpack_require_4243__(/*! socket.io-parser */ "./node_modules/socket.io-parser/dist/index.js");

Object.defineProperty(exports, "protocol", {
  enumerable: true,
  get: function get() {
    return socket_io_parser_1.protocol;
  }
});
/**
 * `connect`.
 *
 * @param {String} uri
 * @public
 */

exports.connect = lookup;
/**
 * Expose constructors for standalone build.
 *
 * @public
 */

var manager_2 = __nested_webpack_require_4243__(/*! ./manager */ "./build/manager.js");

Object.defineProperty(exports, "Manager", {
  enumerable: true,
  get: function get() {
    return manager_2.Manager;
  }
});

/***/ }),

/***/ "./build/manager.js":
/*!**************************!*\
  !*** ./build/manager.js ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_7094__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Manager = void 0;

var eio = __nested_webpack_require_7094__(/*! engine.io-client */ "./node_modules/engine.io-client/lib/index.js");

var socket_1 = __nested_webpack_require_7094__(/*! ./socket */ "./build/socket.js");

var Emitter = __nested_webpack_require_7094__(/*! component-emitter */ "./node_modules/component-emitter/index.js");

var parser = __nested_webpack_require_7094__(/*! socket.io-parser */ "./node_modules/socket.io-parser/dist/index.js");

var on_1 = __nested_webpack_require_7094__(/*! ./on */ "./build/on.js");

var Backoff = __nested_webpack_require_7094__(/*! backo2 */ "./node_modules/backo2/index.js");

var debug = __nested_webpack_require_7094__(/*! debug */ "./node_modules/debug/src/browser.js")("socket.io-client:manager");

var Manager = /*#__PURE__*/function (_Emitter) {
  _inherits(Manager, _Emitter);

  var _super = _createSuper(Manager);

  function Manager(uri, opts) {
    var _this;

    _classCallCheck(this, Manager);

    _this = _super.call(this);
    _this.nsps = {};
    _this.subs = [];

    if (uri && "object" === _typeof(uri)) {
      opts = uri;
      uri = undefined;
    }

    opts = opts || {};
    opts.path = opts.path || "/socket.io";
    _this.opts = opts;

    _this.reconnection(opts.reconnection !== false);

    _this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);

    _this.reconnectionDelay(opts.reconnectionDelay || 1000);

    _this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);

    _this.randomizationFactor(opts.randomizationFactor || 0.5);

    _this.backoff = new Backoff({
      min: _this.reconnectionDelay(),
      max: _this.reconnectionDelayMax(),
      jitter: _this.randomizationFactor()
    });

    _this.timeout(null == opts.timeout ? 20000 : opts.timeout);

    _this._readyState = "closed";
    _this.uri = uri;

    var _parser = opts.parser || parser;

    _this.encoder = new _parser.Encoder();
    _this.decoder = new _parser.Decoder();
    _this._autoConnect = opts.autoConnect !== false;
    if (_this._autoConnect) _this.open();
    return _this;
  }

  _createClass(Manager, [{
    key: "reconnection",
    value: function reconnection(v) {
      if (!arguments.length) return this._reconnection;
      this._reconnection = !!v;
      return this;
    }
  }, {
    key: "reconnectionAttempts",
    value: function reconnectionAttempts(v) {
      if (v === undefined) return this._reconnectionAttempts;
      this._reconnectionAttempts = v;
      return this;
    }
  }, {
    key: "reconnectionDelay",
    value: function reconnectionDelay(v) {
      var _a;

      if (v === undefined) return this._reconnectionDelay;
      this._reconnectionDelay = v;
      (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMin(v);
      return this;
    }
  }, {
    key: "randomizationFactor",
    value: function randomizationFactor(v) {
      var _a;

      if (v === undefined) return this._randomizationFactor;
      this._randomizationFactor = v;
      (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setJitter(v);
      return this;
    }
  }, {
    key: "reconnectionDelayMax",
    value: function reconnectionDelayMax(v) {
      var _a;

      if (v === undefined) return this._reconnectionDelayMax;
      this._reconnectionDelayMax = v;
      (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMax(v);
      return this;
    }
  }, {
    key: "timeout",
    value: function timeout(v) {
      if (!arguments.length) return this._timeout;
      this._timeout = v;
      return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */

  }, {
    key: "maybeReconnectOnOpen",
    value: function maybeReconnectOnOpen() {
      // Only try to reconnect if it's the first time we're connecting
      if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) {
        // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
      }
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */

  }, {
    key: "open",
    value: function open(fn) {
      var _this2 = this;

      debug("readyState %s", this._readyState);
      if (~this._readyState.indexOf("open")) return this;
      debug("opening %s", this.uri);
      this.engine = eio(this.uri, this.opts);
      var socket = this.engine;
      var self = this;
      this._readyState = "opening";
      this.skipReconnect = false; // emit `open`

      var openSubDestroy = on_1.on(socket, "open", function () {
        self.onopen();
        fn && fn();
      }); // emit `error`

      var errorSub = on_1.on(socket, "error", function (err) {
        debug("error");
        self.cleanup();
        self._readyState = "closed";

        _get(_getPrototypeOf(Manager.prototype), "emit", _this2).call(_this2, "error", err);

        if (fn) {
          fn(err);
        } else {
          // Only do this if there is no fn to handle the error
          self.maybeReconnectOnOpen();
        }
      });

      if (false !== this._timeout) {
        var timeout = this._timeout;
        debug("connect attempt will timeout after %d", timeout);

        if (timeout === 0) {
          openSubDestroy(); // prevents a race condition with the 'open' event
        } // set timer


        var timer = setTimeout(function () {
          debug("connect attempt timed out after %d", timeout);
          openSubDestroy();
          socket.close();
          socket.emit("error", new Error("timeout"));
        }, timeout);
        this.subs.push(function subDestroy() {
          clearTimeout(timer);
        });
      }

      this.subs.push(openSubDestroy);
      this.subs.push(errorSub);
      return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */

  }, {
    key: "connect",
    value: function connect(fn) {
      return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */

  }, {
    key: "onopen",
    value: function onopen() {
      debug("open"); // clear old subs

      this.cleanup(); // mark as open

      this._readyState = "open";

      _get(_getPrototypeOf(Manager.prototype), "emit", this).call(this, "open"); // add new subs


      var socket = this.engine;
      this.subs.push(on_1.on(socket, "ping", this.onping.bind(this)), on_1.on(socket, "data", this.ondata.bind(this)), on_1.on(socket, "error", this.onerror.bind(this)), on_1.on(socket, "close", this.onclose.bind(this)), on_1.on(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */

  }, {
    key: "onping",
    value: function onping() {
      _get(_getPrototypeOf(Manager.prototype), "emit", this).call(this, "ping");
    }
    /**
     * Called with data.
     *
     * @private
     */

  }, {
    key: "ondata",
    value: function ondata(data) {
      this.decoder.add(data);
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */

  }, {
    key: "ondecoded",
    value: function ondecoded(packet) {
      _get(_getPrototypeOf(Manager.prototype), "emit", this).call(this, "packet", packet);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */

  }, {
    key: "onerror",
    value: function onerror(err) {
      debug("error", err);

      _get(_getPrototypeOf(Manager.prototype), "emit", this).call(this, "error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */

  }, {
    key: "socket",
    value: function socket(nsp, opts) {
      var socket = this.nsps[nsp];

      if (!socket) {
        socket = new socket_1.Socket(this, nsp, opts);
        this.nsps[nsp] = socket;
      }

      return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */

  }, {
    key: "_destroy",
    value: function _destroy(socket) {
      var nsps = Object.keys(this.nsps);

      for (var _i = 0, _nsps = nsps; _i < _nsps.length; _i++) {
        var nsp = _nsps[_i];
        var _socket = this.nsps[nsp];

        if (_socket.active) {
          debug("socket %s is still active, skipping close", nsp);
          return;
        }
      }

      this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */

  }, {
    key: "_packet",
    value: function _packet(packet) {
      debug("writing packet %j", packet);
      var encodedPackets = this.encoder.encode(packet);

      for (var i = 0; i < encodedPackets.length; i++) {
        this.engine.write(encodedPackets[i], packet.options);
      }
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */

  }, {
    key: "cleanup",
    value: function cleanup() {
      debug("cleanup");
      this.subs.forEach(function (subDestroy) {
        return subDestroy();
      });
      this.subs.length = 0;
      this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */

  }, {
    key: "_close",
    value: function _close() {
      debug("disconnect");
      this.skipReconnect = true;
      this._reconnecting = false;

      if ("opening" === this._readyState) {
        // `onclose` will not fire because
        // an open event never happened
        this.cleanup();
      }

      this.backoff.reset();
      this._readyState = "closed";
      if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */

  }, {
    key: "onclose",
    value: function onclose(reason) {
      debug("onclose");
      this.cleanup();
      this.backoff.reset();
      this._readyState = "closed";

      _get(_getPrototypeOf(Manager.prototype), "emit", this).call(this, "close", reason);

      if (this._reconnection && !this.skipReconnect) {
        this.reconnect();
      }
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */

  }, {
    key: "reconnect",
    value: function reconnect() {
      var _this3 = this;

      if (this._reconnecting || this.skipReconnect) return this;
      var self = this;

      if (this.backoff.attempts >= this._reconnectionAttempts) {
        debug("reconnect failed");
        this.backoff.reset();

        _get(_getPrototypeOf(Manager.prototype), "emit", this).call(this, "reconnect_failed");

        this._reconnecting = false;
      } else {
        var delay = this.backoff.duration();
        debug("will wait %dms before reconnect attempt", delay);
        this._reconnecting = true;
        var timer = setTimeout(function () {
          if (self.skipReconnect) return;
          debug("attempting reconnect");

          _get(_getPrototypeOf(Manager.prototype), "emit", _this3).call(_this3, "reconnect_attempt", self.backoff.attempts); // check again for the case socket closed in above events


          if (self.skipReconnect) return;
          self.open(function (err) {
            if (err) {
              debug("reconnect attempt error");
              self._reconnecting = false;
              self.reconnect();

              _get(_getPrototypeOf(Manager.prototype), "emit", _this3).call(_this3, "reconnect_error", err);
            } else {
              debug("reconnect success");
              self.onreconnect();
            }
          });
        }, delay);
        this.subs.push(function subDestroy() {
          clearTimeout(timer);
        });
      }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */

  }, {
    key: "onreconnect",
    value: function onreconnect() {
      var attempt = this.backoff.attempts;
      this._reconnecting = false;
      this.backoff.reset();

      _get(_getPrototypeOf(Manager.prototype), "emit", this).call(this, "reconnect", attempt);
    }
  }]);

  return Manager;
}(Emitter);

exports.Manager = Manager;

/***/ }),

/***/ "./build/on.js":
/*!*********************!*\
  !*** ./build/on.js ***!
  \*********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = void 0;

function on(obj, ev, fn) {
  obj.on(ev, fn);
  return function subDestroy() {
    obj.off(ev, fn);
  };
}

exports.on = on;

/***/ }),

/***/ "./build/socket.js":
/*!*************************!*\
  !*** ./build/socket.js ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_23564__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Socket = void 0;

var socket_io_parser_1 = __nested_webpack_require_23564__(/*! socket.io-parser */ "./node_modules/socket.io-parser/dist/index.js");

var Emitter = __nested_webpack_require_23564__(/*! component-emitter */ "./node_modules/component-emitter/index.js");

var on_1 = __nested_webpack_require_23564__(/*! ./on */ "./build/on.js");

var debug = __nested_webpack_require_23564__(/*! debug */ "./node_modules/debug/src/browser.js")("socket.io-client:socket");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */


var RESERVED_EVENTS = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});

var Socket = /*#__PURE__*/function (_Emitter) {
  _inherits(Socket, _Emitter);

  var _super = _createSuper(Socket);

  /**
   * `Socket` constructor.
   *
   * @public
   */
  function Socket(io, nsp, opts) {
    var _this;

    _classCallCheck(this, Socket);

    _this = _super.call(this);
    _this.receiveBuffer = [];
    _this.sendBuffer = [];
    _this.ids = 0;
    _this.acks = {};
    _this.flags = {};
    _this.io = io;
    _this.nsp = nsp;
    _this.ids = 0;
    _this.acks = {};
    _this.receiveBuffer = [];
    _this.sendBuffer = [];
    _this.connected = false;
    _this.disconnected = true;
    _this.flags = {};

    if (opts && opts.auth) {
      _this.auth = opts.auth;
    }

    if (_this.io._autoConnect) _this.open();
    return _this;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */


  _createClass(Socket, [{
    key: "subEvents",
    value: function subEvents() {
      if (this.subs) return;
      var io = this.io;
      this.subs = [on_1.on(io, "open", this.onopen.bind(this)), on_1.on(io, "packet", this.onpacket.bind(this)), on_1.on(io, "error", this.onerror.bind(this)), on_1.on(io, "close", this.onclose.bind(this))];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects
     */

  }, {
    key: "connect",

    /**
     * "Opens" the socket.
     *
     * @public
     */
    value: function connect() {
      if (this.connected) return this;
      this.subEvents();
      if (!this.io["_reconnecting"]) this.io.open(); // ensure open

      if ("open" === this.io._readyState) this.onopen();
      return this;
    }
    /**
     * Alias for connect()
     */

  }, {
    key: "open",
    value: function open() {
      return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * @return self
     * @public
     */

  }, {
    key: "send",
    value: function send() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      args.unshift("message");
      this.emit.apply(this, args);
      return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @param ev - event name
     * @return self
     * @public
     */

  }, {
    key: "emit",
    value: function emit(ev) {
      if (RESERVED_EVENTS.hasOwnProperty(ev)) {
        throw new Error('"' + ev + '" is a reserved event name');
      }

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      args.unshift(ev);
      var packet = {
        type: socket_io_parser_1.PacketType.EVENT,
        data: args
      };
      packet.options = {};
      packet.options.compress = this.flags.compress !== false; // event ack callback

      if ("function" === typeof args[args.length - 1]) {
        debug("emitting packet with ack id %d", this.ids);
        this.acks[this.ids] = args.pop();
        packet.id = this.ids++;
      }

      var isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
      var discardPacket = this.flags["volatile"] && (!isTransportWritable || !this.connected);

      if (discardPacket) {
        debug("discard packet as the transport is not currently writable");
      } else if (this.connected) {
        this.packet(packet);
      } else {
        this.sendBuffer.push(packet);
      }

      this.flags = {};
      return this;
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */

  }, {
    key: "packet",
    value: function packet(_packet) {
      _packet.nsp = this.nsp;

      this.io._packet(_packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */

  }, {
    key: "onopen",
    value: function onopen() {
      var _this2 = this;

      debug("transport is open - connecting");

      if (typeof this.auth == "function") {
        this.auth(function (data) {
          _this2.packet({
            type: socket_io_parser_1.PacketType.CONNECT,
            data: data
          });
        });
      } else {
        this.packet({
          type: socket_io_parser_1.PacketType.CONNECT,
          data: this.auth
        });
      }
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */

  }, {
    key: "onerror",
    value: function onerror(err) {
      if (!this.connected) {
        _get(_getPrototypeOf(Socket.prototype), "emit", this).call(this, "connect_error", err);
      }
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @private
     */

  }, {
    key: "onclose",
    value: function onclose(reason) {
      debug("close (%s)", reason);
      this.connected = false;
      this.disconnected = true;
      delete this.id;

      _get(_getPrototypeOf(Socket.prototype), "emit", this).call(this, "disconnect", reason);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */

  }, {
    key: "onpacket",
    value: function onpacket(packet) {
      var sameNamespace = packet.nsp === this.nsp;
      if (!sameNamespace) return;

      switch (packet.type) {
        case socket_io_parser_1.PacketType.CONNECT:
          if (packet.data && packet.data.sid) {
            var id = packet.data.sid;
            this.onconnect(id);
          } else {
            _get(_getPrototypeOf(Socket.prototype), "emit", this).call(this, "connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          }

          break;

        case socket_io_parser_1.PacketType.EVENT:
          this.onevent(packet);
          break;

        case socket_io_parser_1.PacketType.BINARY_EVENT:
          this.onevent(packet);
          break;

        case socket_io_parser_1.PacketType.ACK:
          this.onack(packet);
          break;

        case socket_io_parser_1.PacketType.BINARY_ACK:
          this.onack(packet);
          break;

        case socket_io_parser_1.PacketType.DISCONNECT:
          this.ondisconnect();
          break;

        case socket_io_parser_1.PacketType.CONNECT_ERROR:
          var err = new Error(packet.data.message); // @ts-ignore

          err.data = packet.data.data;

          _get(_getPrototypeOf(Socket.prototype), "emit", this).call(this, "connect_error", err);

          break;
      }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */

  }, {
    key: "onevent",
    value: function onevent(packet) {
      var args = packet.data || [];
      debug("emitting event %j", args);

      if (null != packet.id) {
        debug("attaching ack callback to event");
        args.push(this.ack(packet.id));
      }

      if (this.connected) {
        this.emitEvent(args);
      } else {
        this.receiveBuffer.push(Object.freeze(args));
      }
    }
  }, {
    key: "emitEvent",
    value: function emitEvent(args) {
      if (this._anyListeners && this._anyListeners.length) {
        var listeners = this._anyListeners.slice();

        var _iterator = _createForOfIteratorHelper(listeners),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var listener = _step.value;
            listener.apply(this, args);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      _get(_getPrototypeOf(Socket.prototype), "emit", this).apply(this, args);
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */

  }, {
    key: "ack",
    value: function ack(id) {
      var self = this;
      var sent = false;
      return function () {
        // prevent double callbacks
        if (sent) return;
        sent = true;

        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        debug("sending ack %j", args);
        self.packet({
          type: socket_io_parser_1.PacketType.ACK,
          id: id,
          data: args
        });
      };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */

  }, {
    key: "onack",
    value: function onack(packet) {
      var ack = this.acks[packet.id];

      if ("function" === typeof ack) {
        debug("calling ack %s with %j", packet.id, packet.data);
        ack.apply(this, packet.data);
        delete this.acks[packet.id];
      } else {
        debug("bad ack %s", packet.id);
      }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */

  }, {
    key: "onconnect",
    value: function onconnect(id) {
      debug("socket connected with id %s", id);
      this.id = id;
      this.connected = true;
      this.disconnected = false;

      _get(_getPrototypeOf(Socket.prototype), "emit", this).call(this, "connect");

      this.emitBuffered();
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */

  }, {
    key: "emitBuffered",
    value: function emitBuffered() {
      var _this3 = this;

      this.receiveBuffer.forEach(function (args) {
        return _this3.emitEvent(args);
      });
      this.receiveBuffer = [];
      this.sendBuffer.forEach(function (packet) {
        return _this3.packet(packet);
      });
      this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */

  }, {
    key: "ondisconnect",
    value: function ondisconnect() {
      debug("server disconnect (%s)", this.nsp);
      this.destroy();
      this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (this.subs) {
        // clean subscriptions to avoid reconnections
        this.subs.forEach(function (subDestroy) {
          return subDestroy();
        });
        this.subs = undefined;
      }

      this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually.
     *
     * @return self
     * @public
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this.connected) {
        debug("performing disconnect (%s)", this.nsp);
        this.packet({
          type: socket_io_parser_1.PacketType.DISCONNECT
        });
      } // remove socket from pool


      this.destroy();

      if (this.connected) {
        // fire events
        this.onclose("io client disconnect");
      }

      return this;
    }
    /**
     * Alias for disconnect()
     *
     * @return self
     * @public
     */

  }, {
    key: "close",
    value: function close() {
      return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     * @public
     */

  }, {
    key: "compress",
    value: function compress(_compress) {
      this.flags.compress = _compress;
      return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @returns self
     * @public
     */

  }, {
    key: "onAny",

    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @param listener
     * @public
     */
    value: function onAny(listener) {
      this._anyListeners = this._anyListeners || [];

      this._anyListeners.push(listener);

      return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @param listener
     * @public
     */

  }, {
    key: "prependAny",
    value: function prependAny(listener) {
      this._anyListeners = this._anyListeners || [];

      this._anyListeners.unshift(listener);

      return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @param listener
     * @public
     */

  }, {
    key: "offAny",
    value: function offAny(listener) {
      if (!this._anyListeners) {
        return this;
      }

      if (listener) {
        var listeners = this._anyListeners;

        for (var i = 0; i < listeners.length; i++) {
          if (listener === listeners[i]) {
            listeners.splice(i, 1);
            return this;
          }
        }
      } else {
        this._anyListeners = [];
      }

      return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     *
     * @public
     */

  }, {
    key: "listenersAny",
    value: function listenersAny() {
      return this._anyListeners || [];
    }
  }, {
    key: "active",
    get: function get() {
      return !!this.subs;
    }
  }, {
    key: "volatile",
    get: function get() {
      this.flags["volatile"] = true;
      return this;
    }
  }]);

  return Socket;
}(Emitter);

exports.Socket = Socket;

/***/ }),

/***/ "./build/url.js":
/*!**********************!*\
  !*** ./build/url.js ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_43508__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.url = void 0;

var parseuri = __nested_webpack_require_43508__(/*! parseuri */ "./node_modules/parseuri/index.js");

var debug = __nested_webpack_require_43508__(/*! debug */ "./node_modules/debug/src/browser.js")("socket.io-client:url");
/**
 * URL parser.
 *
 * @param uri - url
 * @param path - the request path of the connection
 * @param loc - An object meant to mimic window.location.
 *        Defaults to window.location.
 * @public
 */


function url(uri) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var loc = arguments.length > 2 ? arguments[2] : undefined;
  var obj = uri; // default to window.location

  loc = loc || typeof location !== "undefined" && location;
  if (null == uri) uri = loc.protocol + "//" + loc.host; // relative path support

  if (typeof uri === "string") {
    if ("/" === uri.charAt(0)) {
      if ("/" === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug("protocol-less url %s", uri);

      if ("undefined" !== typeof loc) {
        uri = loc.protocol + "//" + uri;
      } else {
        uri = "https://" + uri;
      }
    } // parse


    debug("parse %s", uri);
    obj = parseuri(uri);
  } // make sure we treat `localhost:80` and `localhost` equally


  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = "80";
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = "443";
    }
  }

  obj.path = obj.path || "/";
  var ipv6 = obj.host.indexOf(":") !== -1;
  var host = ipv6 ? "[" + obj.host + "]" : obj.host; // define unique id

  obj.id = obj.protocol + "://" + host + ":" + obj.port + path; // define href

  obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
  return obj;
}

exports.url = url;

/***/ }),

/***/ "./node_modules/backo2/index.js":
/*!**************************************!*\
  !*** ./node_modules/backo2/index.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Expose `Backoff`.
 */
module.exports = Backoff;
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */


Backoff.prototype.duration = function () {
  var ms = this.ms * Math.pow(this.factor, this.attempts++);

  if (this.jitter) {
    var rand = Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
  }

  return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */


Backoff.prototype.reset = function () {
  this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */


Backoff.prototype.setMin = function (min) {
  this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */


Backoff.prototype.setMax = function (max) {
  this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */


Backoff.prototype.setJitter = function (jitter) {
  this.jitter = jitter;
};

/***/ }),

/***/ "./node_modules/component-emitter/index.js":
/*!*************************************************!*\
  !*** ./node_modules/component-emitter/index.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Expose `Emitter`.
 */
if (true) {
  module.exports = Emitter;
}
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */


function Emitter(obj) {
  if (obj) return mixin(obj);
}

;
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }

  return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */


Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
  return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */


Emitter.prototype.once = function (event, fn) {
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */


Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
  this._callbacks = this._callbacks || {}; // all

  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  } // specific event


  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this; // remove all handlers

  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  } // remove specific handler


  var cb;

  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];

    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  } // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.


  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */


Emitter.prototype.emit = function (event) {
  this._callbacks = this._callbacks || {};
  var args = new Array(arguments.length - 1),
      callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);

    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */


Emitter.prototype.listeners = function (event) {
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */


Emitter.prototype.hasListeners = function (event) {
  return !!this.listeners(event).length;
};

/***/ }),

/***/ "./node_modules/debug/src/browser.js":
/*!*******************************************!*\
  !*** ./node_modules/debug/src/browser.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_51047__) {

/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();

exports.destroy = function () {
  var warned = false;
  return function () {
    if (!warned) {
      warned = true;
      console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
    }
  };
}();
/**
 * Colors.
 */


exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */
// eslint-disable-next-line complexity

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
    return true;
  } // Internet Explorer and Edge do not support colors.


  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  } // Is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */


function formatArgs(args) {
  args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

  if (!this.useColors) {
    return;
  }

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into

  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if (match === '%%') {
      return;
    }

    index++;

    if (match === '%c') {
      // We only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });
  args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */


exports.log = console.debug || console.log || function () {};
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */


function save(namespaces) {
  try {
    if (namespaces) {
      exports.storage.setItem('debug', namespaces);
    } else {
      exports.storage.removeItem('debug');
    }
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */


function load() {
  var r;

  try {
    r = exports.storage.getItem('debug');
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  } // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */


function localstorage() {
  try {
    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
    // The Browser also has localStorage in the global context.
    return localStorage;
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}

module.exports = __nested_webpack_require_51047__(/*! ./common */ "./node_modules/debug/src/common.js")(exports);
var formatters = module.exports.formatters;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (error) {
    return '[UnexpectedJSONParseError]: ' + error.message;
  }
};

/***/ }),

/***/ "./node_modules/debug/src/common.js":
/*!******************************************!*\
  !*** ./node_modules/debug/src/common.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_57422__) {

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */
function setup(env) {
  createDebug.debug = createDebug;
  createDebug["default"] = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = __nested_webpack_require_57422__(/*! ms */ "./node_modules/ms/index.js");
  createDebug.destroy = destroy;
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;
    var enableOverride = null;

    function debug() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // Disabled?
      if (!debug.enabled) {
        return;
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return '%';
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.useColors = createDebug.useColors();
    debug.color = createDebug.selectColor(namespace);
    debug.extend = extend;
    debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

    Object.defineProperty(debug, 'enabled', {
      enumerable: true,
      configurable: false,
      get: function get() {
        return enableOverride === null ? createDebug.enabled(namespace) : enableOverride;
      },
      set: function set(v) {
        enableOverride = v;
      }
    }); // Env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    return debug;
  }

  function extend(namespace, delimiter) {
    var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
    newDebug.log = this.log;
    return newDebug;
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */


  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }
  }
  /**
  * Disable debug output.
  *
  * @return {String} namespaces
  * @api public
  */


  function disable() {
    var namespaces = [].concat(_toConsumableArray(createDebug.names.map(toNamespace)), _toConsumableArray(createDebug.skips.map(toNamespace).map(function (namespace) {
      return '-' + namespace;
    }))).join(',');
    createDebug.enable('');
    return namespaces;
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */


  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Convert regexp to namespace
  *
  * @param {RegExp} regxep
  * @return {String} namespace
  * @api private
  */


  function toNamespace(regexp) {
    return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */


  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }
  /**
  * XXX DO NOT USE. This is a temporary stub function.
  * XXX It WILL be removed in the next major release.
  */


  function destroy() {
    console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

module.exports = setup;

/***/ }),

/***/ "./node_modules/engine.io-client/lib/globalThis.browser.js":
/*!*****************************************************************!*\
  !*** ./node_modules/engine.io-client/lib/globalThis.browser.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function () {
  if (typeof self !== "undefined") {
    return self;
  } else if (typeof window !== "undefined") {
    return window;
  } else {
    return Function("return this")();
  }
}();

/***/ }),

/***/ "./node_modules/engine.io-client/lib/index.js":
/*!****************************************************!*\
  !*** ./node_modules/engine.io-client/lib/index.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_66186__) {

var Socket = __nested_webpack_require_66186__(/*! ./socket */ "./node_modules/engine.io-client/lib/socket.js");

module.exports = function (uri, opts) {
  return new Socket(uri, opts);
};
/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */


module.exports.Socket = Socket;
module.exports.protocol = Socket.protocol; // this is an int

module.exports.Transport = __nested_webpack_require_66186__(/*! ./transport */ "./node_modules/engine.io-client/lib/transport.js");
module.exports.transports = __nested_webpack_require_66186__(/*! ./transports/index */ "./node_modules/engine.io-client/lib/transports/index.js");
module.exports.parser = __nested_webpack_require_66186__(/*! engine.io-parser */ "./node_modules/engine.io-parser/lib/index.js");

/***/ }),

/***/ "./node_modules/engine.io-client/lib/socket.js":
/*!*****************************************************!*\
  !*** ./node_modules/engine.io-client/lib/socket.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_67240__) {

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var transports = __nested_webpack_require_67240__(/*! ./transports/index */ "./node_modules/engine.io-client/lib/transports/index.js");

var Emitter = __nested_webpack_require_67240__(/*! component-emitter */ "./node_modules/component-emitter/index.js");

var debug = __nested_webpack_require_67240__(/*! debug */ "./node_modules/debug/src/browser.js")("engine.io-client:socket");

var parser = __nested_webpack_require_67240__(/*! engine.io-parser */ "./node_modules/engine.io-parser/lib/index.js");

var parseuri = __nested_webpack_require_67240__(/*! parseuri */ "./node_modules/parseuri/index.js");

var parseqs = __nested_webpack_require_67240__(/*! parseqs */ "./node_modules/parseqs/index.js");

var Socket = /*#__PURE__*/function (_Emitter) {
  _inherits(Socket, _Emitter);

  var _super = _createSuper(Socket);

  /**
   * Socket constructor.
   *
   * @param {String|Object} uri or options
   * @param {Object} options
   * @api public
   */
  function Socket(uri) {
    var _this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Socket);

    _this = _super.call(this);

    if (uri && "object" === _typeof(uri)) {
      opts = uri;
      uri = null;
    }

    if (uri) {
      uri = parseuri(uri);
      opts.hostname = uri.host;
      opts.secure = uri.protocol === "https" || uri.protocol === "wss";
      opts.port = uri.port;
      if (uri.query) opts.query = uri.query;
    } else if (opts.host) {
      opts.hostname = parseuri(opts.host).host;
    }

    _this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;

    if (opts.hostname && !opts.port) {
      // if no port is specified manually, use the protocol default
      opts.port = _this.secure ? "443" : "80";
    }

    _this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
    _this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : _this.secure ? 443 : 80);
    _this.transports = opts.transports || ["polling", "websocket"];
    _this.readyState = "";
    _this.writeBuffer = [];
    _this.prevBufferLen = 0;
    _this.opts = _extends({
      path: "/engine.io",
      agent: false,
      withCredentials: false,
      upgrade: true,
      jsonp: true,
      timestampParam: "t",
      rememberUpgrade: false,
      rejectUnauthorized: true,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {}
    }, opts);
    _this.opts.path = _this.opts.path.replace(/\/$/, "") + "/";

    if (typeof _this.opts.query === "string") {
      _this.opts.query = parseqs.decode(_this.opts.query);
    } // set on handshake


    _this.id = null;
    _this.upgrades = null;
    _this.pingInterval = null;
    _this.pingTimeout = null; // set on heartbeat

    _this.pingTimeoutTimer = null;

    if (typeof addEventListener === "function") {
      addEventListener("beforeunload", function () {
        if (_this.transport) {
          // silently close the transport
          _this.transport.removeAllListeners();

          _this.transport.close();
        }
      }, false);
    }

    _this.open();

    return _this;
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} transport name
   * @return {Transport}
   * @api private
   */


  _createClass(Socket, [{
    key: "createTransport",
    value: function createTransport(name) {
      debug('creating transport "%s"', name);
      var query = clone(this.opts.query); // append engine.io protocol identifier

      query.EIO = parser.protocol; // transport name

      query.transport = name; // session id if we already have one

      if (this.id) query.sid = this.id;

      var opts = _extends({}, this.opts.transportOptions[name], this.opts, {
        query: query,
        socket: this,
        hostname: this.hostname,
        secure: this.secure,
        port: this.port
      });

      debug("options: %j", opts);
      return new transports[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @api private
     */

  }, {
    key: "open",
    value: function open() {
      var transport;

      if (this.opts.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) {
        transport = "websocket";
      } else if (0 === this.transports.length) {
        // Emit error on next tick so it can be listened to
        var self = this;
        setTimeout(function () {
          self.emit("error", "No transports available");
        }, 0);
        return;
      } else {
        transport = this.transports[0];
      }

      this.readyState = "opening"; // Retry with the next transport if the transport is disabled (jsonp: false)

      try {
        transport = this.createTransport(transport);
      } catch (e) {
        debug("error while creating transport: %s", e);
        this.transports.shift();
        this.open();
        return;
      }

      transport.open();
      this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @api private
     */

  }, {
    key: "setTransport",
    value: function setTransport(transport) {
      debug("setting transport %s", transport.name);
      var self = this;

      if (this.transport) {
        debug("clearing existing transport %s", this.transport.name);
        this.transport.removeAllListeners();
      } // set up transport


      this.transport = transport; // set up transport listeners

      transport.on("drain", function () {
        self.onDrain();
      }).on("packet", function (packet) {
        self.onPacket(packet);
      }).on("error", function (e) {
        self.onError(e);
      }).on("close", function () {
        self.onClose("transport close");
      });
    }
    /**
     * Probes a transport.
     *
     * @param {String} transport name
     * @api private
     */

  }, {
    key: "probe",
    value: function probe(name) {
      debug('probing transport "%s"', name);
      var transport = this.createTransport(name, {
        probe: 1
      });
      var failed = false;
      var self = this;
      Socket.priorWebsocketSuccess = false;

      function onTransportOpen() {
        if (self.onlyBinaryUpgrades) {
          var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
          failed = failed || upgradeLosesBinary;
        }

        if (failed) return;
        debug('probe transport "%s" opened', name);
        transport.send([{
          type: "ping",
          data: "probe"
        }]);
        transport.once("packet", function (msg) {
          if (failed) return;

          if ("pong" === msg.type && "probe" === msg.data) {
            debug('probe transport "%s" pong', name);
            self.upgrading = true;
            self.emit("upgrading", transport);
            if (!transport) return;
            Socket.priorWebsocketSuccess = "websocket" === transport.name;
            debug('pausing current transport "%s"', self.transport.name);
            self.transport.pause(function () {
              if (failed) return;
              if ("closed" === self.readyState) return;
              debug("changing transport and sending upgrade packet");
              cleanup();
              self.setTransport(transport);
              transport.send([{
                type: "upgrade"
              }]);
              self.emit("upgrade", transport);
              transport = null;
              self.upgrading = false;
              self.flush();
            });
          } else {
            debug('probe transport "%s" failed', name);
            var err = new Error("probe error");
            err.transport = transport.name;
            self.emit("upgradeError", err);
          }
        });
      }

      function freezeTransport() {
        if (failed) return; // Any callback called by transport should be ignored since now

        failed = true;
        cleanup();
        transport.close();
        transport = null;
      } // Handle any error that happens while probing


      function onerror(err) {
        var error = new Error("probe error: " + err);
        error.transport = transport.name;
        freezeTransport();
        debug('probe transport "%s" failed because of error: %s', name, err);
        self.emit("upgradeError", error);
      }

      function onTransportClose() {
        onerror("transport closed");
      } // When the socket is closed while we're probing


      function onclose() {
        onerror("socket closed");
      } // When the socket is upgraded while we're probing


      function onupgrade(to) {
        if (transport && to.name !== transport.name) {
          debug('"%s" works - aborting "%s"', to.name, transport.name);
          freezeTransport();
        }
      } // Remove all listeners on the transport and on self


      function cleanup() {
        transport.removeListener("open", onTransportOpen);
        transport.removeListener("error", onerror);
        transport.removeListener("close", onTransportClose);
        self.removeListener("close", onclose);
        self.removeListener("upgrading", onupgrade);
      }

      transport.once("open", onTransportOpen);
      transport.once("error", onerror);
      transport.once("close", onTransportClose);
      this.once("close", onclose);
      this.once("upgrading", onupgrade);
      transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @api public
     */

  }, {
    key: "onOpen",
    value: function onOpen() {
      debug("socket open");
      this.readyState = "open";
      Socket.priorWebsocketSuccess = "websocket" === this.transport.name;
      this.emit("open");
      this.flush(); // we check for `readyState` in case an `open`
      // listener already closed the socket

      if ("open" === this.readyState && this.opts.upgrade && this.transport.pause) {
        debug("starting upgrade probes");
        var i = 0;
        var l = this.upgrades.length;

        for (; i < l; i++) {
          this.probe(this.upgrades[i]);
        }
      }
    }
    /**
     * Handles a packet.
     *
     * @api private
     */

  }, {
    key: "onPacket",
    value: function onPacket(packet) {
      if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
        debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
        this.emit("packet", packet); // Socket is live - any packet counts

        this.emit("heartbeat");

        switch (packet.type) {
          case "open":
            this.onHandshake(JSON.parse(packet.data));
            break;

          case "ping":
            this.resetPingTimeout();
            this.sendPacket("pong");
            this.emit("pong");
            break;

          case "error":
            var err = new Error("server error");
            err.code = packet.data;
            this.onError(err);
            break;

          case "message":
            this.emit("data", packet.data);
            this.emit("message", packet.data);
            break;
        }
      } else {
        debug('packet received with socket readyState "%s"', this.readyState);
      }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} handshake obj
     * @api private
     */

  }, {
    key: "onHandshake",
    value: function onHandshake(data) {
      this.emit("handshake", data);
      this.id = data.sid;
      this.transport.query.sid = data.sid;
      this.upgrades = this.filterUpgrades(data.upgrades);
      this.pingInterval = data.pingInterval;
      this.pingTimeout = data.pingTimeout;
      this.onOpen(); // In case open handler closes socket

      if ("closed" === this.readyState) return;
      this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @api private
     */

  }, {
    key: "resetPingTimeout",
    value: function resetPingTimeout() {
      var _this2 = this;

      clearTimeout(this.pingTimeoutTimer);
      this.pingTimeoutTimer = setTimeout(function () {
        _this2.onClose("ping timeout");
      }, this.pingInterval + this.pingTimeout);
    }
    /**
     * Called on `drain` event
     *
     * @api private
     */

  }, {
    key: "onDrain",
    value: function onDrain() {
      this.writeBuffer.splice(0, this.prevBufferLen); // setting prevBufferLen = 0 is very important
      // for example, when upgrading, upgrade packet is sent over,
      // and a nonzero prevBufferLen could cause problems on `drain`

      this.prevBufferLen = 0;

      if (0 === this.writeBuffer.length) {
        this.emit("drain");
      } else {
        this.flush();
      }
    }
    /**
     * Flush write buffers.
     *
     * @api private
     */

  }, {
    key: "flush",
    value: function flush() {
      if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
        debug("flushing %d packets in socket", this.writeBuffer.length);
        this.transport.send(this.writeBuffer); // keep track of current length of writeBuffer
        // splice writeBuffer and callbackBuffer on `drain`

        this.prevBufferLen = this.writeBuffer.length;
        this.emit("flush");
      }
    }
    /**
     * Sends a message.
     *
     * @param {String} message.
     * @param {Function} callback function.
     * @param {Object} options.
     * @return {Socket} for chaining.
     * @api public
     */

  }, {
    key: "write",
    value: function write(msg, options, fn) {
      this.sendPacket("message", msg, options, fn);
      return this;
    }
  }, {
    key: "send",
    value: function send(msg, options, fn) {
      this.sendPacket("message", msg, options, fn);
      return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} callback function.
     * @api private
     */

  }, {
    key: "sendPacket",
    value: function sendPacket(type, data, options, fn) {
      if ("function" === typeof data) {
        fn = data;
        data = undefined;
      }

      if ("function" === typeof options) {
        fn = options;
        options = null;
      }

      if ("closing" === this.readyState || "closed" === this.readyState) {
        return;
      }

      options = options || {};
      options.compress = false !== options.compress;
      var packet = {
        type: type,
        data: data,
        options: options
      };
      this.emit("packetCreate", packet);
      this.writeBuffer.push(packet);
      if (fn) this.once("flush", fn);
      this.flush();
    }
    /**
     * Closes the connection.
     *
     * @api private
     */

  }, {
    key: "close",
    value: function close() {
      var self = this;

      if ("opening" === this.readyState || "open" === this.readyState) {
        this.readyState = "closing";

        if (this.writeBuffer.length) {
          this.once("drain", function () {
            if (this.upgrading) {
              waitForUpgrade();
            } else {
              close();
            }
          });
        } else if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      }

      function close() {
        self.onClose("forced close");
        debug("socket closing - telling transport to close");
        self.transport.close();
      }

      function cleanupAndClose() {
        self.removeListener("upgrade", cleanupAndClose);
        self.removeListener("upgradeError", cleanupAndClose);
        close();
      }

      function waitForUpgrade() {
        // wait for upgrade to finish since we can't send packets while pausing a transport
        self.once("upgrade", cleanupAndClose);
        self.once("upgradeError", cleanupAndClose);
      }

      return this;
    }
    /**
     * Called upon transport error
     *
     * @api private
     */

  }, {
    key: "onError",
    value: function onError(err) {
      debug("socket error %j", err);
      Socket.priorWebsocketSuccess = false;
      this.emit("error", err);
      this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @api private
     */

  }, {
    key: "onClose",
    value: function onClose(reason, desc) {
      if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
        debug('socket close with reason: "%s"', reason);
        var self = this; // clear timers

        clearTimeout(this.pingIntervalTimer);
        clearTimeout(this.pingTimeoutTimer); // stop event from firing again for transport

        this.transport.removeAllListeners("close"); // ensure transport won't stay open

        this.transport.close(); // ignore further transport communication

        this.transport.removeAllListeners(); // set ready state

        this.readyState = "closed"; // clear session id

        this.id = null; // emit close event

        this.emit("close", reason, desc); // clean buffers after, so users can still
        // grab the buffers on `close` event

        self.writeBuffer = [];
        self.prevBufferLen = 0;
      }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} server upgrades
     * @api private
     *
     */

  }, {
    key: "filterUpgrades",
    value: function filterUpgrades(upgrades) {
      var filteredUpgrades = [];
      var i = 0;
      var j = upgrades.length;

      for (; i < j; i++) {
        if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
      }

      return filteredUpgrades;
    }
  }]);

  return Socket;
}(Emitter);

Socket.priorWebsocketSuccess = false;
/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

function clone(obj) {
  var o = {};

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }

  return o;
}

module.exports = Socket;

/***/ }),

/***/ "./node_modules/engine.io-client/lib/transport.js":
/*!********************************************************!*\
  !*** ./node_modules/engine.io-client/lib/transport.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_88993__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var parser = __nested_webpack_require_88993__(/*! engine.io-parser */ "./node_modules/engine.io-parser/lib/index.js");

var Emitter = __nested_webpack_require_88993__(/*! component-emitter */ "./node_modules/component-emitter/index.js");

var Transport = /*#__PURE__*/function (_Emitter) {
  _inherits(Transport, _Emitter);

  var _super = _createSuper(Transport);

  /**
   * Transport abstract constructor.
   *
   * @param {Object} options.
   * @api private
   */
  function Transport(opts) {
    var _this;

    _classCallCheck(this, Transport);

    _this = _super.call(this);
    _this.opts = opts;
    _this.query = opts.query;
    _this.readyState = "";
    _this.socket = opts.socket;
    return _this;
  }
  /**
   * Emits an error.
   *
   * @param {String} str
   * @return {Transport} for chaining
   * @api public
   */


  _createClass(Transport, [{
    key: "onError",
    value: function onError(msg, desc) {
      var err = new Error(msg);
      err.type = "TransportError";
      err.description = desc;
      this.emit("error", err);
      return this;
    }
    /**
     * Opens the transport.
     *
     * @api public
     */

  }, {
    key: "open",
    value: function open() {
      if ("closed" === this.readyState || "" === this.readyState) {
        this.readyState = "opening";
        this.doOpen();
      }

      return this;
    }
    /**
     * Closes the transport.
     *
     * @api private
     */

  }, {
    key: "close",
    value: function close() {
      if ("opening" === this.readyState || "open" === this.readyState) {
        this.doClose();
        this.onClose();
      }

      return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     * @api private
     */

  }, {
    key: "send",
    value: function send(packets) {
      if ("open" === this.readyState) {
        this.write(packets);
      } else {
        throw new Error("Transport not open");
      }
    }
    /**
     * Called upon open
     *
     * @api private
     */

  }, {
    key: "onOpen",
    value: function onOpen() {
      this.readyState = "open";
      this.writable = true;
      this.emit("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @api private
     */

  }, {
    key: "onData",
    value: function onData(data) {
      var packet = parser.decodePacket(data, this.socket.binaryType);
      this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     */

  }, {
    key: "onPacket",
    value: function onPacket(packet) {
      this.emit("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @api private
     */

  }, {
    key: "onClose",
    value: function onClose() {
      this.readyState = "closed";
      this.emit("close");
    }
  }]);

  return Transport;
}(Emitter);

module.exports = Transport;

/***/ }),

/***/ "./node_modules/engine.io-client/lib/transports/index.js":
/*!***************************************************************!*\
  !*** ./node_modules/engine.io-client/lib/transports/index.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_95139__) {

var XMLHttpRequest = __nested_webpack_require_95139__(/*! xmlhttprequest-ssl */ "./node_modules/engine.io-client/lib/xmlhttprequest.js");

var XHR = __nested_webpack_require_95139__(/*! ./polling-xhr */ "./node_modules/engine.io-client/lib/transports/polling-xhr.js");

var JSONP = __nested_webpack_require_95139__(/*! ./polling-jsonp */ "./node_modules/engine.io-client/lib/transports/polling-jsonp.js");

var websocket = __nested_webpack_require_95139__(/*! ./websocket */ "./node_modules/engine.io-client/lib/transports/websocket.js");

exports.polling = polling;
exports.websocket = websocket;
/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling(opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (typeof location !== "undefined") {
    var isSSL = "https:" === location.protocol;
    var port = location.port; // some user agents have empty `location.port`

    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ("open" in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error("JSONP disabled");
    return new JSONP(opts);
  }
}

/***/ }),

/***/ "./node_modules/engine.io-client/lib/transports/polling-jsonp.js":
/*!***********************************************************************!*\
  !*** ./node_modules/engine.io-client/lib/transports/polling-jsonp.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_96895__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Polling = __nested_webpack_require_96895__(/*! ./polling */ "./node_modules/engine.io-client/lib/transports/polling.js");

var globalThis = __nested_webpack_require_96895__(/*! ../globalThis */ "./node_modules/engine.io-client/lib/globalThis.browser.js");

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;
/**
 * Global JSONP callbacks.
 */

var callbacks;

var JSONPPolling = /*#__PURE__*/function (_Polling) {
  _inherits(JSONPPolling, _Polling);

  var _super = _createSuper(JSONPPolling);

  /**
   * JSONP Polling constructor.
   *
   * @param {Object} opts.
   * @api public
   */
  function JSONPPolling(opts) {
    var _this;

    _classCallCheck(this, JSONPPolling);

    _this = _super.call(this, opts);
    _this.query = _this.query || {}; // define global callbacks array if not present
    // we do this here (lazily) to avoid unneeded global pollution

    if (!callbacks) {
      // we need to consider multiple engines in the same page
      callbacks = globalThis.___eio = globalThis.___eio || [];
    } // callback identifier


    _this.index = callbacks.length; // add callback to jsonp global

    var self = _assertThisInitialized(_this);

    callbacks.push(function (msg) {
      self.onData(msg);
    }); // append to query string

    _this.query.j = _this.index;
    return _this;
  }
  /**
   * JSONP only supports binary as base64 encoded strings
   */


  _createClass(JSONPPolling, [{
    key: "doClose",

    /**
     * Closes the socket.
     *
     * @api private
     */
    value: function doClose() {
      if (this.script) {
        // prevent spurious errors from being emitted when the window is unloaded
        this.script.onerror = function () {};

        this.script.parentNode.removeChild(this.script);
        this.script = null;
      }

      if (this.form) {
        this.form.parentNode.removeChild(this.form);
        this.form = null;
        this.iframe = null;
      }

      _get(_getPrototypeOf(JSONPPolling.prototype), "doClose", this).call(this);
    }
    /**
     * Starts a poll cycle.
     *
     * @api private
     */

  }, {
    key: "doPoll",
    value: function doPoll() {
      var self = this;
      var script = document.createElement("script");

      if (this.script) {
        this.script.parentNode.removeChild(this.script);
        this.script = null;
      }

      script.async = true;
      script.src = this.uri();

      script.onerror = function (e) {
        self.onError("jsonp poll error", e);
      };

      var insertAt = document.getElementsByTagName("script")[0];

      if (insertAt) {
        insertAt.parentNode.insertBefore(script, insertAt);
      } else {
        (document.head || document.body).appendChild(script);
      }

      this.script = script;
      var isUAgecko = "undefined" !== typeof navigator && /gecko/i.test(navigator.userAgent);

      if (isUAgecko) {
        setTimeout(function () {
          var iframe = document.createElement("iframe");
          document.body.appendChild(iframe);
          document.body.removeChild(iframe);
        }, 100);
      }
    }
    /**
     * Writes with a hidden iframe.
     *
     * @param {String} data to send
     * @param {Function} called upon flush.
     * @api private
     */

  }, {
    key: "doWrite",
    value: function doWrite(data, fn) {
      var self = this;
      var iframe;

      if (!this.form) {
        var form = document.createElement("form");
        var area = document.createElement("textarea");
        var id = this.iframeId = "eio_iframe_" + this.index;
        form.className = "socketio";
        form.style.position = "absolute";
        form.style.top = "-1000px";
        form.style.left = "-1000px";
        form.target = id;
        form.method = "POST";
        form.setAttribute("accept-charset", "utf-8");
        area.name = "d";
        form.appendChild(area);
        document.body.appendChild(form);
        this.form = form;
        this.area = area;
      }

      this.form.action = this.uri();

      function complete() {
        initIframe();
        fn();
      }

      function initIframe() {
        if (self.iframe) {
          try {
            self.form.removeChild(self.iframe);
          } catch (e) {
            self.onError("jsonp polling iframe removal error", e);
          }
        }

        try {
          // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
          var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
          iframe = document.createElement(html);
        } catch (e) {
          iframe = document.createElement("iframe");
          iframe.name = self.iframeId;
          iframe.src = "javascript:0";
        }

        iframe.id = self.iframeId;
        self.form.appendChild(iframe);
        self.iframe = iframe;
      }

      initIframe(); // escape \n to prevent it from being converted into \r\n by some UAs
      // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side

      data = data.replace(rEscapedNewline, "\\\n");
      this.area.value = data.replace(rNewline, "\\n");

      try {
        this.form.submit();
      } catch (e) {}

      if (this.iframe.attachEvent) {
        this.iframe.onreadystatechange = function () {
          if (self.iframe.readyState === "complete") {
            complete();
          }
        };
      } else {
        this.iframe.onload = complete;
      }
    }
  }, {
    key: "supportsBinary",
    get: function get() {
      return false;
    }
  }]);

  return JSONPPolling;
}(Polling);

module.exports = JSONPPolling;

/***/ }),

/***/ "./node_modules/engine.io-client/lib/transports/polling-xhr.js":
/*!*********************************************************************!*\
  !*** ./node_modules/engine.io-client/lib/transports/polling-xhr.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_106447__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* global attachEvent */
var XMLHttpRequest = __nested_webpack_require_106447__(/*! xmlhttprequest-ssl */ "./node_modules/engine.io-client/lib/xmlhttprequest.js");

var Polling = __nested_webpack_require_106447__(/*! ./polling */ "./node_modules/engine.io-client/lib/transports/polling.js");

var Emitter = __nested_webpack_require_106447__(/*! component-emitter */ "./node_modules/component-emitter/index.js");

var _require = __nested_webpack_require_106447__(/*! ../util */ "./node_modules/engine.io-client/lib/util.js"),
    pick = _require.pick;

var globalThis = __nested_webpack_require_106447__(/*! ../globalThis */ "./node_modules/engine.io-client/lib/globalThis.browser.js");

var debug = __nested_webpack_require_106447__(/*! debug */ "./node_modules/debug/src/browser.js")("engine.io-client:polling-xhr");
/**
 * Empty function
 */


function empty() {}

var hasXHR2 = function () {
  var xhr = new XMLHttpRequest({
    xdomain: false
  });
  return null != xhr.responseType;
}();

var XHR = /*#__PURE__*/function (_Polling) {
  _inherits(XHR, _Polling);

  var _super = _createSuper(XHR);

  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @api public
   */
  function XHR(opts) {
    var _this;

    _classCallCheck(this, XHR);

    _this = _super.call(this, opts);

    if (typeof location !== "undefined") {
      var isSSL = "https:" === location.protocol;
      var port = location.port; // some user agents have empty `location.port`

      if (!port) {
        port = isSSL ? 443 : 80;
      }

      _this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
      _this.xs = opts.secure !== isSSL;
    }
    /**
     * XHR supports binary
     */


    var forceBase64 = opts && opts.forceBase64;
    _this.supportsBinary = hasXHR2 && !forceBase64;
    return _this;
  }
  /**
   * Creates a request.
   *
   * @param {String} method
   * @api private
   */


  _createClass(XHR, [{
    key: "request",
    value: function request() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _extends(opts, {
        xd: this.xd,
        xs: this.xs
      }, this.opts);

      return new Request(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @api private
     */

  }, {
    key: "doWrite",
    value: function doWrite(data, fn) {
      var req = this.request({
        method: "POST",
        data: data
      });
      var self = this;
      req.on("success", fn);
      req.on("error", function (err) {
        self.onError("xhr post error", err);
      });
    }
    /**
     * Starts a poll cycle.
     *
     * @api private
     */

  }, {
    key: "doPoll",
    value: function doPoll() {
      debug("xhr poll");
      var req = this.request();
      var self = this;
      req.on("data", function (data) {
        self.onData(data);
      });
      req.on("error", function (err) {
        self.onError("xhr poll error", err);
      });
      this.pollXhr = req;
    }
  }]);

  return XHR;
}(Polling);

var Request = /*#__PURE__*/function (_Emitter) {
  _inherits(Request, _Emitter);

  var _super2 = _createSuper(Request);

  /**
   * Request constructor
   *
   * @param {Object} options
   * @api public
   */
  function Request(uri, opts) {
    var _this2;

    _classCallCheck(this, Request);

    _this2 = _super2.call(this);
    _this2.opts = opts;
    _this2.method = opts.method || "GET";
    _this2.uri = uri;
    _this2.async = false !== opts.async;
    _this2.data = undefined !== opts.data ? opts.data : null;

    _this2.create();

    return _this2;
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @api private
   */


  _createClass(Request, [{
    key: "create",
    value: function create() {
      var opts = pick(this.opts, "agent", "enablesXDR", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized");
      opts.xdomain = !!this.opts.xd;
      opts.xscheme = !!this.opts.xs;
      var xhr = this.xhr = new XMLHttpRequest(opts);
      var self = this;

      try {
        debug("xhr open %s: %s", this.method, this.uri);
        xhr.open(this.method, this.uri, this.async);

        try {
          if (this.opts.extraHeaders) {
            xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);

            for (var i in this.opts.extraHeaders) {
              if (this.opts.extraHeaders.hasOwnProperty(i)) {
                xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
              }
            }
          }
        } catch (e) {}

        if ("POST" === this.method) {
          try {
            xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
          } catch (e) {}
        }

        try {
          xhr.setRequestHeader("Accept", "*/*");
        } catch (e) {} // ie6 check


        if ("withCredentials" in xhr) {
          xhr.withCredentials = this.opts.withCredentials;
        }

        if (this.opts.requestTimeout) {
          xhr.timeout = this.opts.requestTimeout;
        }

        if (this.hasXDR()) {
          xhr.onload = function () {
            self.onLoad();
          };

          xhr.onerror = function () {
            self.onError(xhr.responseText);
          };
        } else {
          xhr.onreadystatechange = function () {
            if (4 !== xhr.readyState) return;

            if (200 === xhr.status || 1223 === xhr.status) {
              self.onLoad();
            } else {
              // make sure the `error` event handler that's user-set
              // does not throw in the same tick and gets caught here
              setTimeout(function () {
                self.onError(typeof xhr.status === "number" ? xhr.status : 0);
              }, 0);
            }
          };
        }

        debug("xhr data %s", this.data);
        xhr.send(this.data);
      } catch (e) {
        // Need to defer since .create() is called directly from the constructor
        // and thus the 'error' event can only be only bound *after* this exception
        // occurs.  Therefore, also, we cannot throw here at all.
        setTimeout(function () {
          self.onError(e);
        }, 0);
        return;
      }

      if (typeof document !== "undefined") {
        this.index = Request.requestsCount++;
        Request.requests[this.index] = this;
      }
    }
    /**
     * Called upon successful response.
     *
     * @api private
     */

  }, {
    key: "onSuccess",
    value: function onSuccess() {
      this.emit("success");
      this.cleanup();
    }
    /**
     * Called if we have data.
     *
     * @api private
     */

  }, {
    key: "onData",
    value: function onData(data) {
      this.emit("data", data);
      this.onSuccess();
    }
    /**
     * Called upon error.
     *
     * @api private
     */

  }, {
    key: "onError",
    value: function onError(err) {
      this.emit("error", err);
      this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @api private
     */

  }, {
    key: "cleanup",
    value: function cleanup(fromError) {
      if ("undefined" === typeof this.xhr || null === this.xhr) {
        return;
      } // xmlhttprequest


      if (this.hasXDR()) {
        this.xhr.onload = this.xhr.onerror = empty;
      } else {
        this.xhr.onreadystatechange = empty;
      }

      if (fromError) {
        try {
          this.xhr.abort();
        } catch (e) {}
      }

      if (typeof document !== "undefined") {
        delete Request.requests[this.index];
      }

      this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @api private
     */

  }, {
    key: "onLoad",
    value: function onLoad() {
      var data = this.xhr.responseText;

      if (data !== null) {
        this.onData(data);
      }
    }
    /**
     * Check if it has XDomainRequest.
     *
     * @api private
     */

  }, {
    key: "hasXDR",
    value: function hasXDR() {
      return typeof XDomainRequest !== "undefined" && !this.xs && this.enablesXDR;
    }
    /**
     * Aborts the request.
     *
     * @api public
     */

  }, {
    key: "abort",
    value: function abort() {
      this.cleanup();
    }
  }]);

  return Request;
}(Emitter);
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */


Request.requestsCount = 0;
Request.requests = {};

if (typeof document !== "undefined") {
  if (typeof attachEvent === "function") {
    attachEvent("onunload", unloadHandler);
  } else if (typeof addEventListener === "function") {
    var terminationEvent = "onpagehide" in globalThis ? "pagehide" : "unload";
    addEventListener(terminationEvent, unloadHandler, false);
  }
}

function unloadHandler() {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}

module.exports = XHR;
module.exports.Request = Request;

/***/ }),

/***/ "./node_modules/engine.io-client/lib/transports/polling.js":
/*!*****************************************************************!*\
  !*** ./node_modules/engine.io-client/lib/transports/polling.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_119090__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Transport = __nested_webpack_require_119090__(/*! ../transport */ "./node_modules/engine.io-client/lib/transport.js");

var parseqs = __nested_webpack_require_119090__(/*! parseqs */ "./node_modules/parseqs/index.js");

var parser = __nested_webpack_require_119090__(/*! engine.io-parser */ "./node_modules/engine.io-parser/lib/index.js");

var yeast = __nested_webpack_require_119090__(/*! yeast */ "./node_modules/yeast/index.js");

var debug = __nested_webpack_require_119090__(/*! debug */ "./node_modules/debug/src/browser.js")("engine.io-client:polling");

var Polling = /*#__PURE__*/function (_Transport) {
  _inherits(Polling, _Transport);

  var _super = _createSuper(Polling);

  function Polling() {
    _classCallCheck(this, Polling);

    return _super.apply(this, arguments);
  }

  _createClass(Polling, [{
    key: "doOpen",

    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @api private
     */
    value: function doOpen() {
      this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} callback upon buffers are flushed and transport is paused
     * @api private
     */

  }, {
    key: "pause",
    value: function pause(onPause) {
      var self = this;
      this.readyState = "pausing";

      function pause() {
        debug("paused");
        self.readyState = "paused";
        onPause();
      }

      if (this.polling || !this.writable) {
        var total = 0;

        if (this.polling) {
          debug("we are currently polling - waiting to pause");
          total++;
          this.once("pollComplete", function () {
            debug("pre-pause polling complete");
            --total || pause();
          });
        }

        if (!this.writable) {
          debug("we are currently writing - waiting to pause");
          total++;
          this.once("drain", function () {
            debug("pre-pause writing complete");
            --total || pause();
          });
        }
      } else {
        pause();
      }
    }
    /**
     * Starts polling cycle.
     *
     * @api public
     */

  }, {
    key: "poll",
    value: function poll() {
      debug("polling");
      this.polling = true;
      this.doPoll();
      this.emit("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @api private
     */

  }, {
    key: "onData",
    value: function onData(data) {
      var self = this;
      debug("polling got data %s", data);

      var callback = function callback(packet, index, total) {
        // if its the first message we consider the transport open
        if ("opening" === self.readyState && packet.type === "open") {
          self.onOpen();
        } // if its a close packet, we close the ongoing requests


        if ("close" === packet.type) {
          self.onClose();
          return false;
        } // otherwise bypass onData and handle the message


        self.onPacket(packet);
      }; // decode payload


      parser.decodePayload(data, this.socket.binaryType).forEach(callback); // if an event did not trigger closing

      if ("closed" !== this.readyState) {
        // if we got data we're not polling
        this.polling = false;
        this.emit("pollComplete");

        if ("open" === this.readyState) {
          this.poll();
        } else {
          debug('ignoring poll - transport state "%s"', this.readyState);
        }
      }
    }
    /**
     * For polling, send a close packet.
     *
     * @api private
     */

  }, {
    key: "doClose",
    value: function doClose() {
      var self = this;

      function close() {
        debug("writing close packet");
        self.write([{
          type: "close"
        }]);
      }

      if ("open" === this.readyState) {
        debug("transport open - closing");
        close();
      } else {
        // in case we're trying to close while
        // handshaking is in progress (GH-164)
        debug("transport not open - deferring close");
        this.once("open", close);
      }
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} data packets
     * @param {Function} drain callback
     * @api private
     */

  }, {
    key: "write",
    value: function write(packets) {
      var _this = this;

      this.writable = false;
      parser.encodePayload(packets, function (data) {
        _this.doWrite(data, function () {
          _this.writable = true;

          _this.emit("drain");
        });
      });
    }
    /**
     * Generates uri for connection.
     *
     * @api private
     */

  }, {
    key: "uri",
    value: function uri() {
      var query = this.query || {};
      var schema = this.opts.secure ? "https" : "http";
      var port = ""; // cache busting is forced

      if (false !== this.opts.timestampRequests) {
        query[this.opts.timestampParam] = yeast();
      }

      if (!this.supportsBinary && !query.sid) {
        query.b64 = 1;
      }

      query = parseqs.encode(query); // avoid port if default for schema

      if (this.opts.port && ("https" === schema && Number(this.opts.port) !== 443 || "http" === schema && Number(this.opts.port) !== 80)) {
        port = ":" + this.opts.port;
      } // prepend ? to query


      if (query.length) {
        query = "?" + query;
      }

      var ipv6 = this.opts.hostname.indexOf(":") !== -1;
      return schema + "://" + (ipv6 ? "[" + this.opts.hostname + "]" : this.opts.hostname) + port + this.opts.path + query;
    }
  }, {
    key: "name",

    /**
     * Transport name.
     */
    get: function get() {
      return "polling";
    }
  }]);

  return Polling;
}(Transport);

module.exports = Polling;

/***/ }),

/***/ "./node_modules/engine.io-client/lib/transports/websocket-constructor.browser.js":
/*!***************************************************************************************!*\
  !*** ./node_modules/engine.io-client/lib/transports/websocket-constructor.browser.js ***!
  \***************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_128162__) {

var globalThis = __nested_webpack_require_128162__(/*! ../globalThis */ "./node_modules/engine.io-client/lib/globalThis.browser.js");

module.exports = {
  WebSocket: globalThis.WebSocket || globalThis.MozWebSocket,
  usingBrowserWebSocket: true,
  defaultBinaryType: "arraybuffer"
};

/***/ }),

/***/ "./node_modules/engine.io-client/lib/transports/websocket.js":
/*!*******************************************************************!*\
  !*** ./node_modules/engine.io-client/lib/transports/websocket.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_128820__) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Transport = __nested_webpack_require_128820__(/*! ../transport */ "./node_modules/engine.io-client/lib/transport.js");

var parser = __nested_webpack_require_128820__(/*! engine.io-parser */ "./node_modules/engine.io-parser/lib/index.js");

var parseqs = __nested_webpack_require_128820__(/*! parseqs */ "./node_modules/parseqs/index.js");

var yeast = __nested_webpack_require_128820__(/*! yeast */ "./node_modules/yeast/index.js");

var _require = __nested_webpack_require_128820__(/*! ../util */ "./node_modules/engine.io-client/lib/util.js"),
    pick = _require.pick;

var _require2 = __nested_webpack_require_128820__(/*! ./websocket-constructor */ "./node_modules/engine.io-client/lib/transports/websocket-constructor.browser.js"),
    WebSocket = _require2.WebSocket,
    usingBrowserWebSocket = _require2.usingBrowserWebSocket,
    defaultBinaryType = _require2.defaultBinaryType;

var debug = __nested_webpack_require_128820__(/*! debug */ "./node_modules/debug/src/browser.js")("engine.io-client:websocket"); // detect ReactNative environment


var isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";

var WS = /*#__PURE__*/function (_Transport) {
  _inherits(WS, _Transport);

  var _super = _createSuper(WS);

  /**
   * WebSocket transport constructor.
   *
   * @api {Object} connection options
   * @api public
   */
  function WS(opts) {
    var _this;

    _classCallCheck(this, WS);

    _this = _super.call(this, opts);
    _this.supportsBinary = !opts.forceBase64;
    return _this;
  }
  /**
   * Transport name.
   *
   * @api public
   */


  _createClass(WS, [{
    key: "doOpen",

    /**
     * Opens socket.
     *
     * @api private
     */
    value: function doOpen() {
      if (!this.check()) {
        // let probe timeout
        return;
      }

      var uri = this.uri();
      var protocols = this.opts.protocols; // React Native only supports the 'headers' option, and will print a warning if anything else is passed

      var opts = isReactNative ? {} : pick(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");

      if (this.opts.extraHeaders) {
        opts.headers = this.opts.extraHeaders;
      }

      try {
        this.ws = usingBrowserWebSocket && !isReactNative ? protocols ? new WebSocket(uri, protocols) : new WebSocket(uri) : new WebSocket(uri, protocols, opts);
      } catch (err) {
        return this.emit("error", err);
      }

      this.ws.binaryType = this.socket.binaryType || defaultBinaryType;
      this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @api private
     */

  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var self = this;

      this.ws.onopen = function () {
        self.onOpen();
      };

      this.ws.onclose = function () {
        self.onClose();
      };

      this.ws.onmessage = function (ev) {
        self.onData(ev.data);
      };

      this.ws.onerror = function (e) {
        self.onError("websocket error", e);
      };
    }
    /**
     * Writes data to socket.
     *
     * @param {Array} array of packets.
     * @api private
     */

  }, {
    key: "write",
    value: function write(packets) {
      var self = this;
      this.writable = false; // encodePacket efficient as it uses WS framing
      // no need for encodePayload

      var total = packets.length;
      var i = 0;
      var l = total;

      for (; i < l; i++) {
        (function (packet) {
          parser.encodePacket(packet, self.supportsBinary, function (data) {
            // always create a new object (GH-437)
            var opts = {};

            if (!usingBrowserWebSocket) {
              if (packet.options) {
                opts.compress = packet.options.compress;
              }

              if (self.opts.perMessageDeflate) {
                var len = "string" === typeof data ? Buffer.byteLength(data) : data.length;

                if (len < self.opts.perMessageDeflate.threshold) {
                  opts.compress = false;
                }
              }
            } // Sometimes the websocket has already been closed but the browser didn't
            // have a chance of informing us about it yet, in that case send will
            // throw an error


            try {
              if (usingBrowserWebSocket) {
                // TypeError is thrown when passing the second argument on Safari
                self.ws.send(data);
              } else {
                self.ws.send(data, opts);
              }
            } catch (e) {
              debug("websocket closed before onclose event");
            }

            --total || done();
          });
        })(packets[i]);
      }

      function done() {
        self.emit("flush"); // fake drain
        // defer to next tick to allow Socket to clear writeBuffer

        setTimeout(function () {
          self.writable = true;
          self.emit("drain");
        }, 0);
      }
    }
    /**
     * Called upon close
     *
     * @api private
     */

  }, {
    key: "onClose",
    value: function onClose() {
      Transport.prototype.onClose.call(this);
    }
    /**
     * Closes socket.
     *
     * @api private
     */

  }, {
    key: "doClose",
    value: function doClose() {
      if (typeof this.ws !== "undefined") {
        this.ws.close();
        this.ws = null;
      }
    }
    /**
     * Generates uri for connection.
     *
     * @api private
     */

  }, {
    key: "uri",
    value: function uri() {
      var query = this.query || {};
      var schema = this.opts.secure ? "wss" : "ws";
      var port = ""; // avoid port if default for schema

      if (this.opts.port && ("wss" === schema && Number(this.opts.port) !== 443 || "ws" === schema && Number(this.opts.port) !== 80)) {
        port = ":" + this.opts.port;
      } // append timestamp to URI


      if (this.opts.timestampRequests) {
        query[this.opts.timestampParam] = yeast();
      } // communicate binary support capabilities


      if (!this.supportsBinary) {
        query.b64 = 1;
      }

      query = parseqs.encode(query); // prepend ? to query

      if (query.length) {
        query = "?" + query;
      }

      var ipv6 = this.opts.hostname.indexOf(":") !== -1;
      return schema + "://" + (ipv6 ? "[" + this.opts.hostname + "]" : this.opts.hostname) + port + this.opts.path + query;
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @api public
     */

  }, {
    key: "check",
    value: function check() {
      return !!WebSocket && !("__initialize" in WebSocket && this.name === WS.prototype.name);
    }
  }, {
    key: "name",
    get: function get() {
      return "websocket";
    }
  }]);

  return WS;
}(Transport);

module.exports = WS;

/***/ }),

/***/ "./node_modules/engine.io-client/lib/util.js":
/*!***************************************************!*\
  !*** ./node_modules/engine.io-client/lib/util.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports.pick = function (obj) {
  for (var _len = arguments.length, attr = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    attr[_key - 1] = arguments[_key];
  }

  return attr.reduce(function (acc, k) {
    if (obj.hasOwnProperty(k)) {
      acc[k] = obj[k];
    }

    return acc;
  }, {});
};

/***/ }),

/***/ "./node_modules/engine.io-client/lib/xmlhttprequest.js":
/*!*************************************************************!*\
  !*** ./node_modules/engine.io-client/lib/xmlhttprequest.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_139713__) {

// browser shim for xmlhttprequest module
var hasCORS = __nested_webpack_require_139713__(/*! has-cors */ "./node_modules/has-cors/index.js");

var globalThis = __nested_webpack_require_139713__(/*! ./globalThis */ "./node_modules/engine.io-client/lib/globalThis.browser.js");

module.exports = function (opts) {
  var xdomain = opts.xdomain; // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx

  var xscheme = opts.xscheme; // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217

  var enablesXDR = opts.enablesXDR; // XMLHttpRequest can be disabled on IE

  try {
    if ("undefined" !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) {} // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example


  try {
    if ("undefined" !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) {}

  if (!xdomain) {
    try {
      return new globalThis[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
  }
};

/***/ }),

/***/ "./node_modules/engine.io-parser/lib/commons.js":
/*!******************************************************!*\
  !*** ./node_modules/engine.io-parser/lib/commons.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var PACKET_TYPES = Object.create(null); // no Map = no polyfill

PACKET_TYPES["open"] = "0";
PACKET_TYPES["close"] = "1";
PACKET_TYPES["ping"] = "2";
PACKET_TYPES["pong"] = "3";
PACKET_TYPES["message"] = "4";
PACKET_TYPES["upgrade"] = "5";
PACKET_TYPES["noop"] = "6";
var PACKET_TYPES_REVERSE = Object.create(null);
Object.keys(PACKET_TYPES).forEach(function (key) {
  PACKET_TYPES_REVERSE[PACKET_TYPES[key]] = key;
});
var ERROR_PACKET = {
  type: "error",
  data: "parser error"
};
module.exports = {
  PACKET_TYPES: PACKET_TYPES,
  PACKET_TYPES_REVERSE: PACKET_TYPES_REVERSE,
  ERROR_PACKET: ERROR_PACKET
};

/***/ }),

/***/ "./node_modules/engine.io-parser/lib/decodePacket.browser.js":
/*!*******************************************************************!*\
  !*** ./node_modules/engine.io-parser/lib/decodePacket.browser.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_142385__) {

var _require = __nested_webpack_require_142385__(/*! ./commons */ "./node_modules/engine.io-parser/lib/commons.js"),
    PACKET_TYPES_REVERSE = _require.PACKET_TYPES_REVERSE,
    ERROR_PACKET = _require.ERROR_PACKET;

var withNativeArrayBuffer = typeof ArrayBuffer === "function";
var base64decoder;

if (withNativeArrayBuffer) {
  base64decoder = __nested_webpack_require_142385__(/*! base64-arraybuffer */ "./node_modules/engine.io-parser/node_modules/base64-arraybuffer/lib/base64-arraybuffer.js");
}

var decodePacket = function decodePacket(encodedPacket, binaryType) {
  if (typeof encodedPacket !== "string") {
    return {
      type: "message",
      data: mapBinary(encodedPacket, binaryType)
    };
  }

  var type = encodedPacket.charAt(0);

  if (type === "b") {
    return {
      type: "message",
      data: decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
  }

  var packetType = PACKET_TYPES_REVERSE[type];

  if (!packetType) {
    return ERROR_PACKET;
  }

  return encodedPacket.length > 1 ? {
    type: PACKET_TYPES_REVERSE[type],
    data: encodedPacket.substring(1)
  } : {
    type: PACKET_TYPES_REVERSE[type]
  };
};

var decodeBase64Packet = function decodeBase64Packet(data, binaryType) {
  if (base64decoder) {
    var decoded = base64decoder.decode(data);
    return mapBinary(decoded, binaryType);
  } else {
    return {
      base64: true,
      data: data
    }; // fallback for old browsers
  }
};

var mapBinary = function mapBinary(data, binaryType) {
  switch (binaryType) {
    case "blob":
      return data instanceof ArrayBuffer ? new Blob([data]) : data;

    case "arraybuffer":
    default:
      return data;
    // assuming the data is already an ArrayBuffer
  }
};

module.exports = decodePacket;

/***/ }),

/***/ "./node_modules/engine.io-parser/lib/encodePacket.browser.js":
/*!*******************************************************************!*\
  !*** ./node_modules/engine.io-parser/lib/encodePacket.browser.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_144506__) {

var _require = __nested_webpack_require_144506__(/*! ./commons */ "./node_modules/engine.io-parser/lib/commons.js"),
    PACKET_TYPES = _require.PACKET_TYPES;

var withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
var withNativeArrayBuffer = typeof ArrayBuffer === "function"; // ArrayBuffer.isView method is not defined in IE10

var isView = function isView(obj) {
  return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};

var encodePacket = function encodePacket(_ref, supportsBinary, callback) {
  var type = _ref.type,
      data = _ref.data;

  if (withNativeBlob && data instanceof Blob) {
    if (supportsBinary) {
      return callback(data);
    } else {
      return encodeBlobAsBase64(data, callback);
    }
  } else if (withNativeArrayBuffer && (data instanceof ArrayBuffer || isView(data))) {
    if (supportsBinary) {
      return callback(data instanceof ArrayBuffer ? data : data.buffer);
    } else {
      return encodeBlobAsBase64(new Blob([data]), callback);
    }
  } // plain string


  return callback(PACKET_TYPES[type] + (data || ""));
};

var encodeBlobAsBase64 = function encodeBlobAsBase64(data, callback) {
  var fileReader = new FileReader();

  fileReader.onload = function () {
    var content = fileReader.result.split(",")[1];
    callback("b" + content);
  };

  return fileReader.readAsDataURL(data);
};

module.exports = encodePacket;

/***/ }),

/***/ "./node_modules/engine.io-parser/lib/index.js":
/*!****************************************************!*\
  !*** ./node_modules/engine.io-parser/lib/index.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_146354__) {

var encodePacket = __nested_webpack_require_146354__(/*! ./encodePacket */ "./node_modules/engine.io-parser/lib/encodePacket.browser.js");

var decodePacket = __nested_webpack_require_146354__(/*! ./decodePacket */ "./node_modules/engine.io-parser/lib/decodePacket.browser.js");

var SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text

var encodePayload = function encodePayload(packets, callback) {
  // some packets may be added to the array while encoding, so the initial length must be saved
  var length = packets.length;
  var encodedPackets = new Array(length);
  var count = 0;
  packets.forEach(function (packet, i) {
    // force base64 encoding for binary packets
    encodePacket(packet, false, function (encodedPacket) {
      encodedPackets[i] = encodedPacket;

      if (++count === length) {
        callback(encodedPackets.join(SEPARATOR));
      }
    });
  });
};

var decodePayload = function decodePayload(encodedPayload, binaryType) {
  var encodedPackets = encodedPayload.split(SEPARATOR);
  var packets = [];

  for (var i = 0; i < encodedPackets.length; i++) {
    var decodedPacket = decodePacket(encodedPackets[i], binaryType);
    packets.push(decodedPacket);

    if (decodedPacket.type === "error") {
      break;
    }
  }

  return packets;
};

module.exports = {
  protocol: 4,
  encodePacket: encodePacket,
  encodePayload: encodePayload,
  decodePacket: decodePacket,
  decodePayload: decodePayload
};

/***/ }),

/***/ "./node_modules/engine.io-parser/node_modules/base64-arraybuffer/lib/base64-arraybuffer.js":
/*!*************************************************************************************************!*\
  !*** ./node_modules/engine.io-parser/node_modules/base64-arraybuffer/lib/base64-arraybuffer.js ***!
  \*************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function (chars) {
  "use strict";

  exports.encode = function (arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
        i,
        len = bytes.length,
        base64 = "";

    for (i = 0; i < len; i += 3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
      base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
      base64 += chars[bytes[i + 2] & 63];
    }

    if (len % 3 === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode = function (base64) {
    var bufferLength = base64.length * 0.75,
        len = base64.length,
        i,
        p = 0,
        encoded1,
        encoded2,
        encoded3,
        encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;

      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
        bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i += 4) {
      encoded1 = chars.indexOf(base64[i]);
      encoded2 = chars.indexOf(base64[i + 1]);
      encoded3 = chars.indexOf(base64[i + 2]);
      encoded4 = chars.indexOf(base64[i + 3]);
      bytes[p++] = encoded1 << 2 | encoded2 >> 4;
      bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
      bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }

    return arraybuffer;
  };
})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");

/***/ }),

/***/ "./node_modules/has-cors/index.js":
/*!****************************************!*\
  !*** ./node_modules/has-cors/index.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */
try {
  module.exports = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}

/***/ }),

/***/ "./node_modules/ms/index.js":
/*!**********************************!*\
  !*** ./node_modules/ms/index.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Helpers.
 */
var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};

  var type = _typeof(val);

  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options["long"] ? fmtLong(val) : fmtShort(val);
  }

  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */


function parse(str) {
  str = String(str);

  if (str.length > 100) {
    return;
  }

  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);

  if (!match) {
    return;
  }

  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();

  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;

    case 'weeks':
    case 'week':
    case 'w':
      return n * w;

    case 'days':
    case 'day':
    case 'd':
      return n * d;

    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;

    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;

    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;

    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;

    default:
      return undefined;
  }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtShort(ms) {
  var msAbs = Math.abs(ms);

  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }

  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }

  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }

  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }

  return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtLong(ms) {
  var msAbs = Math.abs(ms);

  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }

  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }

  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }

  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }

  return ms + ' ms';
}
/**
 * Pluralization helper.
 */


function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

/***/ }),

/***/ "./node_modules/parseqs/index.js":
/*!***************************************!*\
  !*** ./node_modules/parseqs/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */
exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};
/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */


exports.decode = function (qs) {
  var qry = {};
  var pairs = qs.split('&');

  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }

  return qry;
};

/***/ }),

/***/ "./node_modules/parseuri/index.js":
/*!****************************************!*\
  !*** ./node_modules/parseuri/index.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */
var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
var parts = ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'];

module.exports = function parseuri(str) {
  var src = str,
      b = str.indexOf('['),
      e = str.indexOf(']');

  if (b != -1 && e != -1) {
    str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
  }

  var m = re.exec(str || ''),
      uri = {},
      i = 14;

  while (i--) {
    uri[parts[i]] = m[i] || '';
  }

  if (b != -1 && e != -1) {
    uri.source = src;
    uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
    uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
    uri.ipv6uri = true;
  }

  uri.pathNames = pathNames(uri, uri['path']);
  uri.queryKey = queryKey(uri, uri['query']);
  return uri;
};

function pathNames(obj, path) {
  var regx = /\/{2,9}/g,
      names = path.replace(regx, "/").split("/");

  if (path.substr(0, 1) == '/' || path.length === 0) {
    names.splice(0, 1);
  }

  if (path.substr(path.length - 1, 1) == '/') {
    names.splice(names.length - 1, 1);
  }

  return names;
}

function queryKey(uri, query) {
  var data = {};
  query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
    if ($1) {
      data[$1] = $2;
    }
  });
  return data;
}

/***/ }),

/***/ "./node_modules/socket.io-parser/dist/binary.js":
/*!******************************************************!*\
  !*** ./node_modules/socket.io-parser/dist/binary.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_157635__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reconstructPacket = exports.deconstructPacket = void 0;

var is_binary_1 = __nested_webpack_require_157635__(/*! ./is-binary */ "./node_modules/socket.io-parser/dist/is-binary.js");
/**
 * Replaces every Buffer | ArrayBuffer | Blob | File in packet with a numbered placeholder.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @public
 */


function deconstructPacket(packet) {
  var buffers = [];
  var packetData = packet.data;
  var pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length; // number of binary 'attachments'

  return {
    packet: pack,
    buffers: buffers
  };
}

exports.deconstructPacket = deconstructPacket;

function _deconstructPacket(data, buffers) {
  if (!data) return data;

  if (is_binary_1.isBinary(data)) {
    var placeholder = {
      _placeholder: true,
      num: buffers.length
    };
    buffers.push(data);
    return placeholder;
  } else if (Array.isArray(data)) {
    var newData = new Array(data.length);

    for (var i = 0; i < data.length; i++) {
      newData[i] = _deconstructPacket(data[i], buffers);
    }

    return newData;
  } else if (_typeof(data) === "object" && !(data instanceof Date)) {
    var _newData = {};

    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        _newData[key] = _deconstructPacket(data[key], buffers);
      }
    }

    return _newData;
  }

  return data;
}
/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @public
 */


function reconstructPacket(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  packet.attachments = undefined; // no longer useful

  return packet;
}

exports.reconstructPacket = reconstructPacket;

function _reconstructPacket(data, buffers) {
  if (!data) return data;

  if (data && data._placeholder) {
    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
  } else if (Array.isArray(data)) {
    for (var i = 0; i < data.length; i++) {
      data[i] = _reconstructPacket(data[i], buffers);
    }
  } else if (_typeof(data) === "object") {
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        data[key] = _reconstructPacket(data[key], buffers);
      }
    }
  }

  return data;
}

/***/ }),

/***/ "./node_modules/socket.io-parser/dist/index.js":
/*!*****************************************************!*\
  !*** ./node_modules/socket.io-parser/dist/index.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_160942__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Decoder = exports.Encoder = exports.PacketType = exports.protocol = void 0;

var Emitter = __nested_webpack_require_160942__(/*! component-emitter */ "./node_modules/component-emitter/index.js");

var binary_1 = __nested_webpack_require_160942__(/*! ./binary */ "./node_modules/socket.io-parser/dist/binary.js");

var is_binary_1 = __nested_webpack_require_160942__(/*! ./is-binary */ "./node_modules/socket.io-parser/dist/is-binary.js");

var debug = __nested_webpack_require_160942__(/*! debug */ "./node_modules/debug/src/browser.js")("socket.io-parser");
/**
 * Protocol version.
 *
 * @public
 */


exports.protocol = 5;
var PacketType;

(function (PacketType) {
  PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
  PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
  PacketType[PacketType["EVENT"] = 2] = "EVENT";
  PacketType[PacketType["ACK"] = 3] = "ACK";
  PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
  PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
  PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})(PacketType = exports.PacketType || (exports.PacketType = {}));
/**
 * A socket.io Encoder instance
 */


var Encoder = /*#__PURE__*/function () {
  function Encoder() {
    _classCallCheck(this, Encoder);
  }

  _createClass(Encoder, [{
    key: "encode",

    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */
    value: function encode(obj) {
      debug("encoding packet %j", obj);

      if (obj.type === PacketType.EVENT || obj.type === PacketType.ACK) {
        if (is_binary_1.hasBinary(obj)) {
          obj.type = obj.type === PacketType.EVENT ? PacketType.BINARY_EVENT : PacketType.BINARY_ACK;
          return this.encodeAsBinary(obj);
        }
      }

      return [this.encodeAsString(obj)];
    }
    /**
     * Encode packet as string.
     */

  }, {
    key: "encodeAsString",
    value: function encodeAsString(obj) {
      // first is type
      var str = "" + obj.type; // attachments if we have them

      if (obj.type === PacketType.BINARY_EVENT || obj.type === PacketType.BINARY_ACK) {
        str += obj.attachments + "-";
      } // if we have a namespace other than `/`
      // we append it followed by a comma `,`


      if (obj.nsp && "/" !== obj.nsp) {
        str += obj.nsp + ",";
      } // immediately followed by the id


      if (null != obj.id) {
        str += obj.id;
      } // json data


      if (null != obj.data) {
        str += JSON.stringify(obj.data);
      }

      debug("encoded %j as %s", obj, str);
      return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */

  }, {
    key: "encodeAsBinary",
    value: function encodeAsBinary(obj) {
      var deconstruction = binary_1.deconstructPacket(obj);
      var pack = this.encodeAsString(deconstruction.packet);
      var buffers = deconstruction.buffers;
      buffers.unshift(pack); // add packet info to beginning of data list

      return buffers; // write all the buffers
    }
  }]);

  return Encoder;
}();

exports.Encoder = Encoder;
/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 */

var Decoder = /*#__PURE__*/function (_Emitter) {
  _inherits(Decoder, _Emitter);

  var _super = _createSuper(Decoder);

  function Decoder() {
    _classCallCheck(this, Decoder);

    return _super.call(this);
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */


  _createClass(Decoder, [{
    key: "add",
    value: function add(obj) {
      var packet;

      if (typeof obj === "string") {
        packet = this.decodeString(obj);

        if (packet.type === PacketType.BINARY_EVENT || packet.type === PacketType.BINARY_ACK) {
          // binary packet's json
          this.reconstructor = new BinaryReconstructor(packet); // no attachments, labeled binary but no binary data to follow

          if (packet.attachments === 0) {
            _get(_getPrototypeOf(Decoder.prototype), "emit", this).call(this, "decoded", packet);
          }
        } else {
          // non-binary full packet
          _get(_getPrototypeOf(Decoder.prototype), "emit", this).call(this, "decoded", packet);
        }
      } else if (is_binary_1.isBinary(obj) || obj.base64) {
        // raw binary data
        if (!this.reconstructor) {
          throw new Error("got binary data when not reconstructing a packet");
        } else {
          packet = this.reconstructor.takeBinaryData(obj);

          if (packet) {
            // received final buffer
            this.reconstructor = null;

            _get(_getPrototypeOf(Decoder.prototype), "emit", this).call(this, "decoded", packet);
          }
        }
      } else {
        throw new Error("Unknown type: " + obj);
      }
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */

  }, {
    key: "decodeString",
    value: function decodeString(str) {
      var i = 0; // look up type

      var p = {
        type: Number(str.charAt(0))
      };

      if (PacketType[p.type] === undefined) {
        throw new Error("unknown packet type " + p.type);
      } // look up attachments if type binary


      if (p.type === PacketType.BINARY_EVENT || p.type === PacketType.BINARY_ACK) {
        var start = i + 1;

        while (str.charAt(++i) !== "-" && i != str.length) {}

        var buf = str.substring(start, i);

        if (buf != Number(buf) || str.charAt(i) !== "-") {
          throw new Error("Illegal attachments");
        }

        p.attachments = Number(buf);
      } // look up namespace (if any)


      if ("/" === str.charAt(i + 1)) {
        var _start = i + 1;

        while (++i) {
          var c = str.charAt(i);
          if ("," === c) break;
          if (i === str.length) break;
        }

        p.nsp = str.substring(_start, i);
      } else {
        p.nsp = "/";
      } // look up id


      var next = str.charAt(i + 1);

      if ("" !== next && Number(next) == next) {
        var _start2 = i + 1;

        while (++i) {
          var _c = str.charAt(i);

          if (null == _c || Number(_c) != _c) {
            --i;
            break;
          }

          if (i === str.length) break;
        }

        p.id = Number(str.substring(_start2, i + 1));
      } // look up json data


      if (str.charAt(++i)) {
        var payload = tryParse(str.substr(i));

        if (Decoder.isPayloadValid(p.type, payload)) {
          p.data = payload;
        } else {
          throw new Error("invalid payload");
        }
      }

      debug("decoded %s as %j", str, p);
      return p;
    }
  }, {
    key: "destroy",

    /**
     * Deallocates a parser's resources
     */
    value: function destroy() {
      if (this.reconstructor) {
        this.reconstructor.finishedReconstruction();
      }
    }
  }], [{
    key: "isPayloadValid",
    value: function isPayloadValid(type, payload) {
      switch (type) {
        case PacketType.CONNECT:
          return _typeof(payload) === "object";

        case PacketType.DISCONNECT:
          return payload === undefined;

        case PacketType.CONNECT_ERROR:
          return typeof payload === "string" || _typeof(payload) === "object";

        case PacketType.EVENT:
        case PacketType.BINARY_EVENT:
          return Array.isArray(payload) && payload.length > 0;

        case PacketType.ACK:
        case PacketType.BINARY_ACK:
          return Array.isArray(payload);
      }
    }
  }]);

  return Decoder;
}(Emitter);

exports.Decoder = Decoder;

function tryParse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return false;
  }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */


var BinaryReconstructor = /*#__PURE__*/function () {
  function BinaryReconstructor(packet) {
    _classCallCheck(this, BinaryReconstructor);

    this.packet = packet;
    this.buffers = [];
    this.reconPack = packet;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */


  _createClass(BinaryReconstructor, [{
    key: "takeBinaryData",
    value: function takeBinaryData(binData) {
      this.buffers.push(binData);

      if (this.buffers.length === this.reconPack.attachments) {
        // done with buffer list
        var packet = binary_1.reconstructPacket(this.reconPack, this.buffers);
        this.finishedReconstruction();
        return packet;
      }

      return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */

  }, {
    key: "finishedReconstruction",
    value: function finishedReconstruction() {
      this.reconPack = null;
      this.buffers = [];
    }
  }]);

  return BinaryReconstructor;
}();

/***/ }),

/***/ "./node_modules/socket.io-parser/dist/is-binary.js":
/*!*********************************************************!*\
  !*** ./node_modules/socket.io-parser/dist/is-binary.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasBinary = exports.isBinary = void 0;
var withNativeArrayBuffer = typeof ArrayBuffer === "function";

var isView = function isView(obj) {
  return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};

var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && toString.call(Blob) === "[object BlobConstructor]";
var withNativeFile = typeof File === "function" || typeof File !== "undefined" && toString.call(File) === "[object FileConstructor]";
/**
 * Returns true if obj is a Buffer, an ArrayBuffer, a Blob or a File.
 *
 * @private
 */

function isBinary(obj) {
  return withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)) || withNativeBlob && obj instanceof Blob || withNativeFile && obj instanceof File;
}

exports.isBinary = isBinary;

function hasBinary(obj, toJSON) {
  if (!obj || _typeof(obj) !== "object") {
    return false;
  }

  if (Array.isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      if (hasBinary(obj[i])) {
        return true;
      }
    }

    return false;
  }

  if (isBinary(obj)) {
    return true;
  }

  if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }

  return false;
}

exports.hasBinary = hasBinary;

/***/ }),

/***/ "./node_modules/yeast/index.js":
/*!*************************************!*\
  !*** ./node_modules/yeast/index.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''),
    length = 64,
    map = {},
    seed = 0,
    i = 0,
    prev;
/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */

function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}
/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */


function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}
/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */


function yeast() {
  var now = encode(+new Date());
  if (now !== prev) return seed = 0, prev = now;
  return now + '.' + encode(seed++);
} //
// Map each character to its index.
//


for (; i < length; i++) {
  map[alphabet[i]] = i;
} //
// Expose the `yeast`, `encode` and `decode` functions.
//


yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;

/***/ })

/******/ });
});
//# sourceMappingURL=socket.io.js.map

/***/ }),
/* 4 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getUUID": function() { return /* binding */ getUUID; }
/* harmony export */ });
var getUUID = function (randomLength) {
    if (randomLength === void 0) { randomLength = 2; }
    return Number(Math.random()
        .toString()
        .substr(2, randomLength) + Date.now()).toString(36);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvdXVpZC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxPQUFPLEdBQUcsVUFBQyxZQUFnQjtJQUFoQiw2QkFBQSxFQUFBLGdCQUFnQjtJQUN0QyxPQUFPLE1BQU0sQ0FDWCxJQUFJLENBQUMsTUFBTSxFQUFFO1NBQ1YsUUFBUSxFQUFFO1NBQ1YsTUFBTSxDQUFDLENBQUMsRUFBRSxZQUFZLENBQUMsR0FBRyxJQUFJLENBQUMsR0FBRyxFQUFFLENBQ3hDLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0FBQ2pCLENBQUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBnZXRVVUlEID0gKHJhbmRvbUxlbmd0aCA9IDIpID0+IHtcbiAgcmV0dXJuIE51bWJlcihcbiAgICBNYXRoLnJhbmRvbSgpXG4gICAgICAudG9TdHJpbmcoKVxuICAgICAgLnN1YnN0cigyLCByYW5kb21MZW5ndGgpICsgRGF0ZS5ub3coKVxuICApLnRvU3RyaW5nKDM2KTtcbn07XG4iXX0=

/***/ }),
/* 5 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _package_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var CatLogger = /** @class */ (function () {
    function CatLogger() {
        this.appInfo = {};
        this.uuid = '';
        this.clientVersion = '';
    }
    CatLogger.prototype.init = function (appConfig) {
        this.appInfo = appConfig;
    };
    CatLogger.prototype.setUUID = function (uuid) {
        this.uuid = uuid;
    };
    CatLogger.prototype.setClientVersion = function (version) {
        this.clientVersion = version;
    };
    CatLogger.prototype.setLogger = function (loggerInstance) {
        this.loggerInstance = loggerInstance;
    };
    CatLogger.prototype.log = function (msg, params, level) {
        var opts = {
            level: level,
            category: 'jsError',
        };
        opts.tags = __assign(__assign(__assign({}, params), this.appInfo), this.appInfo.extraAppInfo);
        opts.tags.uuid = this.uuid;
        opts.tags.clientVersion = this.clientVersion;
        opts.tags.sdkVersion = _package_json__WEBPACK_IMPORTED_MODULE_0__.version;
        this.loggerInstance &&
            this.loggerInstance.addError('[MTOB-Client] ' + msg, opts);
    };
    CatLogger.prototype.logInfo = function (msg, params) {
        this.log(msg, params, 'info');
    };
    CatLogger.prototype.logWarning = function (msg, params) {
        this.log(msg, params, 'warn');
    };
    CatLogger.prototype.logError = function (msg, params) {
        this.log(msg, params, 'error');
    };
    return CatLogger;
}());
/* harmony default export */ __webpack_exports__["default"] = (new CatLogger());
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvbG9nZ2VyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxHQUFHLE1BQU0sdUJBQXVCLENBQUM7QUFFeEM7SUFBQTtRQUNVLFlBQU8sR0FBUSxFQUFFLENBQUM7UUFDbEIsU0FBSSxHQUFHLEVBQUUsQ0FBQztRQUNWLGtCQUFhLEdBQUcsRUFBRSxDQUFDO0lBK0M3QixDQUFDO0lBNUNRLHdCQUFJLEdBQVgsVUFBWSxTQUFjO1FBQ3hCLElBQUksQ0FBQyxPQUFPLEdBQUcsU0FBUyxDQUFDO0lBQzNCLENBQUM7SUFFTSwyQkFBTyxHQUFkLFVBQWUsSUFBWTtRQUN6QixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztJQUNuQixDQUFDO0lBRU0sb0NBQWdCLEdBQXZCLFVBQXdCLE9BQWU7UUFDckMsSUFBSSxDQUFDLGFBQWEsR0FBRyxPQUFPLENBQUM7SUFDL0IsQ0FBQztJQUVNLDZCQUFTLEdBQWhCLFVBQWlCLGNBQW1CO1FBQ2xDLElBQUksQ0FBQyxjQUFjLEdBQUcsY0FBYyxDQUFDO0lBQ3ZDLENBQUM7SUFFRCx1QkFBRyxHQUFILFVBQUksR0FBRyxFQUFFLE1BQU0sRUFBRSxLQUFLO1FBQ3BCLElBQU0sSUFBSSxHQUFRO1lBQ2hCLEtBQUssT0FBQTtZQUNMLFFBQVEsRUFBRSxTQUFTO1NBQ3BCLENBQUM7UUFDRixJQUFJLENBQUMsSUFBSSxrQ0FDSixNQUFNLEdBQ04sSUFBSSxDQUFDLE9BQU8sR0FDWixJQUFJLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FDN0IsQ0FBQztRQUNGLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUM7UUFDM0IsSUFBSSxDQUFDLElBQUksQ0FBQyxhQUFhLEdBQUcsSUFBSSxDQUFDLGFBQWEsQ0FBQztRQUM3QyxJQUFJLENBQUMsSUFBSSxDQUFDLFVBQVUsR0FBRyxHQUFHLENBQUMsT0FBTyxDQUFDO1FBQ25DLElBQUksQ0FBQyxjQUFjO1lBQ2pCLElBQUksQ0FBQyxjQUFjLENBQUMsUUFBUSxDQUFDLGdCQUFnQixHQUFHLEdBQUcsRUFBRSxJQUFJLENBQUMsQ0FBQztJQUMvRCxDQUFDO0lBRUQsMkJBQU8sR0FBUCxVQUFRLEdBQUcsRUFBRSxNQUFPO1FBQ2xCLElBQUksQ0FBQyxHQUFHLENBQUMsR0FBRyxFQUFFLE1BQU0sRUFBRSxNQUFNLENBQUMsQ0FBQztJQUNoQyxDQUFDO0lBRUQsOEJBQVUsR0FBVixVQUFXLEdBQUcsRUFBRSxNQUFPO1FBQ3JCLElBQUksQ0FBQyxHQUFHLENBQUMsR0FBRyxFQUFFLE1BQU0sRUFBRSxNQUFNLENBQUMsQ0FBQztJQUNoQyxDQUFDO0lBRUQsNEJBQVEsR0FBUixVQUFTLEdBQUcsRUFBRSxNQUFPO1FBQ25CLElBQUksQ0FBQyxHQUFHLENBQUMsR0FBRyxFQUFFLE1BQU0sRUFBRSxPQUFPLENBQUMsQ0FBQztJQUNqQyxDQUFDO0lBQ0gsZ0JBQUM7QUFBRCxDQUFDLEFBbERELElBa0RDO0FBRUQsZUFBZSxJQUFJLFNBQVMsRUFBRSxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHBrZyBmcm9tICcuLi8uLi8uLi9wYWNrYWdlLmpzb24nO1xuXG5jbGFzcyBDYXRMb2dnZXIge1xuICBwcml2YXRlIGFwcEluZm86IGFueSA9IHt9O1xuICBwcml2YXRlIHV1aWQgPSAnJztcbiAgcHJpdmF0ZSBjbGllbnRWZXJzaW9uID0gJyc7XG4gIHByaXZhdGUgbG9nZ2VySW5zdGFuY2U6IGFueTtcblxuICBwdWJsaWMgaW5pdChhcHBDb25maWc6IGFueSkge1xuICAgIHRoaXMuYXBwSW5mbyA9IGFwcENvbmZpZztcbiAgfVxuXG4gIHB1YmxpYyBzZXRVVUlEKHV1aWQ6IHN0cmluZykge1xuICAgIHRoaXMudXVpZCA9IHV1aWQ7XG4gIH1cblxuICBwdWJsaWMgc2V0Q2xpZW50VmVyc2lvbih2ZXJzaW9uOiBzdHJpbmcpIHtcbiAgICB0aGlzLmNsaWVudFZlcnNpb24gPSB2ZXJzaW9uO1xuICB9XG5cbiAgcHVibGljIHNldExvZ2dlcihsb2dnZXJJbnN0YW5jZTogYW55KSB7XG4gICAgdGhpcy5sb2dnZXJJbnN0YW5jZSA9IGxvZ2dlckluc3RhbmNlO1xuICB9XG5cbiAgbG9nKG1zZywgcGFyYW1zLCBsZXZlbCkge1xuICAgIGNvbnN0IG9wdHM6IGFueSA9IHtcbiAgICAgIGxldmVsLFxuICAgICAgY2F0ZWdvcnk6ICdqc0Vycm9yJyxcbiAgICB9O1xuICAgIG9wdHMudGFncyA9IHtcbiAgICAgIC4uLnBhcmFtcyxcbiAgICAgIC4uLnRoaXMuYXBwSW5mbyxcbiAgICAgIC4uLnRoaXMuYXBwSW5mby5leHRyYUFwcEluZm8sXG4gICAgfTtcbiAgICBvcHRzLnRhZ3MudXVpZCA9IHRoaXMudXVpZDtcbiAgICBvcHRzLnRhZ3MuY2xpZW50VmVyc2lvbiA9IHRoaXMuY2xpZW50VmVyc2lvbjtcbiAgICBvcHRzLnRhZ3Muc2RrVmVyc2lvbiA9IHBrZy52ZXJzaW9uO1xuICAgIHRoaXMubG9nZ2VySW5zdGFuY2UgJiZcbiAgICAgIHRoaXMubG9nZ2VySW5zdGFuY2UuYWRkRXJyb3IoJ1tNVE9CLUNsaWVudF0gJyArIG1zZywgb3B0cyk7XG4gIH1cblxuICBsb2dJbmZvKG1zZywgcGFyYW1zPykge1xuICAgIHRoaXMubG9nKG1zZywgcGFyYW1zLCAnaW5mbycpO1xuICB9XG5cbiAgbG9nV2FybmluZyhtc2csIHBhcmFtcz8pIHtcbiAgICB0aGlzLmxvZyhtc2csIHBhcmFtcywgJ3dhcm4nKTtcbiAgfVxuXG4gIGxvZ0Vycm9yKG1zZywgcGFyYW1zPykge1xuICAgIHRoaXMubG9nKG1zZywgcGFyYW1zLCAnZXJyb3InKTtcbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBuZXcgQ2F0TG9nZ2VyKCk7XG4iXX0=

/***/ }),
/* 6 */
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@mtfe/mtob-client","version":"2.1.5-beta-light.1","description":"MTOB Web SDK","main":"dist/mtob-client.js","files":["dist"],"types":"dist/types/index.d.ts","scripts":{"test":"jest","prepublish":"npm run pack","pack":"webpack --config webpack.conf.js","examples":"webpack-dev-server --config webpack.examples.js","lint":"./node_modules/.bin/eslint"},"dependencies":{"socket.io-client":"^3.0.4"},"repository":{"type":"git","url":"ssh://git@git.sankuai.com/klfe/web_component_mtob.git"},"author":"luanmingyang","license":"ISC","devDependencies":{"@kl/eslint-config-recommended":"0.0.15","@types/jest":"^23.3.1","@types/node":"^10.5.5","@types/socket.io-client":"^1.4.34","jest":"^26.6.3","prettier":"^1.16.4","ts-jest":"^23.0.1","ts-lint":"^4.5.1","ts-loader":"^5.4.5","tslint":"^5.11.0","tslint-loader":"^3.5.4","typescript":"^4.3.5","webpack":"^5.11.0","webpack-cli":"^4.2.0"}}');

/***/ }),
/* 7 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MTOB_CLIENT_EVENT": function() { return /* binding */ MTOB_CLIENT_EVENT; },
/* harmony export */   "EMTOBStatus": function() { return /* binding */ EMTOBStatus; },
/* harmony export */   "ESDKEvents": function() { return /* binding */ ESDKEvents; },
/* harmony export */   "ESDKStatus": function() { return /* binding */ ESDKStatus; }
/* harmony export */ });
var MTOB_CLIENT_EVENT = {
    OPTIONS_UPDATE: 'options-update',
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
};
var EMTOBStatus;
(function (EMTOBStatus) {
    EMTOBStatus["Disconnected"] = "disconnected";
    EMTOBStatus["Connected"] = "connected";
    EMTOBStatus["Connecting"] = "connecting";
    EMTOBStatus["NeedUpdate"] = "need-update";
})(EMTOBStatus || (EMTOBStatus = {}));
var ESDKEvents;
(function (ESDKEvents) {
    ESDKEvents["StatusChange"] = "status-change";
})(ESDKEvents || (ESDKEvents = {}));
var ESDKStatus;
(function (ESDKStatus) {
    ESDKStatus["READY"] = "ready";
    ESDKStatus["ERROR"] = "error";
    ESDKStatus["DISCONNECTED"] = "disconnected";
    ESDKStatus["MTOB_UPDATE_REQUIRED"] = "mtob-update-required";
})(ESDKStatus || (ESDKStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxpQkFBaUIsR0FBRztJQUMvQixjQUFjLEVBQUUsZ0JBQWdCO0lBQ2hDLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLFVBQVUsRUFBRSxZQUFZO0NBQ3pCLENBQUM7QUFFRixNQUFNLENBQU4sSUFBWSxXQUtYO0FBTEQsV0FBWSxXQUFXO0lBQ3JCLDRDQUE2QixDQUFBO0lBQzdCLHNDQUF1QixDQUFBO0lBQ3ZCLHdDQUF5QixDQUFBO0lBQ3pCLHlDQUEwQixDQUFBO0FBQzVCLENBQUMsRUFMVyxXQUFXLEtBQVgsV0FBVyxRQUt0QjtBQUVELE1BQU0sQ0FBTixJQUFZLFVBRVg7QUFGRCxXQUFZLFVBQVU7SUFDcEIsNENBQThCLENBQUE7QUFDaEMsQ0FBQyxFQUZXLFVBQVUsS0FBVixVQUFVLFFBRXJCO0FBRUQsTUFBTSxDQUFOLElBQVksVUFLWDtBQUxELFdBQVksVUFBVTtJQUNwQiw2QkFBZSxDQUFBO0lBQ2YsNkJBQWUsQ0FBQTtJQUNmLDJDQUE2QixDQUFBO0lBQzdCLDJEQUE2QyxDQUFBO0FBQy9DLENBQUMsRUFMVyxVQUFVLEtBQVYsVUFBVSxRQUtyQiIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBNVE9CX0NMSUVOVF9FVkVOVCA9IHtcbiAgT1BUSU9OU19VUERBVEU6ICdvcHRpb25zLXVwZGF0ZScsXG4gIENPTk5FQ1Q6ICdjb25uZWN0JyxcbiAgRElTQ09OTkVDVDogJ2Rpc2Nvbm5lY3QnLFxufTtcblxuZXhwb3J0IGVudW0gRU1UT0JTdGF0dXMge1xuICBEaXNjb25uZWN0ZWQgPSAnZGlzY29ubmVjdGVkJyxcbiAgQ29ubmVjdGVkID0gJ2Nvbm5lY3RlZCcsXG4gIENvbm5lY3RpbmcgPSAnY29ubmVjdGluZycsXG4gIE5lZWRVcGRhdGUgPSAnbmVlZC11cGRhdGUnLFxufVxuXG5leHBvcnQgZW51bSBFU0RLRXZlbnRzIHtcbiAgU3RhdHVzQ2hhbmdlID0gJ3N0YXR1cy1jaGFuZ2UnLFxufVxuXG5leHBvcnQgZW51bSBFU0RLU3RhdHVzIHtcbiAgUkVBRFkgPSAncmVhZHknLFxuICBFUlJPUiA9ICdlcnJvcicsXG4gIERJU0NPTk5FQ1RFRCA9ICdkaXNjb25uZWN0ZWQnLFxuICBNVE9CX1VQREFURV9SRVFVSVJFRCA9ICdtdG9iLXVwZGF0ZS1yZXF1aXJlZCcsXG59XG4iXX0=

/***/ }),
/* 8 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ClientError": function() { return /* binding */ ClientError; }
/* harmony export */ });
var ClientError = {
    CLIENT_OPTIONS_ERROR: { message: 'appName参数必填' },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvcmUvY2xpZW50L2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxXQUFXLEdBQUc7SUFDekIsb0JBQW9CLEVBQUUsRUFBRSxPQUFPLEVBQUUsYUFBYSxFQUFFO0NBQ2pELENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgQ2xpZW50RXJyb3IgPSB7XG4gIENMSUVOVF9PUFRJT05TX0VSUk9SOiB7IG1lc3NhZ2U6ICdhcHBOYW1l5Y+C5pWw5b+F5aGrJyB9LFxufTtcbiJdfQ==

/***/ }),
/* 9 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
    AUTHENTICATE: '/server/authenticate',
    // V1
    SERVER_GETINFO: 'server/getServerInfo',
    SERVER_UPDATE: 'server/update',
    // V2
    GET_AGENT_INFO: 'getAgentInfo',
    GET_GLOBAL_CONFIG: 'getGlobalConfig',
    SET_GLOBAL_CONFIG: 'setGlobalConfig',
    UPGRADE: 'updateAgentVerison',
    // version >= 3.0.0 支持
    CHECK_FOR_UPDATE: 'checkForUpdate',
    GET_UPDATE_INFO: 'getUpdateInfo',
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBpLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvcmUvY2xpZW50L2FwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxlQUFlO0lBQ2IsWUFBWSxFQUFFLHNCQUFzQjtJQUVwQyxLQUFLO0lBQ0wsY0FBYyxFQUFFLHNCQUFzQjtJQUN0QyxhQUFhLEVBQUUsZUFBZTtJQUU5QixLQUFLO0lBQ0wsY0FBYyxFQUFFLGNBQWM7SUFDOUIsaUJBQWlCLEVBQUUsaUJBQWlCO0lBQ3BDLGlCQUFpQixFQUFFLGlCQUFpQjtJQUNwQyxPQUFPLEVBQUUsb0JBQW9CO0lBRTdCLHNCQUFzQjtJQUN0QixnQkFBZ0IsRUFBRSxnQkFBZ0I7SUFDbEMsZUFBZSxFQUFFLGVBQWU7Q0FDakMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcbiAgQVVUSEVOVElDQVRFOiAnL3NlcnZlci9hdXRoZW50aWNhdGUnLFxuXG4gIC8vIFYxXG4gIFNFUlZFUl9HRVRJTkZPOiAnc2VydmVyL2dldFNlcnZlckluZm8nLFxuICBTRVJWRVJfVVBEQVRFOiAnc2VydmVyL3VwZGF0ZScsXG5cbiAgLy8gVjJcbiAgR0VUX0FHRU5UX0lORk86ICdnZXRBZ2VudEluZm8nLFxuICBHRVRfR0xPQkFMX0NPTkZJRzogJ2dldEdsb2JhbENvbmZpZycsXG4gIFNFVF9HTE9CQUxfQ09ORklHOiAnc2V0R2xvYmFsQ29uZmlnJyxcbiAgVVBHUkFERTogJ3VwZGF0ZUFnZW50VmVyaXNvbicsXG5cbiAgLy8gdmVyc2lvbiA+PSAzLjAuMCDmlK/mjIFcbiAgQ0hFQ0tfRk9SX1VQREFURTogJ2NoZWNrRm9yVXBkYXRlJyxcbiAgR0VUX1VQREFURV9JTkZPOiAnZ2V0VXBkYXRlSW5mbycsXG59O1xuIl19

/***/ }),
/* 10 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _core_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony import */ var _v1__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11);
/* harmony import */ var _v2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16);




var MTOBPrinter = /** @class */ (function () {
    function MTOBPrinter() {
        var _this = this;
        this.initialized = false;
        this.printer2 = new _v2__WEBPACK_IMPORTED_MODULE_3__.MTOBPrinterV2();
        this.printer = this.printer2;
        _core_client__WEBPACK_IMPORTED_MODULE_0__.default.on(_constants__WEBPACK_IMPORTED_MODULE_1__.MTOB_CLIENT_EVENT.OPTIONS_UPDATE, function (options, remoteConfig) {
            if (_this.printer instanceof _v2__WEBPACK_IMPORTED_MODULE_3__.MTOBPrinterV2) {
                remoteConfig && _this.printer.setDowngradeOptions(remoteConfig, true);
            }
            _this.printer.setOptions(options);
        });
        _core_client__WEBPACK_IMPORTED_MODULE_0__.default.on(_constants__WEBPACK_IMPORTED_MODULE_1__.MTOB_CLIENT_EVENT.CONNECT, function (clientType) {
            if (!_this.initialized) {
                _this.initialized = true;
                if (clientType === 'V2') {
                    _this.printer2 = _this.printer2 || new _v2__WEBPACK_IMPORTED_MODULE_3__.MTOBPrinterV2();
                    _this.printer = _this.printer2;
                }
                else {
                    _this.printer1 = _this.printer1 || new _v1__WEBPACK_IMPORTED_MODULE_2__.MTOBPrinterV1();
                    _this.printer = _this.printer1;
                }
                _this.printer.init();
            }
        });
        _core_client__WEBPACK_IMPORTED_MODULE_0__.default.on(_constants__WEBPACK_IMPORTED_MODULE_1__.MTOB_CLIENT_EVENT.DISCONNECT, function () {
            _this.initialized = false;
            _this.printer.destroy();
            _this.printer = _this.printer2;
        });
        return new Proxy(this, {
            get: function (_target, prop) {
                if (Object.prototype.hasOwnProperty.call(_this, prop)) {
                    return _this[prop];
                }
                return (_this.printer || {})[prop];
            },
            set: function (_target, prop, value) {
                if (_this.printer) {
                    _this.printer[prop] = value;
                    return true;
                }
                return false;
            },
        });
    }
    MTOBPrinter.prototype.init = function (options) {
        _core_client__WEBPACK_IMPORTED_MODULE_0__.default.init(options);
    };
    return MTOBPrinter;
}());
/* harmony default export */ __webpack_exports__["default"] = (new MTOBPrinter());
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 11 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MTOBPrinterV1": function() { return /* binding */ MTOBPrinterV1; }
/* harmony export */ });
/* harmony import */ var _utils_EventEmitter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _core_client_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var _utils_TemplateManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var MTOB_PRINT_EVENT = {
    TASK_ADDED: 'task-added',
    TASK_START: 'task-start',
    TASK_COMPLETE: 'task-complete',
    TASK_ALL_COMPLETE: 'task-all-complete',
    TASK_CANCELED: 'task-canceled',
    TASK_ERROR: 'task-error',
};
var MTOBPrinterV1 = /** @class */ (function (_super) {
    __extends(MTOBPrinterV1, _super);
    function MTOBPrinterV1() {
        var _this = _super.call(this) || this;
        _this.counter = 0;
        _this.emitter = new _utils_EventEmitter__WEBPACK_IMPORTED_MODULE_0__.default();
        _this.templateManager = new _utils_TemplateManager__WEBPACK_IMPORTED_MODULE_2__.default();
        return _this;
    }
    MTOBPrinterV1.prototype.init = function () {
        var _this = this;
        _core_client_index__WEBPACK_IMPORTED_MODULE_1__.default.ipcOn(_api__WEBPACK_IMPORTED_MODULE_3__.default.PRINTER_QUEUE_STATUS_UPDATE, function (args) { return _this.onTaskStatusChangeNotify(args); });
    };
    MTOBPrinterV1.prototype.destroy = function () {
        _core_client_index__WEBPACK_IMPORTED_MODULE_1__.default.ipcOff(_api__WEBPACK_IMPORTED_MODULE_3__.default.PRINTER_QUEUE_STATUS_UPDATE);
    };
    MTOBPrinterV1.prototype.setOptions = function (options) {
        this.templateManager.setEnvAndProjectId(options.env, options.projectId);
    };
    // V1版本不支持
    MTOBPrinterV1.prototype.setDowngradeOptions = function () {
        return Promise.reject('客户端版本过低');
    };
    // V1版本不支持
    MTOBPrinterV1.prototype.getDowngradeOptions = function () {
        return Promise.resolve({ downgrade: false });
    };
    // 获取打印机列表
    MTOBPrinterV1.prototype.getPrinterList = function () {
        return new Promise(function (resolve, reject) {
            _core_client_index__WEBPACK_IMPORTED_MODULE_1__.default.ipc(_api__WEBPACK_IMPORTED_MODULE_3__.default.PRINTER_GETLIST, null, function (res) {
                if (res && res.result && res.result.printerList && !res.error) {
                    resolve(res.result.printerList);
                }
                else {
                    reject(res.error);
                }
            });
        });
    };
    // V1版本不支持，直接返回[]
    MTOBPrinterV1.prototype.getUSBPrinterList = function () {
        return Promise.resolve([]);
    };
    // V1版本不支持检测打印机状态，直接返回NORMAL
    MTOBPrinterV1.prototype.getPrinterStatus = function () {
        return Promise.resolve(_constants__WEBPACK_IMPORTED_MODULE_5__.EPrinterStatus.NORMAL);
    };
    // V1版本不支持
    MTOBPrinterV1.prototype.setPrinterConfig = function () {
        return Promise.resolve();
    };
    // V1版本不支持
    MTOBPrinterV1.prototype.getPrinterConfig = function () {
        return Promise.resolve(null);
    };
    // V1版本不支持
    MTOBPrinterV1.prototype.getPrintTaskQueueStatus = function () {
        return Promise.resolve(null);
    };
    // 打印，传入的数据如果是数组，则为批量打印
    MTOBPrinterV1.prototype.print = function (data, options) {
        return __awaiter(this, void 0, void 0, function () {
            var mode, templateId, template, timeout, _a, _b, _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!data || !options) {
                            return [2 /*return*/, Promise.reject(_constants__WEBPACK_IMPORTED_MODULE_5__.PrintError.PRINT_PARAMS_ERROR)];
                        }
                        mode = options.mode, templateId = options.templateId, template = options.template, timeout = options.timeout;
                        if (!templateId && !template) {
                            return [2 /*return*/, Promise.reject(_constants__WEBPACK_IMPORTED_MODULE_5__.PrintError.TEMPLATE_EMPTY_ERROR)];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 5, , 6]);
                        _a = options;
                        if (!templateId) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.templateManager.getTemplates(templateId)];
                    case 2:
                        _b = _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _b = template;
                        _d.label = 4;
                    case 4:
                        _a.template = _b;
                        return [3 /*break*/, 6];
                    case 5:
                        _c = _d.sent();
                        return [2 /*return*/, Promise.reject(_constants__WEBPACK_IMPORTED_MODULE_5__.PrintError.TEMPLATE_FETCH_ERROR)];
                    case 6:
                        if (!mode) {
                            options.mode = _types__WEBPACK_IMPORTED_MODULE_4__.EPrintMode.DRIVER;
                        }
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var taskId = ++_this.counter % 10000;
                                var timer;
                                if (timeout) {
                                    timer = setTimeout(function () {
                                        reject(__assign({ taskID: taskId, msg: _constants__WEBPACK_IMPORTED_MODULE_5__.PrintError.PRINT_TIMEOUT_ERROR.message }, _constants__WEBPACK_IMPORTED_MODULE_5__.PrintError.PRINT_TIMEOUT_ERROR));
                                    }, timeout);
                                }
                                _core_client_index__WEBPACK_IMPORTED_MODULE_1__.default.ipc(_api__WEBPACK_IMPORTED_MODULE_3__.default.PRINTER_PRINT, {
                                    data: data,
                                    config: __assign(__assign({}, options), { taskId: taskId, templateType: 'mtpl' }),
                                }, function (res) {
                                    clearTimeout(timer);
                                    if (!res || res.error) {
                                        reject({ taskID: taskId, message: res.error, msg: res.error });
                                    }
                                });
                                _this.emitter.once("" + taskId, function (result) {
                                    clearTimeout(timer);
                                    result
                                        ? resolve({ taskId: taskId })
                                        : reject(__assign({ taskID: taskId }, _constants__WEBPACK_IMPORTED_MODULE_5__.PrintError.PRINT_FAILED_ERROR));
                                });
                            })];
                }
            });
        });
    };
    // V1版本不支持
    MTOBPrinterV1.prototype.openPrinterDeviceDialog = function () {
        return Promise.reject('客户端版本过低');
    };
    // V1版本不支持
    MTOBPrinterV1.prototype.openPreferenceDialog = function () {
        return Promise.reject('客户端版本过低');
    };
    // 重试打印失败的任务
    MTOBPrinterV1.prototype.retryFailedTasks = function () {
        return new Promise(function (resolve, reject) {
            _core_client_index__WEBPACK_IMPORTED_MODULE_1__.default.ipc(_api__WEBPACK_IMPORTED_MODULE_3__.default.PRINTER_RESUME_PRINTING, null, function (res) {
                if (res && !res.error) {
                    resolve(res.success);
                }
                else {
                    reject(res.error);
                }
            });
        });
    };
    // 取消失败的任务
    MTOBPrinterV1.prototype.cancelFailedTasks = function () {
        return new Promise(function (resolve, reject) {
            _core_client_index__WEBPACK_IMPORTED_MODULE_1__.default.ipc(_api__WEBPACK_IMPORTED_MODULE_3__.default.PRINTER_ABORT_PRINTING, null, function (res) {
                if (res && !res.error) {
                    resolve(res.success);
                }
                else {
                    reject(res.error);
                }
            });
        });
    };
    // 跳过当前任务
    MTOBPrinterV1.prototype.skipCurrent = function () {
        return new Promise(function (resolve, reject) {
            _core_client_index__WEBPACK_IMPORTED_MODULE_1__.default.ipc(_api__WEBPACK_IMPORTED_MODULE_3__.default.PRINTER_SKIP_CURRENT, null, function (res) {
                if (res && !res.error) {
                    resolve(res.success);
                }
                else {
                    reject(res.error);
                }
            });
        });
    };
    // V1版本不支持
    MTOBPrinterV1.prototype.getHistoryUnfinishedPrintTasks = function () {
        return Promise.resolve([]);
    };
    MTOBPrinterV1.prototype.onTaskStatusChangeNotify = function (args) {
        var status = args.status, taskId = args.taskId;
        if (status === MTOB_PRINT_EVENT.TASK_ADDED) {
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_5__.EPrintTaskStatusEvent.START, args);
        }
        if (status === MTOB_PRINT_EVENT.TASK_COMPLETE) {
            this.emitter.emit("" + taskId, true);
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_5__.EPrintTaskStatusEvent.PROCESSING, args);
        }
        if (status === MTOB_PRINT_EVENT.TASK_ERROR) {
            this.emitter.emit("" + taskId, false);
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_5__.EPrintTaskStatusEvent.BREAKOFF, args);
        }
        if (status === MTOB_PRINT_EVENT.TASK_ALL_COMPLETE ||
            status === MTOB_PRINT_EVENT.TASK_CANCELED) {
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_5__.EPrintTaskStatusEvent.FINISH, args);
        }
    };
    return MTOBPrinterV1;
}(_utils_EventEmitter__WEBPACK_IMPORTED_MODULE_0__.default));

//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 12 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var ETemplateEnv;
(function (ETemplateEnv) {
    ETemplateEnv["PROD"] = "prod";
    ETemplateEnv["STAGING"] = "staging";
    ETemplateEnv["TEST"] = "test";
})(ETemplateEnv || (ETemplateEnv = {}));
var urlPrefix = 'https://s3plus.meituan.net/klfe-print/print';
var TemplateManager = /** @class */ (function () {
    function TemplateManager() {
        this.env = ETemplateEnv.PROD;
        this.templatesMap = new Map();
    }
    TemplateManager.prototype.setEnvAndProjectId = function (env, projectId) {
        this.projectId = projectId;
        switch (env) {
            case 'development':
            case 'test':
                this.env = ETemplateEnv.TEST;
                break;
            case 'staging':
                this.env = ETemplateEnv.STAGING;
                break;
            case 'production':
                this.env = ETemplateEnv.PROD;
        }
    };
    TemplateManager.prototype.getTemplateURL = function (templateId) {
        return urlPrefix + "/" + this.env + "/" + this.projectId + "/" + templateId;
    };
    // 只有V1使用
    TemplateManager.prototype.getTemplates = function (ids) {
        var _this = this;
        ids = ids instanceof Array ? ids : [ids];
        var promises = ids.map(function (templateId) {
            var cache = _this.templatesMap.get(templateId);
            return cache ? Promise.resolve(cache) : _this.fetch(templateId);
        });
        return Promise.all(promises);
    };
    TemplateManager.prototype.fetch = function (templateId) {
        var _this = this;
        return fetch(this.getTemplateURL(templateId))
            .then(function (response) { return response.json(); })
            .then(function (template) {
            _this.templatesMap.set(templateId, template);
            return template;
        });
    };
    return TemplateManager;
}());
/* harmony default export */ __webpack_exports__["default"] = (TemplateManager);
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 13 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
    PRINTER_GETLIST: 'printer/getPrinterList',
    PRINTER_PRINT: 'printer/print',
    PRINTER_RESUME_PRINTING: 'printer/resumePrinting',
    PRINTER_ABORT_PRINTING: 'printer/abortPrinting',
    PRINTER_QUEUE_STATUS_UPDATE: 'printer/queueStatusUpdate',
    PRINTER_SKIP_CURRENT: 'printer/skipCurrent',
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBpLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvcmUvcHJpbnRlci92MS9hcGkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsZUFBZTtJQUNiLGVBQWUsRUFBRSx3QkFBd0I7SUFDekMsYUFBYSxFQUFFLGVBQWU7SUFDOUIsdUJBQXVCLEVBQUUsd0JBQXdCO0lBQ2pELHNCQUFzQixFQUFFLHVCQUF1QjtJQUMvQywyQkFBMkIsRUFBRSwyQkFBMkI7SUFDeEQsb0JBQW9CLEVBQUUscUJBQXFCO0NBQzVDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gIFBSSU5URVJfR0VUTElTVDogJ3ByaW50ZXIvZ2V0UHJpbnRlckxpc3QnLFxuICBQUklOVEVSX1BSSU5UOiAncHJpbnRlci9wcmludCcsXG4gIFBSSU5URVJfUkVTVU1FX1BSSU5USU5HOiAncHJpbnRlci9yZXN1bWVQcmludGluZycsXG4gIFBSSU5URVJfQUJPUlRfUFJJTlRJTkc6ICdwcmludGVyL2Fib3J0UHJpbnRpbmcnLFxuICBQUklOVEVSX1FVRVVFX1NUQVRVU19VUERBVEU6ICdwcmludGVyL3F1ZXVlU3RhdHVzVXBkYXRlJyxcbiAgUFJJTlRFUl9TS0lQX0NVUlJFTlQ6ICdwcmludGVyL3NraXBDdXJyZW50Jyxcbn07XG4iXX0=

/***/ }),
/* 14 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EPrintMode": function() { return /* binding */ EPrintMode; },
/* harmony export */   "EPaperOrientation": function() { return /* binding */ EPaperOrientation; }
/* harmony export */ });
var EPrintMode;
(function (EPrintMode) {
    EPrintMode["DRIVER"] = "electron";
    EPrintMode["COMMAND"] = "tsc";
})(EPrintMode || (EPrintMode = {}));
var EPaperOrientation;
(function (EPaperOrientation) {
    EPaperOrientation["Landscape"] = "landscape";
    EPaperOrientation["Portrait"] = "portrait";
})(EPaperOrientation || (EPaperOrientation = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29yZS9wcmludGVyL3YxL3R5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLFVBR1g7QUFIRCxXQUFZLFVBQVU7SUFDcEIsaUNBQW1CLENBQUE7SUFDbkIsNkJBQWUsQ0FBQTtBQUNqQixDQUFDLEVBSFcsVUFBVSxLQUFWLFVBQVUsUUFHckI7QUFFRCxNQUFNLENBQU4sSUFBWSxpQkFHWDtBQUhELFdBQVksaUJBQWlCO0lBQzNCLDRDQUF1QixDQUFBO0lBQ3ZCLDBDQUFxQixDQUFBO0FBQ3ZCLENBQUMsRUFIVyxpQkFBaUIsS0FBakIsaUJBQWlCLFFBRzVCIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gRVByaW50TW9kZSB7XG4gIERSSVZFUiA9ICdlbGVjdHJvbicsXG4gIENPTU1BTkQgPSAndHNjJyxcbn1cblxuZXhwb3J0IGVudW0gRVBhcGVyT3JpZW50YXRpb24ge1xuICBMYW5kc2NhcGUgPSAnbGFuZHNjYXBlJyxcbiAgUG9ydHJhaXQgPSAncG9ydHJhaXQnLFxufVxuXG5leHBvcnQgaW50ZXJmYWNlIElQcmludGVyIHtcbiAgbmFtZTogc3RyaW5nO1xuICBzeXN0ZW1fZHJpdmVyaW5mbzogc3RyaW5nO1xuICAncHJpbnRlci1tYWtlLWFuZC1tb2RlbCc/OiBzdHJpbmc7XG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgUHJpbnRDb25maWcge1xuICBwcmludGVyTmFtZTogc3RyaW5nO1xuICBtb2RlPzogRVByaW50TW9kZTtcbiAgdGVtcGxhdGVJZD86IHN0cmluZyB8IHN0cmluZ1tdO1xuICB0ZW1wbGF0ZT86IGFueTtcbiAgb3JpZW50YXRpb24/OiBFUGFwZXJPcmllbnRhdGlvbjtcbiAgdGltZW91dD86IG51bWJlcjtcbiAgcGFwZXJTaXplPzoge1xuICAgIHdpZHRoOiBudW1iZXI7XG4gICAgaGVpZ2h0OiBudW1iZXI7XG4gIH07XG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgUHJpbnRlckxpc3RSZXN1bHQge1xuICByZXN1bHQ6IHtcbiAgICBwcmludGVyTGlzdDogSVByaW50ZXJbXSB8IG51bGw7XG4gIH0gfCBudWxsO1xuICBlcnJvcjogc3RyaW5nIHwgbnVsbDtcbiAgc3RhdHVzQ29kZTogbnVtYmVyO1xufVxuXG5leHBvcnQgaW50ZXJmYWNlIFByaW50ZXJPcHNSZXN1bHQge1xuICBzdWNjZXNzOiBib29sZWFuO1xuICBlcnJvcjogc3RyaW5nIHwgbnVsbDtcbiAgc3RhdHVzQ29kZTogbnVtYmVyO1xufVxuXG5leHBvcnQgaW50ZXJmYWNlIElQcmludFByb2dyZXNzSW5mb0RldGFpbCB7XG4gIGxhYmVsQ291bnQ6IG51bWJlcjtcbiAgc3RhdHVzOiBzdHJpbmc7XG4gIHRhc2tJZDogbnVtYmVyO1xufVxuXG5leHBvcnQgaW50ZXJmYWNlIElQcmludFByb2dyZXNzSW5mbyB7XG4gIHN0YXR1czogc3RyaW5nO1xuICB0YXNrTGlzdEluZm86IElQcmludFByb2dyZXNzSW5mb0RldGFpbFtdO1xuICB0YXNrSWQ/OiBudW1iZXI7XG59XG4iXX0=

/***/ }),
/* 15 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PrintError": function() { return /* binding */ PrintError; },
/* harmony export */   "EPrintEvent": function() { return /* binding */ EPrintEvent; },
/* harmony export */   "EPrintTaskStatusEvent": function() { return /* binding */ EPrintTaskStatusEvent; },
/* harmony export */   "EPrinterStatus": function() { return /* binding */ EPrinterStatus; },
/* harmony export */   "EPrintTaskQueueStatus": function() { return /* binding */ EPrintTaskQueueStatus; },
/* harmony export */   "PrintOptionsStorageKey": function() { return /* binding */ PrintOptionsStorageKey; }
/* harmony export */ });
var PrintError = {
    PRINT_PARAMS_ERROR: { message: '打印请求参数错误' },
    TEMPLATE_EMPTY_ERROR: { message: '打印模板不能为空' },
    TEMPLATE_FETCH_ERROR: { message: '获取打印模板失败，请稍后重试' },
    PRINT_TIMEOUT_ERROR: { message: '打印超时，请重试' },
    PRINT_FAILED_ERROR: {
        message: '打印失败，请检查打印机状态，稍后重试',
    },
};
// 打印事件
var EPrintEvent;
(function (EPrintEvent) {
    EPrintEvent["PrintDowngradeWarning"] = "PrintDowngradeWarning";
})(EPrintEvent || (EPrintEvent = {}));
// 打印任务事件
var EPrintTaskStatusEvent;
(function (EPrintTaskStatusEvent) {
    EPrintTaskStatusEvent["START"] = "start";
    EPrintTaskStatusEvent["BREAKOFF"] = "breakoff";
    EPrintTaskStatusEvent["PROCESSING"] = "processing";
    EPrintTaskStatusEvent["FINISH"] = "finish";
})(EPrintTaskStatusEvent || (EPrintTaskStatusEvent = {}));
// 打印机状态
var EPrinterStatus;
(function (EPrinterStatus) {
    EPrinterStatus["NORMAL"] = "NORMAL";
    EPrinterStatus["ERROR"] = "ERROR";
    EPrinterStatus["OFFLINE"] = "OFFLINE";
    EPrinterStatus["SUSPENDED"] = "SUSPENDED";
})(EPrinterStatus || (EPrinterStatus = {}));
// 打印队列状态
var EPrintTaskQueueStatus;
(function (EPrintTaskQueueStatus) {
    EPrintTaskQueueStatus["FREE"] = "FREE";
    EPrintTaskQueueStatus["PRINTING"] = "PRINTING";
    EPrintTaskQueueStatus["SUSPENDED"] = "SUSPENDED";
})(EPrintTaskQueueStatus || (EPrintTaskQueueStatus = {}));
var PrintOptionsStorageKey = 'mtob_print_options';
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 16 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MTOBPrinterV2": function() { return /* binding */ MTOBPrinterV2; }
/* harmony export */ });
/* harmony import */ var _utils_EventEmitter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _core_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
/* harmony import */ var _utils_TemplateManager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};







var MTOBPrinterV2 = /** @class */ (function (_super) {
    __extends(MTOBPrinterV2, _super);
    function MTOBPrinterV2() {
        var _this = _super.call(this) || this;
        _this.counter = 0;
        _this.emitter = new _utils_EventEmitter__WEBPACK_IMPORTED_MODULE_0__.default();
        _this.progress = {};
        _this.projectId = '';
        _this.failCount = 0;
        _this.maxPrintFailCount = 5;
        _this.templateManager = new _utils_TemplateManager__WEBPACK_IMPORTED_MODULE_4__.default();
        return _this;
    }
    MTOBPrinterV2.prototype.init = function () {
        var _this = this;
        this.failCount = 0;
        // 监听打印结果通知
        _core_client__WEBPACK_IMPORTED_MODULE_1__.default.ipcOn(_api__WEBPACK_IMPORTED_MODULE_6__.default.NOTIFY_PRINT_RESULT, function (args) {
            return _this.onTaskResultNotify(args);
        });
        // 监听打印状态变更通知
        _core_client__WEBPACK_IMPORTED_MODULE_1__.default.ipcOn(_api__WEBPACK_IMPORTED_MODULE_6__.default.NOTIFY_TASK_STATUS_UPDATE, function (args) {
            return _this.onTaskStatusChangeNotify(args);
        });
    };
    MTOBPrinterV2.prototype.destroy = function () {
        // 监听打印结果通知
        _core_client__WEBPACK_IMPORTED_MODULE_1__.default.ipcOff(_api__WEBPACK_IMPORTED_MODULE_6__.default.NOTIFY_PRINT_RESULT);
        // 监听打印状态变更通知
        _core_client__WEBPACK_IMPORTED_MODULE_1__.default.ipcOff(_api__WEBPACK_IMPORTED_MODULE_6__.default.NOTIFY_TASK_STATUS_UPDATE);
    };
    MTOBPrinterV2.prototype.setOptions = function (options) {
        this.projectId = options.projectId;
        this.maxPrintFailCount =
            options.maxPrintFailCount != null ? options.maxPrintFailCount : 5;
        this.templateManager.setEnvAndProjectId(options.env, options.projectId);
    };
    MTOBPrinterV2.prototype.setDowngradeOptions = function (options, skipErrorReport) {
        if (skipErrorReport === void 0) { skipErrorReport = false; }
        if (options.maxPrintFailCount != null) {
            this.maxPrintFailCount = options.maxPrintFailCount;
        }
        var printOptions = {};
        try {
            printOptions = JSON.parse(localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_5__.PrintOptionsStorageKey) || '{}');
        }
        catch (_a) {
            printOptions = {};
        }
        var downgrade = options.downgrade, _b = options.duration, duration = _b === void 0 ? 12 * 60 * 60 * 1000 : _b, // 默认降级生效时间: 12小时
        _c = options.useIframe, // 默认降级生效时间: 12小时
        useIframe = _c === void 0 ? false : _c;
        if (!downgrade) {
            printOptions.downgrade = false;
            printOptions.downgradeStartTime = undefined;
            printOptions.downgradeDuration = undefined;
            printOptions.downgradeUseIframe = undefined;
        }
        else {
            // 已经降级的情况下，不更新降级开始时间
            if (printOptions.downgrade !== true) {
                printOptions.downgradeStartTime = Date.now();
            }
            printOptions.downgrade = true;
            printOptions.downgradeDuration = duration;
            printOptions.downgradeUseIframe = useIframe;
            this.failCount = 0;
            if (skipErrorReport !== true) {
                _utils_logger__WEBPACK_IMPORTED_MODULE_2__.default.logError('开启打印降级');
            }
        }
        localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_5__.PrintOptionsStorageKey, JSON.stringify(printOptions));
    };
    MTOBPrinterV2.prototype.getDowngradeOptions = function () {
        var printOptions = {};
        try {
            printOptions = JSON.parse(localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_5__.PrintOptionsStorageKey) || '{}');
        }
        catch (_a) {
            printOptions = {};
        }
        var downgrade = printOptions.downgrade, downgradeStartTime = printOptions.downgradeStartTime, downgradeDuration = printOptions.downgradeDuration, downgradeUseIframe = printOptions.downgradeUseIframe;
        if (downgrade &&
            downgradeStartTime != null &&
            downgradeDuration != null &&
            Date.now() - downgradeStartTime <= downgradeDuration) {
            return {
                downgrade: true,
                useIframe: downgradeUseIframe,
                maxPrintFailCount: this.maxPrintFailCount,
            };
        }
        this.setDowngradeOptions({ downgrade: false });
        return { downgrade: false, maxPrintFailCount: this.maxPrintFailCount };
    };
    /**
     * 获取所有已添加的打印机(包含驱动、免驱)
     * @param forceUpdate 是否强制刷新打印机列表
     */
    MTOBPrinterV2.prototype.getPrinterList = function (forceUpdate) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.GET_PRINTERS, {
                            forceUpdate: forceUpdate,
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, (data.printers || []).map(function (x) {
                                // 兼容旧版本驱动打印机返回status的场景
                                if (x.interfaceType === 'DRIVER') {
                                    x.status = x.driverPrinterSystemStatus;
                                }
                                return x;
                            })];
                }
            });
        });
    };
    /**
     * 获取所有识别到的USB打印机(包含已添加的、未添加的)
     * @param onlyStandard 是否只获取标准的USB打印机(不包含USB打印支持等)
     */
    MTOBPrinterV2.prototype.getUSBPrinterList = function (onlyStandard) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.GET_USB_PRINTERS, {
                            onlyStandard: onlyStandard,
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, (data.printers || [])];
                }
            });
        });
    };
    /**
     * 添加免驱打印机
     */
    MTOBPrinterV2.prototype.addPrinter = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.ADD_PRINTER, {
                            params: params,
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.id];
                }
            });
        });
    };
    /**
     * 删除免驱打印机
     */
    MTOBPrinterV2.prototype.deletePrinter = function (printer, force) {
        return _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.DELETE_PRINTER, {
            printer: printer,
            force: force,
        });
    };
    /**
     * 重启打印机任务处理
     */
    MTOBPrinterV2.prototype.restartPrinter = function (printerName, id) {
        return _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.RESTART_PRINTER, {
            printer: printerName,
            id: id,
        });
    };
    /**
     * 设置打印机配置
     */
    MTOBPrinterV2.prototype.setPrinterConfig = function (options, printerName, id) {
        return _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.SET_PRINTER_CONFIG, __assign({ printer: printerName, id: id }, options));
    };
    /**
     *获取打印机配置
     */
    MTOBPrinterV2.prototype.getPrinterConfig = function (printerName, id) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, name, options;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.GET_PRINTER_CONFIG, {
                            printerName: printerName,
                            id: id,
                        })];
                    case 1:
                        _a = (_b.sent()).printer, name = _a.name, options = __rest(_a, ["name"]);
                        return [2 /*return*/, options];
                }
            });
        });
    };
    /**
     * 获取打印机状态
     */
    MTOBPrinterV2.prototype.getPrinterStatus = function (printerName, id) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.GET_PRINTER_STATUS, {
                            printer: printerName,
                            id: id,
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.printerStatus];
                }
            });
        });
    };
    /**
     * 获取打印队列状态
     */
    MTOBPrinterV2.prototype.getPrintTaskQueueStatus = function (printerName, id) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.GET_PRINT_TASK_QUEUE_STATUS, {
                            printer: printerName,
                            id: id,
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.status];
                }
            });
        });
    };
    /**
     * 批量获取打印任务状态
     */
    MTOBPrinterV2.prototype.getPrintTaskStatus = function (taskIDs) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.GET_TASK_STATUS, {
                            taskID: taskIDs,
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * 用于兼容旧的传参方式，将数据转换为新版本的标准格式
     */
    MTOBPrinterV2.prototype.print = function (datalist, options) {
        return __awaiter(this, void 0, void 0, function () {
            var templateURL, templateId, template, stylesURL, useHTML, taskID, documents, task;
            var _this = this;
            return __generator(this, function (_a) {
                if (!datalist || !options) {
                    return [2 /*return*/, Promise.reject(_constants__WEBPACK_IMPORTED_MODULE_5__.PrintError.PRINT_PARAMS_ERROR)];
                }
                templateURL = options.templateURL, templateId = options.templateId, template = options.template, stylesURL = options.stylesURL, useHTML = options.useHTML;
                if (!templateURL && !templateId && !template) {
                    return [2 /*return*/, Promise.reject(_constants__WEBPACK_IMPORTED_MODULE_5__.PrintError.TEMPLATE_EMPTY_ERROR)];
                }
                if (!Array.isArray(datalist)) {
                    datalist = [datalist];
                }
                taskID = this.getTaskID();
                documents = datalist.map(function (data, index) { return ({
                    documentID: 'DOC' + (index + 1),
                    contents: !templateURL && Array.isArray(templateId)
                        ? [
                            {
                                data: data,
                                templateURL: _this.templateManager.getTemplateURL(templateId.find(function (x) { return x === data.selectTemplate; })),
                            },
                        ]
                        : [
                            {
                                data: data,
                                templateURL: templateURL ||
                                    (templateId
                                        ? _this.templateManager.getTemplateURL(templateId)
                                        : ''),
                                template: template,
                                stylesURL: useHTML && stylesURL
                                    ? _this.templateManager.getTemplateURL(stylesURL)
                                    : '',
                            },
                        ],
                }); });
                task = {
                    taskID: taskID,
                    projectId: this.projectId,
                    printer: options.printerName,
                    preview: !!options.preview,
                    previewType: options.previewType === 'image' ? 'image' : 'pdf',
                    documents: documents,
                    useHTML: options.useHTML || false,
                    useDriverTSC: options.useDriverTSC,
                    strictOrder: options.strictOrder,
                    timeout: options.timeout,
                    reportKeys: options.reportKeys,
                    reportExcludeKeys: options.reportExcludeKeys,
                    customTags: __assign({ appName: _core_client__WEBPACK_IMPORTED_MODULE_1__.default.options.appName, userId: _core_client__WEBPACK_IMPORTED_MODULE_1__.default.options.userId }, (options.customTags || {})),
                };
                return [2 /*return*/, this.requestPrint({
                        task: task,
                        id: options.id,
                        autoRestart: options.autoRestart,
                    })];
            });
        });
    };
    /**
     * 新版本标准格式的打印
     */
    MTOBPrinterV2.prototype.printStandard = function (params, options) {
        if (options === void 0) { options = {}; }
        var taskID = this.getTaskID();
        var task = __assign(__assign({ taskID: taskID, projectId: this.projectId }, params), { customTags: __assign({ appName: _core_client__WEBPACK_IMPORTED_MODULE_1__.default.options.appName, userId: _core_client__WEBPACK_IMPORTED_MODULE_1__.default.options.userId, extraAppInfo: _core_client__WEBPACK_IMPORTED_MODULE_1__.default.options.extraAppInfo }, (params.customTags || {})) });
        return this.requestPrint({
            task: task,
            id: options.id,
            autoRestart: options.autoRestart,
        });
    };
    MTOBPrinterV2.prototype.requestPrint = function (params) {
        var _this = this;
        var task = params.task;
        var taskID = task.taskID;
        // const { downgrade, useIframe } = this.getDowngradeOptions();
        // if (downgrade) {
        //   // 只有在没有连接成功的情况下停止连接（避免客户端可以正常连接的场景下也被断开连接，导致电子秤等设备也无法使用）
        //   if (MTOBClient.status !== EMTOBStatus.Connected) {
        //     MTOBClient.finish();
        //   }
        //   return useIframe ? WebPrint.iframePrint(task) : WebPrint.print(task);
        // }
        return new Promise(function (resolve, reject) {
            _this.emitter.once(taskID, function (success, response) {
                success
                    ? resolve({ taskID: taskID })
                    : reject(__assign(__assign({}, _constants__WEBPACK_IMPORTED_MODULE_5__.PrintError.PRINT_FAILED_ERROR), { taskID: taskID, msg: response.taskMsg || _constants__WEBPACK_IMPORTED_MODULE_5__.PrintError.PRINT_FAILED_ERROR.message, message: response.taskMsg || _constants__WEBPACK_IMPORTED_MODULE_5__.PrintError.PRINT_FAILED_ERROR.message, code: response.taskErrorCode }));
            });
            _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.PRINT, params)
                .then(function (res) {
                if (task.preview) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    var cmd = res.cmd, requestID = res.requestID, status_1 = res.status, code = res.code, data = __rest(res, ["cmd", "requestID", "status", "code"]);
                    resolve(data);
                }
            })
                .catch(function (res) {
                _this.emitter.removeAllListeners(taskID);
                reject({
                    taskID: taskID,
                    msg: res === null || res === void 0 ? void 0 : res.msg,
                    message: res === null || res === void 0 ? void 0 : res.msg,
                    code: res === null || res === void 0 ? void 0 : res.code,
                });
            });
        })
            .then(function (res) {
            _this.failCount = 0;
            return res;
        })
            .catch(function (error) {
            _this.checkPrintError(error);
            throw error;
        });
    };
    /**
     * 检查打印错误
     */
    MTOBPrinterV2.prototype.checkPrintError = function (error) {
        var version = _core_client__WEBPACK_IMPORTED_MODULE_1__.default.connectedVersion || _core_client__WEBPACK_IMPORTED_MODULE_1__.default.requestVersion;
        // 已连接的客户端版本或需要链接的客户端版本小于 3.0.0, 不支持打印降级
        if (version && +version[0] < 3) {
            return;
        }
        var codeStr = "" + error.code;
        this.failCount += Number((error.code === undefined &&
            _core_client__WEBPACK_IMPORTED_MODULE_1__.default.status !== _constants__WEBPACK_IMPORTED_MODULE_3__.EMTOBStatus.Connected) || // 客户端连接异常
            codeStr.startsWith('1') || // 任务添加异常
            codeStr.startsWith('3') || // 设备连接或数据发送异常
            codeStr.startsWith('6') || // 任务被取消、删除或超时
            codeStr === '2000' || // 驱动打印机系统状态异常（非脱机或暂停）
            codeStr === '2003' // 无法获取驱动打印机信息
        );
        if (this.failCount > this.maxPrintFailCount) {
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_5__.EPrintEvent.PrintDowngradeWarning);
        }
    };
    /**
     * 打开Windows系统【设备和打印机】
     */
    MTOBPrinterV2.prototype.openPrinterDeviceDialog = function () {
        return _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.OPEN_PRINTER_DEVICE_DIALOG);
    };
    /**
     * 打开驱动打印机【打印首选项】
     */
    MTOBPrinterV2.prototype.openPreferenceDialog = function (printerName) {
        return _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.OPEN_PRINTER_PREFERENCE_DIALOG, {
            printer: printerName,
        });
    };
    /**
     * 清空当前队列中的所有任务
     */
    MTOBPrinterV2.prototype.cancelTasks = function (force, printerName, id) {
        return _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.CLEAR_PRINT_TASKS, {
            printer: printerName,
            id: id,
            force: force,
        });
    };
    /**
     * 清空当前队列中的失败任务
     */
    MTOBPrinterV2.prototype.cancelFailedTasks = function (printerName, id) {
        return _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.CLEAR_FAILED_PRINT_TASKS, {
            printer: printerName,
            id: id,
        });
    };
    /**
     * 重试当前队列中失败的任务
     */
    MTOBPrinterV2.prototype.retryFailedTasks = function (autoRestart, printerName, id) {
        return _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.RETRY_PRINT_TASKS_FAILED, {
            printer: printerName,
            id: id,
            autoRestart: autoRestart,
        });
    };
    /**
     * 重试历史未完成任务
     */
    MTOBPrinterV2.prototype.retryHistoryUnfinishedPrintTasks = function (tasks, autoRestart, printerName, id) {
        return _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.RETRY_HISTORY_PRINT_TASKS, {
            printer: printerName,
            id: id,
            tasks: tasks,
            autoRestart: autoRestart,
        });
    };
    /**
     * 取消历史未完成任务
     */
    MTOBPrinterV2.prototype.cancelHistoryUnfinishedPrintTasks = function (tasks) {
        return _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.CANCEL_HISTORY_PRINT_TASKS, {
            tasks: tasks,
        });
    };
    /**
     * 获取历史未完成任务
     * @param id 打印机id
     * @param startTime 开始时间
     * @param needFailedNotRetried 需要获取失败未重试的任务
     */
    MTOBPrinterV2.prototype.getHistoryUnfinishedPrintTasks = function (id, startTime, needFailedNotRetried) {
        if (startTime === void 0) { startTime = null; }
        if (needFailedNotRetried === void 0) { needFailedNotRetried = true; }
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _core_client__WEBPACK_IMPORTED_MODULE_1__.default.reuqest(_api__WEBPACK_IMPORTED_MODULE_6__.default.GET_UNFINISHED_PRINT_TASKS, {
                            id: id,
                            startTime: startTime,
                            needFailedNotRetried: needFailedNotRetried,
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.unfinished];
                }
            });
        });
    };
    /**
     * 打印结果通知
     */
    MTOBPrinterV2.prototype.onTaskResultNotify = function (res) {
        if (!res || res.taskStatus === 'FAILED') {
            this.emitter.emit(res.taskID, false, res);
        }
        if (res.taskStatus === 'SUCCESS') {
            this.emitter.emit(res.taskID, true, res);
        }
    };
    /**
     * 打印队列状态变更通知
     */
    MTOBPrinterV2.prototype.onTaskStatusChangeNotify = function (data) {
        var printer = data.printer, id = data.id, queueStatus = data.queueStatus, taskList = data.taskList, breakoff = data.breakoff, currentFailedTasks = data.currentFailedTasks;
        var pending = (taskList || []).filter(function (x) { return !['CANCELED', 'SUCCESS', 'FAILED'].includes(x.status); });
        if (!pending.length) {
            delete this.progress[printer];
            this.emit(_constants__WEBPACK_IMPORTED_MODULE_5__.EPrintTaskStatusEvent.FINISH, {
                progress: this.progress,
                printer: printer,
                id: id,
                taskListInfo: pending.map(function (x) { return ({
                    labelCount: x.documents.length,
                    docCount: x.documents.length,
                }); }),
                failedTaskListInfo: currentFailedTasks || [],
            });
        }
        else {
            var event_1;
            if (!this.progress[printer]) {
                event_1 = _constants__WEBPACK_IMPORTED_MODULE_5__.EPrintTaskStatusEvent.START;
            }
            else {
                event_1 = _constants__WEBPACK_IMPORTED_MODULE_5__.EPrintTaskStatusEvent.PROCESSING;
            }
            this.progress[printer] = {
                id: id,
                status: queueStatus,
                tasks: pending.length,
                labels: pending.reduce(function (acc, cur) { return acc + cur.documents.length; }, 0),
            };
            var progressData = {
                progress: this.progress,
                printer: printer,
                id: id,
                taskListInfo: pending.map(function (x) { return ({
                    labelCount: x.documents.length,
                    docCount: x.documents.length,
                }); }),
                failedTaskListInfo: currentFailedTasks || [],
                breakoff: breakoff,
            };
            this.emit(event_1, progressData);
            if (breakoff) {
                this.emit(_constants__WEBPACK_IMPORTED_MODULE_5__.EPrintTaskStatusEvent.BREAKOFF, progressData);
            }
        }
    };
    /**
     * 生成任务ID
     * 格式：MTPYYYYMMDD{requestID}{serialNo}
     * @returns
     */
    MTOBPrinterV2.prototype.getTaskID = function () {
        var t = new Date();
        var year = t.getFullYear();
        var month = (t.getMonth() + 1).toString().padStart(2, '0');
        var date = t
            .getDate()
            .toString()
            .padStart(2, '0');
        var serialNo = (++this.counter).toString().padStart(4, '0');
        return "MTP" + year + month + date + _core_client__WEBPACK_IMPORTED_MODULE_1__.default.requestID + serialNo;
    };
    return MTOBPrinterV2;
}(_utils_EventEmitter__WEBPACK_IMPORTED_MODULE_0__.default));

//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 17 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
    GET_PRINTERS: 'getPrinters',
    GET_USB_PRINTERS: 'getUSBPrinters',
    GET_PRINTER_STATUS: 'getPrinterStatus',
    GET_PRINTER_CONFIG: 'getPrinterConfig',
    GET_TASK_STATUS: 'getTaskStatus',
    GET_PRINT_TASK_QUEUE_STATUS: 'getPrintTaskQueueStatus',
    ADD_PRINTER: 'addPrinter',
    DELETE_PRINTER: 'deletePrinter',
    RESTART_PRINTER: 'restartPrinter',
    SET_PRINTER_CONFIG: 'setPrinterConfig',
    OPEN_PRINTER_DEVICE_DIALOG: 'openPrinterDeviceDialog',
    OPEN_PRINTER_PREFERENCE_DIALOG: 'openPrinterPreferenceDialog',
    PRINT: 'print',
    CLEAR_PRINT_TASKS: 'clearPrintTasks',
    CLEAR_FAILED_PRINT_TASKS: 'clearFailedPrintTasks',
    RETRY_PRINT_TASKS_FAILED: 'retryPrintTasksFailed',
    RETRY_HISTORY_PRINT_TASKS: 'retryHistoryPrintTasks',
    CANCEL_HISTORY_PRINT_TASKS: 'cancelHistoryPrintTasks',
    GET_UNFINISHED_PRINT_TASKS: 'getUnfinishedPrintTasks',
    NOTIFY_PRINT_RESULT: 'notifyPrintResult',
    NOTIFY_TASK_STATUS_UPDATE: 'notifyTaskStatusUpdate',
});
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 18 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MTOBSerialport": function() { return /* reexport safe */ _serialport__WEBPACK_IMPORTED_MODULE_0__.default; }
/* harmony export */ });
/* harmony import */ var _serialport__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19);


//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29yZS9pbnRlcmZhY2UvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxjQUFjLE1BQU0sY0FBYyxDQUFDO0FBRTFDLE9BQU8sRUFBRSxjQUFjLEVBQUUsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBNVE9CU2VyaWFscG9ydCBmcm9tICcuL3NlcmlhbHBvcnQnO1xuXG5leHBvcnQgeyBNVE9CU2VyaWFscG9ydCB9O1xuIl19

/***/ }),
/* 19 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _NewserialPort__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20);
/* harmony import */ var _OldserialPort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22);



var MTOBSerialport = /** @class */ (function () {
    // 构造方法
    function MTOBSerialport(portPath, baudRate) {
        this.portPath = portPath;
        this.baudRate = baudRate;
        this.Serialport =
            _client__WEBPACK_IMPORTED_MODULE_0__.default.clientType === 'V2'
                ? new _NewserialPort__WEBPACK_IMPORTED_MODULE_1__.default(this.portPath, this.baudRate)
                : new _OldserialPort__WEBPACK_IMPORTED_MODULE_2__.default(this.portPath, this.baudRate);
    }
    // 获取串口列表
    MTOBSerialport.getSerialPortList = function () {
        return _client__WEBPACK_IMPORTED_MODULE_0__.default.clientType === 'V2'
            ? _NewserialPort__WEBPACK_IMPORTED_MODULE_1__.default.getSerialPortList()
            : _OldserialPort__WEBPACK_IMPORTED_MODULE_2__.default.getSerialPortList();
    };
    // 打开串口
    MTOBSerialport.prototype.open = function (callback) {
        this.Serialport.open(callback);
    };
    // 关闭串口
    MTOBSerialport.prototype.close = function (callback) {
        this.Serialport.close(callback);
    };
    // 写串口
    MTOBSerialport.prototype.write = function (data, callback) {
        this.Serialport.write(data, callback);
    };
    // 监听事件
    MTOBSerialport.prototype.on = function (event, callback) {
        this.Serialport.on(event, callback);
    };
    //解除监听
    MTOBSerialport.prototype.off = function (event) {
        this.Serialport.off(event);
    };
    return MTOBSerialport;
}());
/* harmony default export */ __webpack_exports__["default"] = (MTOBSerialport);
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 20 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _Constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);


var SERIALPORT_MSG = 'serialport-msg';
var NewMTOBSerialport = /** @class */ (function () {
    // 构造方法
    function NewMTOBSerialport(path, baudRate) {
        var _this = this;
        this.eventHandlers = {};
        this.path = path;
        this.baudRate = baudRate;
        _client__WEBPACK_IMPORTED_MODULE_0__.default.ipcOn(SERIALPORT_MSG, function (msg) { return _this.fireEvent(msg); });
    }
    NewMTOBSerialport.prototype.fireEvent = function (msg) {
        if (this.eventHandlers[msg.event]) {
            this.eventHandlers[msg.event].forEach(function (callback) {
                callback && callback(msg.data);
            });
        }
    };
    // 获取串口列表
    NewMTOBSerialport.getSerialPortList = function () {
        return new Promise(function (resolve, reject) {
            _client__WEBPACK_IMPORTED_MODULE_0__.default.reuqest(_Constants__WEBPACK_IMPORTED_MODULE_1__.API.NEW_SERIALPORT_GETLIST, { type: 'serialport' })
                .then(function (res) {
                if ((res || {}).status === 'success' && res.list) {
                    resolve(res.list);
                }
                else {
                    reject(res.msg);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    // 打开串口
    NewMTOBSerialport.prototype.open = function (callback) {
        _client__WEBPACK_IMPORTED_MODULE_0__.default.reuqest(_Constants__WEBPACK_IMPORTED_MODULE_1__.API.NEW_SERIALPORT_OPEN, {
            type: 'serialport',
            path: this.path,
            baudRate: this.baudRate,
        }).then(function (res) {
            callback && callback(res);
        });
    };
    // 关闭串口
    NewMTOBSerialport.prototype.close = function (callback) {
        _client__WEBPACK_IMPORTED_MODULE_0__.default.ipcOff(SERIALPORT_MSG);
        _client__WEBPACK_IMPORTED_MODULE_0__.default.reuqest(_Constants__WEBPACK_IMPORTED_MODULE_1__.API.NEW_SERIALPORT_CLOSE, {
            type: 'serialport',
            path: this.path,
        }).then(function (res) {
            callback && callback(res);
        });
    };
    // 写串口
    NewMTOBSerialport.prototype.write = function (data, callback) {
        _client__WEBPACK_IMPORTED_MODULE_0__.default.reuqest(_Constants__WEBPACK_IMPORTED_MODULE_1__.API.NEW_SERIALPORT_WRITE, {
            type: 'serialport',
            path: this.path,
            data: data,
        }).then(function (res) {
            callback && callback(res);
        });
    };
    // 监听事件
    NewMTOBSerialport.prototype.on = function (event, callback) {
        if (!this.eventHandlers[event]) {
            this.eventHandlers[event] = [];
        }
        this.eventHandlers[event].push(callback);
    };
    //解除监听
    NewMTOBSerialport.prototype.off = function (event) {
        if (this.eventHandlers[event]) {
            this.eventHandlers[event] = [];
        }
    };
    return NewMTOBSerialport;
}());
/* harmony default export */ __webpack_exports__["default"] = (NewMTOBSerialport);
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 21 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "API": function() { return /* binding */ API; }
/* harmony export */ });
var API = {
    // 旧版串口相关接口
    SERIALPORT_OPEN: 'serialport/open',
    SERIALPORT_CLOSE: 'serialport/close',
    SERIALPORT_WRITE: 'serialport/write',
    SERIALPORT_GETLIST: 'serialport/getSerialPortList',
    SERIALPORT_ON: 'serialport/on',
    //新版串口相关接口
    NEW_SERIALPORT_OPEN: 'open',
    NEW_SERIALPORT_CLOSE: 'close',
    NEW_SERIALPORT_WRITE: 'write',
    NEW_SERIALPORT_GETLIST: 'getDeviceList',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvcmUvaW50ZXJmYWNlL3NlcmlhbHBvcnQvQ29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxJQUFNLEdBQUcsR0FBRztJQUNqQixXQUFXO0lBQ1gsZUFBZSxFQUFFLGlCQUFpQjtJQUNsQyxnQkFBZ0IsRUFBRSxrQkFBa0I7SUFDcEMsZ0JBQWdCLEVBQUUsa0JBQWtCO0lBQ3BDLGtCQUFrQixFQUFFLDhCQUE4QjtJQUNsRCxhQUFhLEVBQUUsZUFBZTtJQUU5QixVQUFVO0lBQ1YsbUJBQW1CLEVBQUUsTUFBTTtJQUMzQixvQkFBb0IsRUFBRSxPQUFPO0lBQzdCLG9CQUFvQixFQUFFLE9BQU87SUFDN0Isc0JBQXNCLEVBQUUsZUFBZTtDQUN4QyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IEFQSSA9IHtcbiAgLy8g5pen54mI5Liy5Y+j55u45YWz5o6l5Y+jXG4gIFNFUklBTFBPUlRfT1BFTjogJ3NlcmlhbHBvcnQvb3BlbicsXG4gIFNFUklBTFBPUlRfQ0xPU0U6ICdzZXJpYWxwb3J0L2Nsb3NlJyxcbiAgU0VSSUFMUE9SVF9XUklURTogJ3NlcmlhbHBvcnQvd3JpdGUnLFxuICBTRVJJQUxQT1JUX0dFVExJU1Q6ICdzZXJpYWxwb3J0L2dldFNlcmlhbFBvcnRMaXN0JyxcbiAgU0VSSUFMUE9SVF9PTjogJ3NlcmlhbHBvcnQvb24nLFxuXG4gIC8v5paw54mI5Liy5Y+j55u45YWz5o6l5Y+jXG4gIE5FV19TRVJJQUxQT1JUX09QRU46ICdvcGVuJyxcbiAgTkVXX1NFUklBTFBPUlRfQ0xPU0U6ICdjbG9zZScsXG4gIE5FV19TRVJJQUxQT1JUX1dSSVRFOiAnd3JpdGUnLFxuICBORVdfU0VSSUFMUE9SVF9HRVRMSVNUOiAnZ2V0RGV2aWNlTGlzdCcsXG59O1xuIl19

/***/ }),
/* 22 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _Constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);


var SERIALPORT_MSG = 'serialport-msg';
var OldMTOBSerialport = /** @class */ (function () {
    // 构造方法
    function OldMTOBSerialport(portName, baudRate) {
        var _this = this;
        this.eventHandlers = {};
        this.portName = portName;
        this.baudRate = baudRate;
        _client__WEBPACK_IMPORTED_MODULE_0__.default.ipcOn(SERIALPORT_MSG, function (msg) { return _this.fireEvent(msg); });
    }
    OldMTOBSerialport.prototype.fireEvent = function (msg) {
        if (this.eventHandlers[msg.event]) {
            this.eventHandlers[msg.event].forEach(function (callback) {
                callback(msg.data);
            });
        }
    };
    // 获取串口列表
    OldMTOBSerialport.getSerialPortList = function () {
        return new Promise(function (resolve, reject) {
            _client__WEBPACK_IMPORTED_MODULE_0__.default.ipc(_Constants__WEBPACK_IMPORTED_MODULE_1__.API.SERIALPORT_GETLIST, null, function (res) {
                if (res && res.result && res.result.list && !res.error) {
                    resolve(res.result.list);
                }
                else {
                    reject(res.error);
                }
            });
        });
    };
    // 打开串口
    OldMTOBSerialport.prototype.open = function () {
        _client__WEBPACK_IMPORTED_MODULE_0__.default.ipc(_Constants__WEBPACK_IMPORTED_MODULE_1__.API.SERIALPORT_OPEN, {
            portName: this.portName,
            baudRate: this.baudRate,
        });
    };
    // 关闭串口
    OldMTOBSerialport.prototype.close = function () {
        _client__WEBPACK_IMPORTED_MODULE_0__.default.ipcOff(SERIALPORT_MSG);
        _client__WEBPACK_IMPORTED_MODULE_0__.default.ipc(_Constants__WEBPACK_IMPORTED_MODULE_1__.API.SERIALPORT_CLOSE, {
            portName: this.portName,
        });
    };
    // 写串口
    OldMTOBSerialport.prototype.write = function (data, callback) {
        _client__WEBPACK_IMPORTED_MODULE_0__.default.ipc(_Constants__WEBPACK_IMPORTED_MODULE_1__.API.SERIALPORT_WRITE, {
            portName: this.portName,
            data: data,
        }, callback);
    };
    // 监听事件
    OldMTOBSerialport.prototype.on = function (event, callback) {
        if (!this.eventHandlers[event]) {
            this.eventHandlers[event] = [];
        }
        this.eventHandlers[event].push(callback);
    };
    //解除监听
    OldMTOBSerialport.prototype.off = function (event) {
        if (this.eventHandlers[event]) {
            this.eventHandlers[event] = [];
        }
    };
    return OldMTOBSerialport;
}());
/* harmony default export */ __webpack_exports__["default"] = (OldMTOBSerialport);
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 23 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB0eXBlIEVudlR5cGUgPSAnZGV2ZWxvcG1lbnQnIHwgJ3Rlc3QnIHwgJ3N0YWdpbmcnIHwgJ3Byb2R1Y3Rpb24nO1xuXG5leHBvcnQgaW50ZXJmYWNlIElNVE9CU0RLT3B0aW9ucyB7XG4gIGFwcE5hbWU6IHN0cmluZztcbiAgdXNlcklkPzogbnVtYmVyIHwgc3RyaW5nO1xuICBlbnY6IEVudlR5cGU7XG4gIHByb2plY3RJZDogc3RyaW5nO1xuICBwb3J0TnVtPzogbnVtYmVyO1xuICBhdXRvTGF1bmNoPzogYm9vbGVhbjtcbiAgZGVmYXVsdERvd25sb2FkQWxlcnQ/OiBib29sZWFuO1xuICBkZWZhdWx0VXBkYXRlQWxlcnQ/OiBib29sZWFuO1xuICBleHRyYUFwcEluZm86IHsgW2s6IHN0cmluZ106IGFueSB9O1xuXG4gIG1heFByaW50RmFpbENvdW50PzogbnVtYmVyO1xuICBza2lwRm9yY2VkVXBncmFkZT86IGJvb2xlYW47XG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgSU1UT0JHbG9iYWxDb25maWcge1xuICBwZW5kaW5nVGFza0xpbWl0OiBudW1iZXI7XG4gIHByaW50SGlzdG9yeVNhdmVIb3VyczogbnVtYmVyO1xuICBub3RpZnlPblRhc2tGYWlsdXJlOiBib29sZWFuO1xufVxuIl19

/***/ }),
/* 24 */
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

//# sourceMappingURL=data:application/json;base64,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

/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MTOBClient": function() { return /* reexport safe */ _core_client__WEBPACK_IMPORTED_MODULE_1__.default; },
/* harmony export */   "MTOBPrinter": function() { return /* reexport safe */ _core_printer__WEBPACK_IMPORTED_MODULE_2__.default; },
/* harmony export */   "EventEmitter": function() { return /* reexport safe */ _utils_EventEmitter__WEBPACK_IMPORTED_MODULE_0__.default; },
/* harmony export */   "MTOBSerialport": function() { return /* reexport safe */ _core_interface__WEBPACK_IMPORTED_MODULE_3__.MTOBSerialport; },
/* harmony export */   "ESDKEvents": function() { return /* reexport safe */ _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents; },
/* harmony export */   "ESDKStatus": function() { return /* reexport safe */ _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus; },
/* harmony export */   "EPrintMode": function() { return /* reexport safe */ _core_printer_v1_types__WEBPACK_IMPORTED_MODULE_5__.EPrintMode; },
/* harmony export */   "EPrintTaskStatusEvent": function() { return /* reexport safe */ _core_printer_constants__WEBPACK_IMPORTED_MODULE_6__.EPrintTaskStatusEvent; },
/* harmony export */   "EPrinterStatus": function() { return /* reexport safe */ _core_printer_constants__WEBPACK_IMPORTED_MODULE_6__.EPrinterStatus; },
/* harmony export */   "EPrintTaskQueueStatus": function() { return /* reexport safe */ _core_printer_constants__WEBPACK_IMPORTED_MODULE_6__.EPrintTaskQueueStatus; },
/* harmony export */   "EPrintEvent": function() { return /* reexport safe */ _core_printer_constants__WEBPACK_IMPORTED_MODULE_6__.EPrintEvent; }
/* harmony export */ });
/* harmony import */ var _utils_EventEmitter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _core_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var _core_printer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10);
/* harmony import */ var _core_interface__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _core_printer_v1_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14);
/* harmony import */ var _core_printer_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23);
/* harmony import */ var _core_printer_v2_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24);










/* harmony default export */ __webpack_exports__["default"] = ({
    MTOBClient: _core_client__WEBPACK_IMPORTED_MODULE_1__.default,
    MTOBPrinter: _core_printer__WEBPACK_IMPORTED_MODULE_2__.default,
    EventEmitter: _utils_EventEmitter__WEBPACK_IMPORTED_MODULE_0__.default,
    MTOBSerialport: _core_interface__WEBPACK_IMPORTED_MODULE_3__.MTOBSerialport,
    ESDKEvents: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKEvents,
    ESDKStatus: _constants__WEBPACK_IMPORTED_MODULE_4__.ESDKStatus,
    EPrintMode: _core_printer_v1_types__WEBPACK_IMPORTED_MODULE_5__.EPrintMode,
    EPrintTaskStatusEvent: _core_printer_constants__WEBPACK_IMPORTED_MODULE_6__.EPrintTaskStatusEvent,
    EPrinterStatus: _core_printer_constants__WEBPACK_IMPORTED_MODULE_6__.EPrinterStatus,
    EPrintTaskQueueStatus: _core_printer_constants__WEBPACK_IMPORTED_MODULE_6__.EPrintTaskQueueStatus,
    EPrintEvent: _core_printer_constants__WEBPACK_IMPORTED_MODULE_6__.EPrintEvent,
});
//# sourceMappingURL=data:application/json;base64,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
}();
__webpack_exports__ = __webpack_exports__.default;
/******/ 	return __webpack_exports__;
/******/ })()
;
});